/**
 * Shopify Customizer Plugin — Storefront Script
 */

(function () {
  'use strict';

  /* ---------------------------------------------------------------------
   * Fehlermelder
   *
   * Warum: Clarity sagt uns, DASS im Shop JavaScript kracht, aber bei einem
   * grossen Teil nur "script error" — die nichtssagende Meldung, die ein
   * Browser fuer Fehler aus fremdem Ursprung ohne CORS-Freigabe ausgibt. Was
   * wirklich passiert, sehen wir nur mit einem eigenen Melder auf dem echten
   * Geraet.
   *
   * Gemessen am 02.09.2026: 94 % der Clarity-Fehler stammen aus Metas eigenem
   * In-App-Code und gehen uns nichts an. Einsortiert wird deshalb im Backend,
   * nicht hier — hier wird nur gemeldet, damit die Logik an einer Stelle liegt.
   *
   * Drei Regeln, damit der Melder dem Shop nie schadet:
   *   - Er darf niemals selbst werfen (alles in try/catch).
   *   - Er meldet hoechstens ein paar Fehler je Seitenaufruf, sonst kann eine
   *     Schleife im Fremdcode das Backend fluten.
   *   - Er blockiert nichts: keepalive-fetch, Ergebnis interessiert nicht.
   * ------------------------------------------------------------------- */
  const Melder = (function () {
    let gesendet = 0;
    const MAX = 5;
    const gesehen = new Set();

    function backendUrl() {
      try {
        const w = document.querySelector('[data-api-url]');
        const u = w && w.dataset.apiUrl;
        // Ohne konfiguriertes Backend gibt es niemanden, dem wir melden
        // koennten. Der lokale Vorgabewert taugt dafuer nicht.
        if (!u || /127\.0\.0\.1|localhost/.test(u)) return null;
        return u.replace(/\/$/, '');
      } catch (e) { return null; }
    }

    function melde(satz) {
      try {
        if (gesendet >= MAX) return;
        // Derselbe Fehler feuert oft im Dutzend — einmal reicht.
        const schluessel = `${satz.message}|${satz.quelle}|${satz.zeile}`;
        if (gesehen.has(schluessel)) return;
        gesehen.add(schluessel);

        const basis = backendUrl();
        if (!basis) return;
        gesendet++;

        fetch(basis + '/api/customizer/js-error', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(Object.assign({
            seite: location.href.slice(0, 400),
            ua: navigator.userAgent.slice(0, 400),
          }, satz)),
          keepalive: true,
          mode: 'cors',
        }).catch(function () { /* Melden darf nie stoeren */ });
      } catch (e) { /* ebenfalls */ }
    }

    window.addEventListener('error', function (e) {
      melde({
        art: 'error',
        // Bei fremdem Ursprung ohne CORS liefert der Browser nur "Script
        // error." und keine Zeile. Das ist selbst ein Befund: dann steckt der
        // Fehler in einem Fremdskript, nicht in unserem.
        message: String((e && e.message) || 'unbekannt').slice(0, 400),
        quelle: String((e && e.filename) || '').slice(0, 300),
        zeile: (e && e.lineno) || null,
        spalte: (e && e.colno) || null,
        stack: String((e && e.error && e.error.stack) || '').slice(0, 1500),
      });
    }, true);

    window.addEventListener('unhandledrejection', function (e) {
      const g = e && e.reason;
      melde({
        art: 'rejection',
        message: String((g && g.message) || g || 'unbekannt').slice(0, 400),
        quelle: '',
        stack: String((g && g.stack) || '').slice(0, 1500),
      });
    });

    return { melde: melde };
  })();

  class Customizer {
    constructor(wrapper) {
      this.wrapper = wrapper;

      try {
        this.config = JSON.parse(wrapper.dataset.config || '{}');
        this.global = JSON.parse(wrapper.dataset.global || '{}');
      } catch (e) {
        console.error('[Customizer] Failed to parse data attributes:', e);
        return;
      }

      this.previewUrl   = wrapper.dataset.preview || '';
      this.variantTitle = wrapper.dataset.variantTitle || '';
      this.apiUrl       = (wrapper.dataset.apiUrl || 'http://127.0.0.1:8000').replace(/\/$/, '');
      this.displayMode  = wrapper.dataset.displayMode || 'inline';
      this.canvas       = wrapper.querySelector('#customizer-canvas') || document.getElementById('customizer-canvas');
      this.ctx          = this.canvas.getContext('2d');
      this.controlsEl   = wrapper.querySelector('#customizer-controls') || document.getElementById('customizer-controls');
      this.promptsEl    = wrapper.querySelector('#customizer-option-prompts') || document.getElementById('customizer-option-prompts');
      this.propertiesEl = wrapper.querySelector('#customizer-line-item-properties') || document.getElementById('customizer-line-item-properties');
      this.loadingEl    = wrapper.querySelector('#customizer-loading') || document.getElementById('customizer-loading');
      this.errorEl      = wrapper.querySelector('#customizer-error') || document.getElementById('customizer-error');
      this.wrapper      = wrapper;

      // Customization options defined in config
      this.options = this.config.customizationOptions || [];

      // Per-option choice: 'yes' | 'no' | string (giftbox selection)
      // Default: respect defaultYes setting if present, otherwise check price
      this.optionChoices = {};
      this.options.forEach(opt => {
        if (opt.type === 'giftbox') {
          this.optionChoices[opt.id] = '';
        } else {
          if (opt.defaultYes !== undefined) {
            this.optionChoices[opt.id] = opt.defaultYes ? 'yes' : 'no';
          } else {
            this.optionChoices[opt.id] = (opt.price > 0) ? 'no' : 'yes';
          }
        }
      });

      // Track which text rects are rendered in inline controls (to avoid duplicates in unlinked section)
      this._inlineRenderedRects = new Set();


      // Per-rectangle values: { [rectId]: { type, text?, font?, color?, imageUrl?, imageName? } }
      this.values = {};
      this._imageCache  = {};
      this._loadedFonts = new Set();
      // Artikel-Farbe (Ring um den Textbereich) je Bild-URL + Rechteck
      this._artikelFarbeCache = new Map();

      // AI stitch generation state
      this._stitchImages    = {}; // rectId → HTMLImageElement (AI result, BG removed)
      this._stitchTimers    = {}; // rectId → setTimeout handle
      this._stitchAborts    = {}; // rectId → AbortController
      this._stitchStatusEls = {}; // rectId → <span> status element
      this._mirrorGroups    = {}; // rectId → [rectIds] that share the SAME stitch
      this._mirrorCross     = {}; // rectId → [rects] same text, OTHER technique (own PNG)

      // Part A: personalization confirmation gating + captured preview
      this._confirmed  = false;   // customer clicked "Übernehmen"
      this._previewUrl = null;    // Shopify Files URL of the configured preview
      this._atcButton  = null;    // the theme's Add-to-Cart submit button

      // Font support map: loaded from font_character_map.json
      // This is auto-generated by the fontConverter thread from actual font data
      this.fontSupport = {};
      this._loadFontCharacterMap();
      // „Nur Laser"-Produkte prüfen gegen die Laser-TTFs statt der Stickschriften.
      this.laserFontSupport = {};
      if (this._isLaserOnlyProduct() || this._allLaserRects().length) this._loadLaserFontCharacterMap();

      this.init();
    }

    // ── Bootstrap ─────────────────────────────────────────────────────────────

    async init() {
      this._injectPreviewStyles();
      try {
        await this.loadFonts();
        await this.loadPreviewImage(this.previewUrl);
        this.initDefaultValues();
        this.buildOptionPrompts();
        this.buildControls();
        this.render();
        this._generateAllStitches();  // render default embroidery on load, before any input
        this.updateLineItemProperties();
        this._setupModalIfNeeded();
        this.hookIntoAddToCart();
        // Each of these is independent — a failure in one must NOT abort the others
        // (a throw in buildVariantSelector previously killed the magnifier + hint).
        this._safe('setupMagnifier', () => this._setupMagnifier());
        this._safe('setupMobilePreview', () => this._setupMobilePreview());
        this._safe('buildVariantSelector', () => this.buildVariantSelector());
        this._safe('rightScrollCue', () => this._setupRightScrollCue());
      } catch (e) {
        console.error('[Customizer] Init failed:', e);
      }
    }

    // Run a step in isolation so its failure can't cascade to later init steps.
    _safe(label, fn) {
      try { fn(); }
      catch (e) { console.error('[Customizer] step "' + label + '" failed:', e); }
    }

    // Positioniert ein geöffnetes Dropdown-Panel EINMALIG als position:fixed,
    // vollständig INNERHALB des Dialogs (nicht am Feld festgetackert), gedeckelt auf
    // die Dialoggröße mit eigenem Scroll — so wird es nie abgeschnitten. Bewusst OHNE
    // Reflow-Listener: die feste max-height verhindert, dass Tippen/Filtern die Größe
    // ändert (sonst „springt" das Panel weg).
    _floatPanel(anchor, panel) {
      if (!anchor || !panel) return;
      const dlg = document.getElementById('test-modal-dialog');
      const b = dlg ? dlg.getBoundingClientRect()
                    : { left: 0, top: 0, right: window.innerWidth, bottom: window.innerHeight,
                        width: window.innerWidth, height: window.innerHeight };
      const m = 10;
      panel.style.position = 'fixed';
      panel.style.transform = 'none';
      panel.style.right = 'auto';
      panel.style.margin = '0';
      // FESTE Breite → Layout ist deterministisch, unabhängig davon ob die Bilder
      // (Garnrollen/Font-Vorschauen) schon geladen sind. Sonst wird zu früh gemessen,
      // das Panel wächst nach dem Laden und ragt aus dem Dialog.
      const pw = Math.min(360, b.width - 2 * m);
      panel.style.width = pw + 'px';
      panel.style.maxWidth  = pw + 'px';
      panel.style.maxHeight = Math.round(b.height - 2 * m) + 'px';
      panel.style.overflowY = 'auto';
      const ph = Math.min(panel.offsetHeight, b.height - 2 * m);
      const a = anchor.getBoundingClientRect();
      let left = Math.min(a.left, b.right - m - pw);   // an Feld-Linkskante, in Dialog klemmen
      left = Math.max(left, b.left + m);
      let top;                                         // bevorzugt unter dem Feld …
      if (a.bottom + 4 + ph <= b.bottom - m) top = a.bottom + 4;
      else if (a.top - 4 - ph >= b.top + m)  top = a.top - 4 - ph;   // … sonst darüber …
      else top = b.bottom - m - ph;                    // … sonst am unteren Dialogrand
      top = Math.max(b.top + m, top);
      // Der Dialog hat ein CSS-transform (Zentrierung) → position:fixed-Kinder
      // beziehen sich auf den DIALOG, nicht aufs Viewport. Dann die Viewport-
      // Koordinaten um den Dialog-Ursprung versetzen (auf Mobile: transform none →
      // kein Versatz). Sonst „wandert" das Panel um b.left/b.top und wird abgeschnitten.
      const st = dlg ? getComputedStyle(dlg) : null;
      const shifted = st && st.transform && st.transform !== 'none';
      panel.style.left = Math.round(left - (shifted ? b.left : 0)) + 'px';
      panel.style.top  = Math.round(top  - (shifted ? b.top  : 0)) + 'px';
    }

    // Persistent "there's more below" cue for the ONE scroll context of the
    // dialog (.test-modal-body — no option block scrolls in itself), so the
    // customer immediately sees that it scrolls (and can click to scroll down).
    // Shows only while the body is actually scrollable and not at the bottom.
    // Desktop only — mobile has the collapsing preview as its scroll hint.
    _setupRightScrollCue() {
      if (window.matchMedia('(max-width: 900px)').matches) return;
      const dialog = document.getElementById('test-modal-dialog');
      const body   = document.querySelector('.test-modal-body');
      if (!dialog || !body || this._scrollCue) return;
      const cue = document.createElement('button');
      cue.type = 'button';
      cue.className = 'customizer-scroll-cue';
      cue.setAttribute('aria-label', 'Mehr anzeigen – nach unten scrollen');
      cue.innerHTML = 'Mehr ▼';
      // An den Dialog gehängt, NICHT an den Body: absolut positionierte Kinder
      // eines Scroll-Containers scrollen mit dem Inhalt weg.
      dialog.appendChild(cue);
      this._scrollCue = cue;
      let raf = 0;
      const update = () => {
        raf = 0;
        const scroller = /(auto|scroll)/.test(getComputedStyle(body).overflowY);
        const more = scroller && (body.scrollHeight - body.clientHeight - body.scrollTop > 8);
        cue.classList.toggle('is-visible', more);
      };
      const schedule = () => { if (!raf) raf = (window.requestAnimationFrame || window.setTimeout)(update, 0); };
      cue.addEventListener('click', () => body.scrollBy({ top: Math.round(body.clientHeight * 0.8), behavior: 'smooth' }));
      body.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      try { new MutationObserver(schedule).observe(body, { childList: true, subtree: true }); } catch (e) {}
      this._updateScrollCue = schedule;
      setTimeout(update, 300);
    }

    _setupMagnifier() {
      // Mobile bekommt Pinch-Zoom statt Lupe (siehe _setupMobilePreview)
      if (window.matchMedia('(max-width: 900px)').matches) return;
      const previewArea = this.wrapper.querySelector('.customizer-preview-area') || document.querySelector('.test-preview');
      if (!previewArea || !this.canvas) return;

      // Magnifier zoom is configurable per product (config.zoomFactor). Default 5
      // = twice as strong as the previous fixed 2.5.
      const ZOOM = Number(this.config && this.config.zoomFactor) || 5;
      const LENS_WIDTH_RATIO = 2 / 3;  // 2/3 of preview width
      const LENS_HEIGHT_RATIO = 1 / 2; // 1/2 of lens width

      // Slowly-blinking hint directly under the preview image (mouse devices only,
      // via CSS @media hover) inviting the customer to hover-to-zoom.
      if (!previewArea.parentNode.querySelector('.customizer-zoom-hint')) {
        const hint = document.createElement('div');
        hint.className = 'customizer-zoom-hint';
        hint.textContent = this._t('zoomHint');
        previewArea.insertAdjacentElement('afterend', hint);
      }

      // Create magnifier lens element
      const lens = document.createElement('div');
      lens.id = 'customizer-magnifier';
      lens.style.cssText = `
        position: absolute;
        border: 3px solid #999;
        background: white;
        overflow: hidden;
        display: none;
        z-index: 1000;
        box-shadow: 0 0 12px rgba(0,0,0,0.3);
        pointer-events: none;
      `;

      // Create magnified canvas inside lens
      const magCanvas = document.createElement('canvas');
      magCanvas.style.cssText = `
        position: absolute;
        display: block;
        background: white;
      `;
      lens.appendChild(magCanvas);
      previewArea.style.position = 'relative';
      previewArea.appendChild(lens);

      const magCtx = magCanvas.getContext('2d');
      let lensWidth, lensHeight;

      previewArea.addEventListener('mousemove', (e) => {
        const rect = previewArea.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        // Calculate lens dimensions based on preview size
        lensWidth = Math.round(rect.width * LENS_WIDTH_RATIO);
        lensHeight = Math.round(lensWidth * LENS_HEIGHT_RATIO);

        // Position lens centered on cursor (with boundary clamping for display only)
        let lensX = mouseX - lensWidth / 2;
        let lensY = mouseY - lensHeight / 2;

        const displayX = Math.max(0, Math.min(lensX, rect.width - lensWidth));
        const displayY = Math.max(0, Math.min(lensY, rect.height - lensHeight));

        lens.style.display = 'block';
        lens.style.left = displayX + 'px';
        lens.style.top = displayY + 'px';
        lens.style.width = lensWidth + 'px';
        lens.style.height = lensHeight + 'px';

        // Map the cursor to the exact backing-store pixel under it using the
        // canvas's ACTUAL rendered rectangle (getBoundingClientRect already
        // includes any CSS transform AND the flex-centering offset).
        // Separate X/Y scales are robust to any letterboxing.
        const cRect = this.canvas.getBoundingClientRect();
        const fx = (e.clientX - cRect.left) / cRect.width;
        const fy = (e.clientY - cRect.top)  / cRect.height;
        const cursorCanvasX = fx * this.canvas.width;
        const cursorCanvasY = fy * this.canvas.height;

        const sourceWidth  = (lensWidth  * (this.canvas.width  / cRect.width))  / ZOOM;
        const sourceHeight = (lensHeight * (this.canvas.height / cRect.height)) / ZOOM;

        // DPR-backed lens canvas → crisp magnification; CSS size stays the lens size.
        const dpr = window.devicePixelRatio || 1;
        magCanvas.width  = Math.round(lensWidth  * dpr);
        magCanvas.height = Math.round(lensHeight * dpr);
        magCanvas.style.width  = lensWidth + 'px';
        magCanvas.style.height = lensHeight + 'px';

        magCtx.drawImage(
          this.canvas,
          cursorCanvasX - sourceWidth / 2,
          cursorCanvasY - sourceHeight / 2,
          sourceWidth,
          sourceHeight,
          0,
          0,
          magCanvas.width,
          magCanvas.height
        );
      });

      previewArea.addEventListener('mouseleave', () => {
        lens.style.display = 'none';
      });
    }

    _setupModalIfNeeded() {
      if (this.displayMode !== 'modal') return;

      // Use TEST MODAL (which has working CSS)
      const backdrop = document.getElementById('test-modal-backdrop');
      const dialog = document.getElementById('test-modal-dialog');
      const modalBtn = document.getElementById('test-modal-btn');
      const closeBtn = dialog?.querySelector('.test-modal-close');

      console.log('[Customizer] Modal setup (using test modal):', {
        hasBackdrop: !!backdrop,
        hasDialog: !!dialog,
        hasModalBtn: !!modalBtn,
        hasCloseBtn: !!closeBtn
      });

      if (!backdrop || !dialog) {
        console.warn('[Customizer] Test modal elements not found');
        return;
      }

      portalModalToBody();

      // Open modal — this is the "Personalisieren" button.
      if (modalBtn) {
        modalBtn.textContent = this._t('personalizeBtn');
        const openModal = (e) => {
          e.preventDefault();
          backdrop.classList.add('is-open');
          dialog.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        };
        modalBtn.addEventListener('click', openModal);

        // Second "Personalisieren" button at the very top of the info column,
        // BEFORE the product title. On mobile the info column stacks directly
        // below the gallery, so this one is visible without scrolling (the
        // primary button sits below price/separator, i.e. below the fold).
        // Mobile-only via .customizer-modal-btn--top CSS.
        const info = document.querySelector('.product-info');
        if (info && !document.getElementById('customizer-modal-btn-top')) {
          const topBtn = modalBtn.cloneNode(true);
          topBtn.id = 'customizer-modal-btn-top';
          topBtn.classList.add('customizer-modal-btn--top');
          topBtn.addEventListener('click', openModal);
          info.insertBefore(topBtn, info.firstElementChild);
        }
      }

      // Close (✕) / "Abbrechen" just close the dialog. The customer's state lives
      // in this.values and persists in memory, so reopening restores it as-is.
      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this._closeModal();
        });
      }

      // Footer: total surcharge (left) + "Abbrechen" + "In den Warenkorb" (right).
      let footer = dialog.querySelector('.customizer-modal-footer');
      if (!footer) {
        footer = document.createElement('div');
        footer.className = 'customizer-modal-footer';

        // Total-surcharge summary moved here from the top of the controls.
        let summary = document.getElementById('customizer-price-summary');
        if (!summary) {
          summary = document.createElement('div');
          summary.id = 'customizer-price-summary';
          summary.className = 'customizer-price-summary';
        }
        footer.appendChild(summary);

        const actions = document.createElement('div');
        actions.className = 'customizer-modal-footer-actions';

        const cancel = document.createElement('button');
        cancel.type = 'button';
        cancel.className = 'customizer-cancel-btn';
        cancel.textContent = this._t('cancelBtn');
        cancel.addEventListener('click', () => this._closeModal());

        const addBtn = document.createElement('button');
        addBtn.type = 'button';
        addBtn.className = 'customizer-apply-btn';
        addBtn.textContent = this._t('addToCartBtn');
        // Referenz merken: die Rueckfrage muss den Button aus dem
        // „Wird hinzugefuegt…"-Zustand holen (siehe _withApplyButtonIdle).
        this._applyBtn = addBtn;
        addBtn.addEventListener('click', async () => {
          addBtn.disabled = true;
          const orig = addBtn.textContent;
          addBtn.textContent = this._t('addToCartBusy');
          try {
            await this._addToCartWithPersonalization();
          } finally {
            addBtn.disabled = false;
            addBtn.textContent = orig;
          }
        });

        actions.appendChild(cancel);
        actions.appendChild(addBtn);
        footer.appendChild(actions);
        dialog.appendChild(footer);
        this._updatePriceDisplay();
      }
    }

    _closeModal() {
      document.getElementById('test-modal-backdrop')?.classList.remove('is-open');
      document.getElementById('test-modal-dialog')?.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // Compose the canvas and upload it to Shopify Files → this._previewUrl.
    async _captureAndUploadPreview() {
      let dataUri = null;
      try {
        this.render();
        // Upload a modest JPEG, not the full supersampled PNG (multi-MB) — the
        // smaller file uploads and processes far faster. The on-screen loupe keeps
        // using the full-res canvas.
        dataUri = this._downscaledPreviewDataUri(1400);
      } catch (e) {
        console.warn('[Customizer] preview capture failed (tainted canvas?):', e);
      }
      if (!dataUri || !this.apiUrl) return;
      try {
        const res = await fetch(this.apiUrl + '/api/customizer/upload-image', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ dataUri, filename: `preview-${Date.now()}.jpg` }),
        });
        if (res.ok) this._previewUrl = (await res.json()).url || null;
        else console.warn('[Customizer] preview upload:', res.status);
      } catch (e) { console.warn('[Customizer] preview upload failed:', e); }
    }

    // Downscale the supersampled canvas to a JPEG for a small, fast upload.
    _downscaledPreviewDataUri(maxEdge) {
      const src  = this.canvas;
      const long = Math.max(src.width, src.height) || 1;
      const scale = Math.min(1, maxEdge / long);
      if (scale >= 1) return src.toDataURL('image/jpeg', 0.85);
      const t = document.createElement('canvas');
      t.width  = Math.round(src.width  * scale);
      t.height = Math.round(src.height * scale);
      const tctx = t.getContext('2d');
      tctx.fillStyle = '#ffffff';                 // JPEG has no alpha → flatten on white
      tctx.fillRect(0, 0, t.width, t.height);
      tctx.drawImage(src, 0, 0, t.width, t.height);
      return t.toDataURL('image/jpeg', 0.85);
    }

    // Bezahlte Optionen, die auf „Ja" stehen, deren Feld aber leer ist.
    //
    // WARUM: Die bezahlten Optionen stehen per `defaultYes` oft schon auf „Ja"
    // (so gewollt — Personalisierung ist der Normalfall). Wer dann nichts
    // eintippt und direkt in den Warenkorb geht, bezahlt den Aufpreis und
    // bekommt eine Zeile OHNE Text: in der Produktion unbrauchbar, und der
    // Kunde hat fuer nichts bezahlt. Real passiert beim Kapuzenhandtuch
    // (16.08.2026) — Warenkorb zeigte „Name: Ja, bitte!" + „Name – Preis",
    // aber weder Text noch Schrift noch Farbe.
    //
    // Nur AKTIVE Rects werden geprueft: ein Rect, dessen Option auf „Nein"
    // steht, ist ausgeblendet und darf den Kauf nicht blockieren.
    _missingPersonalizationFields() {
      const missing = [];
      const byId = new Map((this.activeRects() || []).map(r => [r.id, r]));
      this.options.forEach(opt => {
        if (!(opt.price > 0)) return;
        if (this.optionChoices[opt.id] !== 'yes') return;
        (opt.rectIds || []).forEach(rid => {
          const rect = byId.get(rid);
          if (!rect) return;
          const val = this.values[rid] || {};
          const filled = rect.type === 'text'
            ? !!String(val.text || '').trim()
            : !!val.imageName;
          if (!filled) missing.push({ rect, opt });
        });
      });
      return missing;
    }

    // Hinweis im Dialog-Footer + Sprung ins erste leere Feld.
    _showMissingFieldsHint(missing) {
      const footer = document.querySelector('.customizer-modal-footer');
      const names = missing.map(m => m.rect.label || m.opt.label).join(', ');
      const text = this._t('missingFields').replace('{fields}', names);
      if (footer) {
        let hint = footer.querySelector('.customizer-validation-hint');
        if (!hint) {
          hint = document.createElement('div');
          hint.className = 'customizer-validation-hint';
          hint.setAttribute('role', 'alert');
          footer.insertBefore(hint, footer.firstChild);
        }
        hint.textContent = text;
        hint.style.display = '';
      }

      const first = missing[0];
      const input = document.querySelector(
        '.customizer-text-input[data-rect-id="' + first.rect.id + '"]');
      if (input) {
        input.classList.add('is-invalid');
        try { input.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
        input.focus();
        // Markierung weg, sobald der Kunde tippt — sonst bleibt das Feld rot,
        // obwohl er das Problem laengst behoben hat.
        input.addEventListener('input', () => {
          input.classList.remove('is-invalid');
          this._clearMissingFieldsHint();
        }, { once: true });
      } else if (!footer) {
        // Weder Footer noch Feld gefunden → wenigstens nicht stumm scheitern.
        alert(text);
      }
    }

    _clearMissingFieldsHint() {
      const hint = document.querySelector('.customizer-validation-hint');
      if (hint) hint.style.display = 'none';
    }

    // Personalisierungs-Optionen des Produkts. Die Geschenkverpackung zaehlt
    // NICHT — sie ist Verpackung, keine Personalisierung.
    _personalizationOptions() {
      return (this.options || []).filter(o => o.type !== 'giftbox');
    }

    // Optionen, die mindestens EIN Text-Rect schalten. Eine reine Motiv-Option
    // zaehlt hier NICHT — sie entscheidet nichts ueber den Wunschtext.
    _textOptions() {
      const isText = new Map(this._allRects().map(r => [r.id, r.type === 'text']));
      return this._personalizationOptions().filter(
        o => (o.rectIds || []).some(id => isText.get(id)));
    }

    // Hat der Kunde irgendwo einen Wunschtext eingegeben — auch in einem Rect,
    // das inzwischen ausgeblendet ist? Genau darum `_allRects()` statt
    // `activeRects()`: der abgewaehlte Text ist ja das, was wir suchen.
    _anyTextEntered() {
      return this._enteredTexts().length > 0;
    }

    // Die tatsaechlich eingegebenen Wunschtexte — der Kunde soll in der
    // Rueckfrage sehen, um WELCHEN Text es geht. Mehrzeilige Produkte liefern
    // mehrere; sehr lange Texte werden gekuerzt, damit der Dialog lesbar bleibt.
    _enteredTexts() {
      return this._allRects()
        .filter(r => r.type === 'text')
        .map(r => String((this.values[r.id] || {}).text || '').trim())
        .filter(Boolean)
        .map(t => (t.length > 60 ? t.slice(0, 60) + '…' : t));
    }

    // Rueckfrage-Variante „Text geht verloren": Der Kunde hat einen Wunschtext
    // eingegeben und danach die zugehoerige Option abgewaehlt. Der Text waere
    // damit still weg.
    //
    // Bewusst nur ueber TEXT-Optionen entschieden, nicht ueber alle:
    //  • Ein aktives MOTIV aendert nichts daran, dass der Wunschtext wegfaellt
    //    — die Frage muss trotzdem kommen.
    //  • Wer von „einzeilig" auf „zweizeilig" wechselt, hat weiterhin eine
    //    Textoption aktiv → keine Frage, obwohl kurzzeitig umgeschaltet wurde.
    _shouldConfirmTextDiscarded() {
      const textOpts = this._textOptions();
      if (!textOpts.length) return false;
      if (textOpts.some(o => this.optionChoices[o.id] === 'yes')) return false;
      return this._anyTextEntered();
    }

    // Soll vor dem Warenkorb rueckgefragt werden?
    //
    // Ja, wenn das Produkt Personalisierungs-Optionen HAT, aber keine davon auf
    // „Ja" steht. Sonst legt der Kunde womoeglich unbeabsichtigt ein blankes
    // Produkt in den Warenkorb — bei einem Sortiment, das ueber die
    // Personalisierung verkauft wird, ist das fast immer ein Versehen.
    //
    // Zwei Ausnahmen, damit die Frage nicht nervt:
    //  • Produkt ohne Personalisierungs-Optionen → es gaebe nichts auszuwaehlen.
    //  • Der Kunde hat trotzdem etwas eingegeben (ungekoppeltes Rect) → er WILL
    //    personalisieren; „bist du sicher?" waere hier Unsinn.
    _shouldConfirmWithoutPersonalization() {
      const opts = this._personalizationOptions();
      if (!opts.length) return false;
      if (opts.some(o => this.optionChoices[o.id] === 'yes')) return false;
      const anyContent = (this.activeRects() || []).some(r => {
        const v = this.values[r.id] || {};
        return r.type === 'text' ? !!String(v.text || '').trim() : !!v.imageName;
      });
      return !anyContent;
    }

    // Setzt den „In den Warenkorb"-Button waehrend `fn` auf sein Ruhe-Label
    // zurueck. Sonst stuende hinter der halbtransparenten Rueckfrage
    // „Wird hinzugefuegt…" auf dem Button — waehrend genau gefragt wird, OB
    // ueberhaupt hinzugefuegt werden soll.
    async _withApplyButtonIdle(fn) {
      const btn = this._applyBtn;
      const busyLabel = btn ? btn.textContent : '';
      if (btn) btn.textContent = this._t('addToCartBtn');
      try {
        return await fn();
      } finally {
        if (btn) btn.textContent = busyLabel;
      }
    }

    // Rueckfrage „ohne Personalisierung bestellen?" → Promise<boolean>.
    // true = weiter in den Warenkorb, false = zurueck in den Dialog.
    _confirmWithoutPersonalization() {
      return this._confirmDialog(
        'confirmNoPerso', 'confirmNoPersoGo', 'confirmNoPersoBack');
    }

    // Rueckfrage „eingegebener Wunschtext geht verloren" → Promise<boolean>.
    _confirmTextDiscarded() {
      return this._confirmDialog(
        'confirmTextGone', 'confirmTextGoneGo', 'confirmTextGoneBack',
        { text: this._enteredTexts().join('", "') });
    }

    // Gemeinsamer Ja/Nein-Dialog. `textKey` stellt die Frage, `goKey` beschriftet
    // das Weiter, `backKey` das Zurueck. `vars` ersetzt {platzhalter} im Fragetext.
    _confirmDialog(textKey, goKey, backKey, vars) {
      return new Promise(resolve => {
        let ov = this._confirmOverlay;
        if (!ov) {
          ov = document.createElement('div');
          // Erbt Backdrop/Karte vom ATC-Overlay — gleiche Optik, kein Duplikat.
          ov.className = 'customizer-atc-overlay customizer-confirm-overlay';
          ov.setAttribute('role', 'dialog');
          ov.setAttribute('aria-modal', 'true');
          ov.innerHTML =
            '<div class="customizer-atc-card">' +
              '<div class="customizer-confirm-icon" aria-hidden="true">🪡</div>' +
              '<p class="customizer-atc-text"></p>' +
              '<div class="customizer-atc-actions">' +
                '<button type="button" class="customizer-confirm-no"></button>' +
                '<button type="button" class="customizer-confirm-yes"></button>' +
              '</div>' +
            '</div>';
          document.body.appendChild(ov);
          this._confirmOverlay = ov;
        }

        // split/join statt String.replace: der eingesetzte Wert ist KUNDENTEXT.
        // Ein „$&" oder „$1" darin wuerde von replace() als Ersetzungsmuster
        // gedeutet und den Satz verstuemmeln.
        let msg = this._t(textKey);
        if (vars) {
          Object.keys(vars).forEach(k => {
            msg = msg.split('{' + k + '}').join(vars[k]);
          });
        }
        ov.querySelector('.customizer-atc-text').textContent = msg;
        const noBtn  = ov.querySelector('.customizer-confirm-no');
        const yesBtn = ov.querySelector('.customizer-confirm-yes');
        noBtn.textContent  = this._t(backKey);
        yesBtn.textContent = this._t(goKey);

        // Listener beim Schliessen wieder abraeumen: das Overlay wird
        // wiederverwendet, und ein liegengebliebener Klick-Handler wuerde beim
        // naechsten Oeffnen auf ein laengst aufgeloestes Promise antworten.
        const onNo  = () => finish(false);
        const onYes = () => finish(true);
        const onKey = (e) => { if (e.key === 'Escape') finish(false); };
        function finish(answer) {
          ov.classList.remove('is-open');
          noBtn.removeEventListener('click', onNo);
          yesBtn.removeEventListener('click', onYes);
          document.removeEventListener('keydown', onKey);
          resolve(answer);
        }
        noBtn.addEventListener('click', onNo);
        yesBtn.addEventListener('click', onYes);
        document.addEventListener('keydown', onKey);

        ov.classList.add('is-open');
        noBtn.focus();   // Default = zurueck in den Dialog, nicht "kaufen"
      });
    }

    // Dialog "In den Warenkorb": capture the preview, then add the personalized
    // main variant PLUS any surcharge fee lines to the cart in a SINGLE
    // /cart/add.js call (theme-independent — no reliance on the theme's own ATC
    // button), and navigate to the cart so the customer sees the result.
    async _addToCartWithPersonalization() {
      // Bezahlte Personalisierung gewaehlt, Feld aber leer → hier abbrechen,
      // BEVOR das Overlay aufgeht. Sonst wandert eine bezahlte Leer-Zeile in
      // den Warenkorb (siehe _missingPersonalizationFields).
      const missing = this._missingPersonalizationFields();
      if (missing.length) {
        this._showMissingFieldsHint(missing);
        return;
      }
      this._clearMissingFieldsHint();

      // Rueckfragen vor dem Warenkorb. Reihenfolge = spezifisch vor allgemein:
      // Wer schon einen Wunschtext eingegeben hat, soll erfahren, dass GENAU
      // DER verlorengeht — nicht bloss „keine Personalisierung gewaehlt".
      // Darum else-if: es kommt hoechstens EINE Frage.
      let confirmFn = null;
      if (this._shouldConfirmTextDiscarded()) {
        confirmFn = () => this._confirmTextDiscarded();
      } else if (this._shouldConfirmWithoutPersonalization()) {
        confirmFn = () => this._confirmWithoutPersonalization();
      }
      if (confirmFn) {
        const proceed = await this._withApplyButtonIdle(confirmFn);
        if (!proceed) return;   // „Nein" → zurueck in den Dialog
      }

      // Show the reassuring overlay INSTANTLY (before the slow preview upload), so
      // the customer gets immediate feedback instead of just a dead button.
      const ov = this._ensureAtcOverlay();
      this._setAtcOverlayState('loading');
      ov.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      this._atcPromise = this._runAddToCart();
      try {
        await this._atcPromise;
        this._setAtcOverlayState('done');
      } catch (e) {
        console.error('[Customizer] add to cart failed:', e);
        this._setAtcOverlayState('error', (e && e.message) || '');
      }
    }

    // The actual work. For SPEED, the item is added to the cart WITHOUT waiting
    // for the (slow, ~seconds) Shopify-Files preview upload: the upload runs in
    // parallel and its URL is patched onto the line afterwards. Resolves true when
    // the item is in the cart; throws on failure.
    async _runAddToCart() {
      const form   = this._atcForm;
      const idEl   = form && form.querySelector('[name="id"]');
      const mainId = idEl && idEl.value;
      if (!mainId) throw new Error('Variante nicht gefunden – bitte Seite neu laden.');
      const qtyEl = form.querySelector('[name="quantity"]');
      const qty   = parseInt(qtyEl && qtyEl.value, 10) || 1;

      // Start the preview upload in parallel — do NOT block the cart add on it.
      const previewPromise = this._captureAndUploadPreview();

      // Shared bundle id so a Cart Transform function can MERGE the main product +
      // its surcharge lines into one non-splittable line (underscore keys are
      // hidden from the cart/checkout display).
      const bundleId = 'cz-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
      this._bundleId = bundleId;
      const mainProps = Object.assign({}, this._cartProperties(), { _cz_bundle: bundleId, _cz_role: 'main' });

      const items = [{ id: String(mainId), quantity: qty, properties: mainProps }];
      this._collectFeeItems(items, bundleId, qty);

      // Shopify's /cart/add.js MERGES two items that share a variant id within ONE
      // request — even when their line-item properties differ (a documented AJAX-API
      // limitation): the duplicate collapses into a single line and one item's
      // properties are silently dropped. Fee variants are keyed by PRICE, so two
      // paid options at the SAME price (e.g. a 5,95 € gift box + a 5,95 € Stickerei
      // surcharge) resolve to the SAME fee variant → one surcharge would vanish from
      // the cart AND the survivor could lose its _cz_bundle/_cz_role tags (then it
      // shows up as a loose, individually deletable line). Split any same-variant
      // collision into SEPARATE sequential requests, where differing properties DO
      // produce distinct line items. The common case (no price collision) stays a
      // single request — unchanged speed.
      const rounds = [];
      items.forEach((it) => {
        let r = rounds.find((rd) => !rd.ids.has(it.id));
        if (!r) { r = { ids: new Set(), items: [] }; rounds.push(r); }
        r.ids.add(it.id);
        r.items.push(it);
      });

      let firstData = null;
      for (let i = 0; i < rounds.length; i++) {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: rounds[i].items }),
        });
        if (!res.ok) {
          // The first round carries the MAIN product — its failure is fatal. A later
          // (fee-only) round failing must never strand the customer without the
          // product they configured, so just warn and keep the item in the cart.
          if (i === 0) {
            let msg = 'HTTP ' + res.status;
            try { const j = await res.json(); msg = j.description || j.message || msg; } catch (e) {}
            throw new Error(msg);
          }
          console.warn('[Customizer] surcharge round', i, 'failed:', res.status);
          continue;
        }
        if (i === 0) firstData = await res.json().catch(() => null);
      }
      this._notifyCartChange();  // refresh cart count/drawer without navigating away

      // Patch the preview URL onto the added main line once the upload finishes.
      const added  = (firstData && firstData.items) || [];
      const mainLn = added.find(it => String(it.id) === String(mainId)) || added[0];
      this._previewPatchPromise = this._patchPreviewWhenReady(previewPromise, mainLn && mainLn.key);
      return true;
    }

    // Wait for the background preview upload, then attach its URL to the line
    // (re-sending the full property set so nothing else is lost). Best-effort.
    async _patchPreviewWhenReady(previewPromise, lineKey) {
      try {
        await previewPromise;                 // sets this._previewUrl
        if (!this._previewUrl || !lineKey) return;
        // Re-send the FULL property set INCLUDING the bundle tags (else the patch
        // would drop _cz_bundle/_cz_role, and customizer-cart.js could no longer
        // group the main line with its surcharge lines to keep them consistent).
        const props = Object.assign({}, this._cartProperties(), { _cz_bundle: this._bundleId, _cz_role: 'main' });
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: lineKey, properties: props }),
        });
        this._notifyCartChange();
      } catch (e) { console.warn('[Customizer] preview patch failed:', e); }
    }

    // Build the add-to-cart status overlay once (spinner + text + two actions).
    // "Weiter Shoppen" closes it and keeps the dialog open (configure the next,
    // similar item); "Zum Warenkorb" waits for the add then navigates to /cart.
    _ensureAtcOverlay() {
      if (this._atcOverlay) return this._atcOverlay;
      const ov = document.createElement('div');
      ov.className = 'customizer-atc-overlay';
      ov.innerHTML =
        '<div class="customizer-atc-card">' +
          '<div class="customizer-atc-spinner" aria-hidden="true">🕐</div>' +
          '<p class="customizer-atc-text"></p>' +
          '<div class="customizer-atc-actions">' +
            '<button type="button" class="customizer-atc-continue"></button>' +
            '<button type="button" class="customizer-atc-tocart"></button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(ov);

      const contBtn = ov.querySelector('.customizer-atc-continue');
      const cartBtn = ov.querySelector('.customizer-atc-tocart');
      contBtn.textContent = this._t('continueShopping');
      cartBtn.textContent = this._t('toCart');

      const close = () => { ov.classList.remove('is-open'); document.body.style.overflow = ''; };

      contBtn.addEventListener('click', async () => {
        contBtn.disabled = cartBtn.disabled = true;
        try { await this._atcPromise; } catch (e) {}
        contBtn.disabled = cartBtn.disabled = false;
        close();  // dialog stays open → tweak & add another similar item
      });
      cartBtn.addEventListener('click', async () => {
        contBtn.disabled = cartBtn.disabled = true;
        try {
          await this._atcPromise;
          // Wait for the preview to be attached BEFORE navigating — otherwise the
          // page unload would abort the in-flight patch and lose the preview URL.
          try { await this._previewPatchPromise; } catch (e) {}
          window.location.href = '/cart';
        } catch (e) { contBtn.disabled = cartBtn.disabled = false; }
      });

      this._atcOverlay = ov;
      return ov;
    }

    _setAtcOverlayState(state, msg) {
      const ov = this._atcOverlay; if (!ov) return;
      const spin = ov.querySelector('.customizer-atc-spinner');
      const text = ov.querySelector('.customizer-atc-text');
      ov.classList.toggle('is-loading', state === 'loading');
      ov.classList.toggle('is-done',    state === 'done');
      ov.classList.toggle('is-error',   state === 'error');
      if (state === 'loading')    { spin.textContent = '🕐'; text.textContent = this._t('atcLoading'); }
      else if (state === 'done')  { spin.textContent = '✅'; text.textContent = this._t('atcDone'); }
      else                        { spin.textContent = '⚠️'; text.textContent = this._t('atcError') + (msg ? ' ' + msg : ''); }
    }

    // Property-Key für die Ja/Nein-Antwort einer Option.
    //
    // FALLE (bis 2026-08-12 ein echter Datenverlust): Rect-Label und
    // Options-Label heißen in der Praxis GLEICH — das Textfeld heißt „Name"
    // und die bezahlte Option „Möchtest du einen Namen?" trägt ebenfalls das
    // Label „Name". Weil die Options-Schleife NACH der Rect-Schleife läuft,
    // überschrieb sie `properties['Name']` — der Wunschtext des Kunden war
    // damit aus der Bestellung verschwunden und in uos nicht mehr
    // rekonstruierbar (dort kam nur noch „Ja, bitte!" an, während
    // „Name – Schrift"/„– Farbe" korrekt durchliefen).
    //
    // Der Wunschtext gewinnt jetzt; die Antwort bekommt einen eigenen Key.
    _optionAnswerKey(label, takenKeys) {
      return takenKeys.has(label) ? `${label} – Personalisierung` : label;
    }

    // Personalization + option choices as a Shopify line-item properties object
    // (mirrors updateLineItemProperties, but for the /cart/add.js payload).
    _cartProperties() {
      const props = {};
      const textKeys = new Set();
      this.activeRects().forEach((rect, i) => {
        const val = this.values[rect.id];
        if (!val) return;
        const label = rect.label || (rect.type === 'text' ? `Text ${i + 1}` : `Bild ${i + 1}`);
        if (rect.type === 'text' && val.text) {
          props[label]                = val.text;
          props[`${label} – Schrift`] = val.font;
          // Save the yarn colour NAME (e.g. "gold"), not the hex, so uos reads it.
          // Laser-Rechteck: keine Garnfarbe (Gravur hat keine).
          if (!this._isLaserRect(rect)) props[`${label} – Farbe`] = val.colorName || val.color;
          textKeys.add(label);
        } else if (rect.type === 'image' && val.imageName) {
          props[`${label} – Motiv`]   = val.imageName;
        }
      });
      this.options.forEach(opt => {
        const choice = this.optionChoices[opt.id];
        if (opt.type === 'giftbox') {
          if (choice) props[this._optionAnswerKey(opt.label, textKeys)] = choice;
        } else if (opt.price > 0) {
          const selected = choice === 'yes';
          props[this._optionAnswerKey(opt.label, textKeys)] =
            selected ? (opt.yesLabel || 'Ja') : (opt.noLabel || 'Nein');
          if (selected) props[`${opt.label} – Preis`] = this._formatPrice(opt.price, opt.currency);
        }
      });
      // Customer's configured preview image (uploaded to Shopify Files on confirm)
      if (this._previewUrl) props['Vorschau'] = this._previewUrl;
      return props;
    }

    // Verbund-Key eines Aufpreis-Artikels. MUSS bit-genau _fee_key() im Backend
    // entsprechen (typ|label|preis: trim, Whitespace kollabieren, lowercase, Preis
    // mit 2 Nachkommastellen), sonst wird die Variante nicht gefunden.
    _feeKey(type, label, price) {
      return String(type == null ? '' : type) + '|' +
        String(label == null ? '' : label).trim().replace(/\s+/g, ' ').toLowerCase() + '|' +
        Number(price).toFixed(2);
    }

    // Push one hidden fee-variant line per selected paid option into `items`.
    // Variant ids come from window.__customizerFeeVariants, now keyed by the
    // Verbund-Key `typ|label|preis` (not price) so two options at the same price
    // resolve to DISTINCT variants. The backend auto-creates these on push, so a
    // missing variant should not normally happen; it's skipped (warned) so the
    // main product still adds.
    _collectFeeItems(items, bundleId, qty) {
      const feeQty = qty || 1;
      const fees = window.__customizerFeeVariants || {};
      this.options.forEach(opt => {
        const choice = this.optionChoices[opt.id];
        let price = 0, label = opt.label || 'Personalisierung';
        if (opt.type === 'giftbox') {
          const co = (opt.choices || []).find(c => (typeof c === 'object' ? c.name : c) === choice);
          if (co && typeof co === 'object') { price = co.price || 0; label = `${opt.label}: ${co.name}`; }
        } else if (choice === 'yes') {
          price = opt.price || 0;
        }
        if (price > 0) {
          const key = this._feeKey(opt.type, label, price);
          const vid = fees[key];
          if (vid) {
            const props = { 'Aufpreis für': label };
            if (bundleId) { props._cz_bundle = bundleId; props._cz_role = 'fee'; }
            items.push({ id: String(vid), quantity: feeQty, properties: props });
          }
          else console.warn('[Customizer] kein Aufpreis-Artikel für', key, '— Produkt im Admin neu pushen');
        }
      });
    }

    // ── Font loading ──────────────────────────────────────────────────────────

    async loadFonts() {
      const fonts = this.global.fonts || [];
      await Promise.all(
        fonts
          .filter(f => f.url && !this._loadedFonts.has(f.name))
          .map(async f => {
            try {
              const face = new FontFace(f.name, `url(${f.url})`);
              await face.load();
              document.fonts.add(face);
              this._loadedFonts.add(f.name);
            } catch (err) {
              console.warn(`[Customizer] Font "${f.name}" failed:`, err);
            }
          })
      );
    }

    // ── Preview image ─────────────────────────────────────────────────────────

    loadPreviewImage(url) {
      return new Promise((resolve, reject) => {
        if (!url) {
          this.loadingEl.style.display = 'none';
          this.errorEl.style.display   = 'block';
          reject(new Error('No preview URL'));
          return;
        }

        const img = new Image();
        // CORS-clean so the composed canvas can be exported (toDataURL) for the
        // customer preview upload. Shopify CDN serves the needed CORS headers.
        img.crossOrigin = 'anonymous';

        img.onload = () => {
          this.image = img;
          // Natural (logical) dimensions — the coordinate space rects live in.
          this._imgNaturalW = img.naturalWidth;
          this._imgNaturalH = img.naturalHeight;
          // Supersample the canvas backing store so magnified stitch text stays
          // crisp under the loupe. Aim for ~2600px on the long edge, capped 1–3×.
          const TARGET = 2600;
          const long   = Math.max(img.naturalWidth, img.naturalHeight) || 1;
          this._res = Math.max(1, Math.min(3, TARGET / long));
          this.canvas.width  = Math.round(img.naturalWidth  * this._res);
          this.canvas.height = Math.round(img.naturalHeight * this._res);
          this._applyCanvasScale();
          this.loadingEl.style.display = 'none';
          resolve();
        };

        img.onerror = () => {
          this.loadingEl.style.display = 'none';
          this.errorEl.style.display   = 'block';
          reject(new Error('Image load failed'));
        };

        img.src = url;
      });
    }

    async updateVariant(url, variantTitle) {
      if (variantTitle !== undefined) this.variantTitle = variantTitle;
      this.previewUrl = url;
      // Neues Produktbild → die Artikel-Farbe (Ring um den Textbereich) muss neu
      // ermittelt werden; der alte Cache gehört zum vorherigen Bild.
      this._artikelFarbeCache = new Map();
      this.loadingEl.style.display = 'flex';
      this.errorEl.style.display   = 'none';
      // Abort any in-flight stitch generations and clear cached images
      Object.values(this._stitchAborts).forEach(ac => ac.abort());
      this._stitchImages    = {};
      this._stitchTimers    = {};
      this._stitchAborts    = {};
      this._stitchStatusEls = {};
      try {
        await this.loadPreviewImage(url);
        this.initDefaultValues();
        this.buildOptionPrompts();
        this.buildControls();
        this.buildVariantSelector();  // keep the in-dialog highlight in sync
        this._relabelAtcButton();     // theme re-renders the ATC label on change
        this.render();
        this._generateAllStitches();  // regenerate stitched previews after variant change
        this.updateLineItemProperties();
      } catch (_) {}
    }

    // ── In-dialog variant switching ─────────────────────────────────────────────
    // Lets the customer flip between variants (designs) inside the dialog while
    // keeping their personalization — matched across variants by rectangle LABEL,
    // so same-named rects (e.g. "Name RS") carry the text/font/colour/motif over.

    // Ein Listing hat in Shopify 1–3 Auswahl-Kriterien ("Größe", "Farbe", "Motiv").
    // Der Customizer spiegelt GENAU diese Struktur: je Kriterium ein Dropdown. Die
    // Thumbnail-Matrix (3×3) gibt es nur bei EINEM Kriterium mit ≤9 Werten — bei
    // mehreren Kriterien wäre eine flache Liste aller Kombinationen unbrauchbar
    // (Handtuch: 5 Größen × 16 Farben = 80 Einträge in einem Dropdown).

    _variantList() {
      const map = window.__customizerVariants || {};
      return Object.keys(map).map(id => ({
        id: id,
        title: map[id].title || '',
        previewUrl: map[id].previewUrl || map[id].imageUrl || '',
        // Options-Werte in Options-Reihenfolge. null = altes Liquid ohne die Daten
        // (Shopify-Seiten-Cache liefert nach einem Deploy bis zu ~1h altes Liquid
        // zu neuer JS) → wir fallen auf die frühere Variantenliste zurück.
        options: Array.isArray(map[id].options) ? map[id].options : null,
        available: map[id].available !== false,
      }));
    }

    // Kriterien mit echter Auswahl (>1 Wert). `idx` bleibt der Index im
    // variant.options-Array, auch wenn eine 1-Wert-Option herausgefiltert wurde.
    _productOptions() {
      const raw = window.__customizerProductOptions;
      if (!Array.isArray(raw) || !raw.length) return [];
      if (!this._variantList().some(v => v.options)) return [];
      return raw
        .map((o, i) => ({ name: o.name || '', idx: i, values: Array.isArray(o.values) ? o.values : [] }))
        .filter(o => o.values.length > 1);
    }

    _currentSelection() {
      const cur = this._currentVariantId();
      const v = this._variantList().find(x => String(x.id) === String(cur));
      return (v && v.options) ? v.options.slice() : [];
    }

    // Index des bildführenden Kriteriums, memoisiert — die Berechnung läuft über
    // alle Varianten und wird je Neuaufbau für jeden einzelnen Wert gebraucht.
    _imgIdxCached() {
      if (this._imgIdx === undefined) this._imgIdx = this._imageOptionIdx(this._productOptions());
      return this._imgIdx;
    }

    // Ist ein Kriterium bildführend? Ohne erkennbares bildführendes Kriterium
    // (noch keine Bilder zugeordnet) gilt das für ALLE — dann ändert sich beim
    // Wechsel kein Vorschaubild, also darf auch nichts still nachgezogen werden.
    _isImageLed(idx) {
      const imgIdx = this._imgIdxCached();
      return imgIdx === -1 || idx === imgIdx;
    }

    // Wechselt der Kunde ein NICHT bildführendes Kriterium (Größe), darf das
    // bildführende (Farbe) nachziehen, wenn die Kombination ausverkauft ist — den
    // Bildwechsel sieht er sofort. Umgekehrt niemals: eine still geänderte Größe
    // fällt nicht auf und würde als Fehlbestellung durchgehen. Beim Wechsel des
    // bildführenden Kriteriums bleibt die Größe deshalb hart stehen.
    _resolveOptionChange(idx, value, sel) {
      const cands = this._variantList().filter(v => v.options && v.options[idx] === value);
      if (!cands.length) return null;
      const mayShift = !this._isImageLed(idx);
      const score = v => (mayShift && v.available ? 1000 : 0)
                       + v.options.reduce((s, ov, i) => s + (i !== idx && ov === sel[i] ? 10 : 0), 0)
                       + (v.available ? 1 : 0);
      return cands.reduce((best, v) => (score(v) > score(best) ? v : best), cands[0]);
    }

    // Bildführendes Kriterium gegen den TATSÄCHLICHEN Bestand prüfen (Farbe, die
    // es in dieser Größe nicht gibt → gesperrt). Alle anderen gegen den
    // GESAMTbestand — sonst wäre eine Größe gesperrt, die es in einer anderen
    // Farbe noch gibt.
    _valueSelectable(idx, value, sel) {
      if (!this._isImageLed(idx)) {
        return this._variantList().some(v => v.options && v.options[idx] === value && v.available);
      }
      const v = this._resolveOptionChange(idx, value, sel || this._currentSelection());
      return !!(v && v.available);
    }

    _firstAvailableVariant() {
      return this._variantList().find(v => v.available) || null;
    }

    // Shopify-Verhalten: beim Öffnen steht die erste LIEFERBARE Variante drin, und
    // ist alles ausverkauft, ist der Kaufweg zu. Läuft genau einmal je Seitenaufruf
    // (sonst würde jeder Rebuild des Selectors die Wahl des Kunden überschreiben).
    _applyAvailabilityRules() {
      const variants = this._variantList();
      if (!variants.length) return;
      const anyAvailable = variants.some(v => v.available);

      if (!anyAvailable) {
        this._soldOut = true;
        ['test-modal-btn', 'customizer-modal-btn-top'].forEach(id => {
          const b = document.getElementById(id);
          if (!b) return;
          b.disabled = true;
          b.classList.add('is-sold-out');
          b.textContent = this._t('soldOut');
        });
        if (this._atcButton) {
          this._atcButton.disabled = true;
          this._atcButton.classList.add('is-sold-out');
        }
        return;
      }

      if (this._availabilityApplied) return;
      this._availabilityApplied = true;
      const cur = variants.find(v => String(v.id) === String(this._currentVariantId()));
      if (cur && !cur.available) {
        const next = this._firstAvailableVariant();
        if (next) this.switchVariant(next.id, next);
      }
    }

    // Welches Kriterium bestimmt das Vorschaubild? Das, dessen Werte die Bilder am
    // besten "erklären": viele verschiedene Bilder ÜBER die Werte, möglichst keine
    // Abweichung INNERHALB eines Werts (Handtuch: Farbe ja, Größe nein). -1 = keins
    // → alle Dropdowns rein textuell (z.B. solange noch keine Bilder zugeordnet sind).
    _imageOptionIdx(opts) {
      const vs = this._variantList().filter(v => v.options && v.previewUrl);
      let best = -1, bestScore = 0;
      opts.forEach(o => {
        const groups = {};
        vs.forEach(v => { const k = v.options[o.idx]; (groups[k] = groups[k] || []).push(v.previewUrl); });
        const distinct = new Set();
        let penalty = 0;
        Object.keys(groups).forEach(k => {
          const counts = {};
          groups[k].forEach(u => { counts[u] = (counts[u] || 0) + 1; });
          const urls = Object.keys(counts);
          distinct.add(urls.reduce((a, b) => (counts[a] >= counts[b] ? a : b)));
          penalty += urls.length - 1;
        });
        const score = distinct.size - penalty;
        if (distinct.size > 1 && score > bestScore) { bestScore = score; best = o.idx; }
      });
      return best;
    }

    _currentVariantId() {
      const form = this._atcForm;
      const idEl = form && form.querySelector('[name="id"]');
      if (idEl && idEl.value) return String(idEl.value);
      const map = window.__customizerVariants || {};
      for (const id in map) { if ((map[id].title || '') === this.variantTitle) return id; }
      return new URLSearchParams(location.search).get('variant') || '';
    }

    buildVariantSelector() {
      const variants = this._variantList();
      const previewEl = document.querySelector('.test-preview')
        || this.wrapper.querySelector('.customizer-preview-area')
        || document.querySelector('.customizer-preview-area');
      if (!previewEl || !previewEl.parentNode) return;

      this._imgIdx = undefined;   // je Neuaufbau frisch bestimmen (s. _imgIdxCached)

      // VOR dem Abbruch für Ein-Varianten-Artikel: auch ein Artikel ohne Auswahl
      // kann ausverkauft sein, und dann muss der Kaufweg zu sein.
      this._applyAvailabilityRules();

      const existing = document.getElementById('customizer-variant-selector');
      if (variants.length < 2) { if (existing) existing.remove(); return; }  // nothing to switch

      // Der Selector wird bei JEDEM Variantenwechsel neu gebaut. Die Outside-Click-
      // Handler der alten Dropdowns hingen sonst als Leiche am document und
      // vervielfachten sich mit jedem Wechsel (jetzt: mehrere Dropdowns pro Aufbau).
      (this._variantDocClicks || []).forEach(h => document.removeEventListener('click', h));
      this._variantDocClicks = [];

      const sel = existing || document.createElement('div');
      sel.id = 'customizer-variant-selector';
      sel.className = 'customizer-variant-selector';
      sel.innerHTML = '';

      const currentId = this._currentVariantId();
      const opts      = this._productOptions();
      const VARIANT_ROW_MAX = 9;   // ≤9 → 3×3-Grid-Thumbnails; darüber → Dropdown

      const addHeading = () => {
        const heading = document.createElement('div');
        heading.className = 'customizer-variant-heading';
        // Per-listing configurable (admin) with a sensible localized default.
        heading.textContent = (this.config && this.config.variantHeading) || this._t('variantHeading');
        sel.appendChild(heading);
      };

      if (!opts.length) {
        // Kein Liquid mit Options-Daten → altes Verhalten (flache Variantenliste).
        addHeading();
        const flat = variants.map(v => Object.assign({}, v, { disabled: !v.available }));
        if (variants.length > VARIANT_ROW_MAX) {
          sel.appendChild(this._buildVariantDropdown(flat, currentId));
        } else {
          sel.appendChild(this._buildVariantGrid(flat, currentId));
        }
      } else if (opts.length === 1 && opts[0].values.length <= VARIANT_ROW_MAX) {
        // EIN Kriterium mit wenigen Werten → Thumbnail-Matrix (schöner zu überblicken).
        addHeading();
        const o   = opts[0];
        const sel0 = this._currentSelection();
        const items = o.values.map(val => {
          const v = this._resolveOptionChange(o.idx, val, sel0);
          return { key: val, label: val, imageUrl: v ? v.previewUrl : '', variant: v,
                   disabled: !this._valueSelectable(o.idx, val, sel0) };
        });
        sel.appendChild(this._buildVariantGrid(
          items.map(it => ({ id: it.variant ? it.variant.id : '', title: it.label, previewUrl: it.imageUrl,
                             disabled: it.disabled, _pick: it.variant })),
          currentId));
      } else {
        // Mehrere Kriterien (oder eines mit vielen Werten) → je Kriterium ein Dropdown.
        const imgIdx = this._imgIdxCached();
        opts.forEach(o => {
          const wrap = document.createElement('div');
          wrap.className = 'customizer-variant-option';
          const lbl = document.createElement('div');
          lbl.className = 'customizer-variant-option-label';
          // Bei genau einem Kriterium bleibt die im Admin gepflegte Überschrift
          // ("Wähle deine Lieblingsfarbe:"); bei mehreren wäre sie mehrdeutig →
          // dann der Options-Name aus dem Listing ("Größe", "Farbe").
          lbl.textContent = (opts.length === 1
            ? ((this.config && this.config.variantHeading) || this._t('variantHeading'))
            : o.name);
          wrap.appendChild(lbl);

          const cur   = this._currentSelection();
          const items = o.values.map(val => {
            const v = this._resolveOptionChange(o.idx, val, cur);
            return {
              key: val,
              label: val,
              imageUrl: (o.idx === imgIdx && v) ? v.previewUrl : '',
              // Ausverkauft = durchgestrichen UND nicht anklickbar.
              disabled: !this._valueSelectable(o.idx, val, cur),
              variant: v,
            };
          });
          wrap.appendChild(this._buildPickerDropdown(items, cur[o.idx], it => {
            if (it.variant) this.switchVariant(it.variant.id, it.variant);
          }));
          sel.appendChild(wrap);
        });
      }
      if (!existing) {
        // Mobile: Preview ist collapsing Header — Variantenwahl gehört in den
        // Scroll-Bereich (ganz oben), nicht dauerhaft über die Preview.
        const mobileBody = this._mobileMode && document.querySelector('.test-modal-body');
        if (mobileBody) mobileBody.insertBefore(sel, mobileBody.firstChild);
        else previewEl.parentNode.insertBefore(sel, previewEl);
      }
    }

    // Thumbnail-Matrix (3×3 per CSS). Erwartet Einträge mit {id, title, previewUrl}
    // und optional `_pick` = die Variante, auf die geschaltet werden soll (bei der
    // Options-Matrix ist das die beste Kombination für den gewählten Wert).
    _buildVariantGrid(items, currentId) {
      const row = document.createElement('div');
      row.className = 'customizer-variant-row';
      items.forEach(v => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'customizer-variant-item'
          + (String(v.id) === String(currentId) ? ' is-selected' : '')
          + (v.disabled ? ' is-unavailable' : '');
        btn.title = v.disabled ? `${v.title} — ${this._t('soldOut')}` : v.title;
        if (v.previewUrl) {
          const img = document.createElement('img');
          img.src = v.previewUrl; img.alt = v.title; img.loading = 'lazy';
          btn.appendChild(img);
        } else {
          btn.textContent = v.title;
        }
        const target = v._pick || v;
        if (v.disabled) {
          btn.disabled = true;
        } else if (target && target.id) {
          btn.addEventListener('click', () => this.switchVariant(target.id, target));
        }
        row.appendChild(btn);
      });
      return row;
    }

    // Searchable dropdown (image + label), reusing the motif-dropdown look.
    // items: [{key, label, imageUrl, disabled}] — generisch, damit sowohl die
    // Options-Werte ("navyblau") als auch die alte flache Variantenliste damit
    // gebaut werden können.
    _buildPickerDropdown(items, currentKey, onPick) {
      const dd = document.createElement('div');
      dd.className = 'customizer-motif-dropdown';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'customizer-motif-trigger';
      const trigImg = document.createElement('img');
      trigImg.className = 'customizer-motif-trigger-img';
      const trigLabel = document.createElement('span');
      trigLabel.className = 'customizer-motif-trigger-label';
      const caret = document.createElement('span');
      caret.className = 'customizer-motif-caret'; caret.textContent = '▼';
      trigger.append(trigImg, trigLabel, caret);

      const panel = document.createElement('div');
      panel.className = 'customizer-motif-panel';
      const search = document.createElement('input');
      search.type = 'text';
      search.className = 'customizer-motif-search';
      search.placeholder = this._t('motifSearchPlaceholder');
      // Bei wenigen Werten (Größen!) ist ein Suchfeld nur Ballast.
      if (items.length <= 8) search.style.display = 'none';
      const list = document.createElement('div');
      list.className = 'customizer-motif-list';
      panel.append(search, list);
      dd.append(trigger, panel);

      const setTrigger = (it) => {
        if (it && it.imageUrl) { trigImg.src = it.imageUrl; trigImg.style.display = ''; }
        else trigImg.style.display = 'none';
        trigLabel.textContent = it ? it.label : '';
      };
      setTrigger(items.find(it => String(it.key) === String(currentKey)) || items[0]);

      const closePanel = () => dd.classList.remove('is-open');
      const optionEls = [];
      items.forEach(it => {
        const rowb = document.createElement('button');
        rowb.type = 'button';
        rowb.className = 'customizer-motif-option'
          + (String(it.key) === String(currentKey) ? ' is-selected' : '')
          + (it.disabled ? ' is-unavailable' : '');
        const img = document.createElement('img');
        if (it.imageUrl) img.src = it.imageUrl; else img.style.display = 'none';
        img.alt = it.label; img.loading = 'lazy';
        const span = document.createElement('span');
        span.textContent = it.disabled ? `${it.label} — ${this._t('soldOut')}` : it.label;
        rowb.append(img, span);
        // Ausverkauft: sichtbar, aber nicht wählbar (Shopify-Muster).
        if (it.disabled) rowb.disabled = true;
        else rowb.addEventListener('click', () => { closePanel(); onPick(it); });
        list.appendChild(rowb);
        optionEls.push({ q: (it.label || '').toLowerCase(), el: rowb });
      });
      search.addEventListener('input', () => {
        const q = search.value.trim().toLowerCase();
        optionEls.forEach(o => { o.el.style.display = (!q || o.q.indexOf(q) !== -1) ? '' : 'none'; });
      });
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const open = dd.classList.toggle('is-open');
        if (open) { search.value = ''; optionEls.forEach(o => o.el.style.display = ''); this._floatPanel(trigger, panel, dd); if (search.style.display !== 'none') search.focus(); }
      });
      const outside = (e) => { if (!dd.contains(e.target)) closePanel(); };
      document.addEventListener('click', outside);
      (this._variantDocClicks = this._variantDocClicks || []).push(outside);
      return dd;
    }

    // Alte flache Variantenliste (nur noch als Fallback ohne Options-Daten).
    _buildVariantDropdown(variants, currentId) {
      const items = variants.map(v => ({ key: v.id, label: v.title, imageUrl: v.previewUrl, variant: v }));
      return this._buildPickerDropdown(items, currentId, it => this.switchVariant(it.variant.id, it.variant));
    }

    async switchVariant(variantId, v) {
      v = v || (window.__customizerVariants || {})[variantId] || {};
      if (String(variantId) === String(this._currentVariantId())) return;

      // 1. Snapshot the current personalization keyed by rectangle LABEL.
      const carry = {};
      this.activeRects().forEach(r => {
        const val = this.values[r.id];
        if (val && r.label) carry[r.label] = Object.assign({}, val);
      });

      // 2. Point the product form at the chosen variant so add-to-cart is correct.
      const form = this._atcForm;
      const idEl = form && form.querySelector('[name="id"]');
      if (idEl) {
        idEl.value = String(variantId);
        try { idEl.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }

      // 3. Swap the preview + rects for the new variant.
      this.variantTitle = v.title || this.variantTitle;
      this.previewUrl   = v.previewUrl || v.imageUrl || this.previewUrl;
      this.loadingEl.style.display = 'flex';
      this.errorEl.style.display   = 'none';
      Object.values(this._stitchAborts).forEach(ac => ac.abort());
      // KEEP _stitchImages: the stitched text is variant-independent (only the base
      // preview changes), so _generateAllStitches below skips the cached ones and
      // won't needlessly re-render unchanged texts on a colour switch.
      this._stitchTimers = {}; this._stitchAborts = {}; this._stitchStatusEls = {};

      try {
        await this.loadPreviewImage(this.previewUrl);
        this.initDefaultValues();
        // 4. Re-apply carried personalization to same-named rects of the new variant.
        this.activeRects().forEach(r => {
          const src = r.label && carry[r.label];
          if (!src) return;
          if (r.type === 'text' && src.type === 'text') {
            this.values[r.id] = Object.assign({}, this.values[r.id], {
              text: src.text, font: src.font, color: src.color, colorName: src.colorName,
            });
          } else if (r.type === 'image' && src.type === 'image') {
            this.values[r.id] = { type: 'image', imageUrl: src.imageUrl, imageName: src.imageName };
          }
        });
        this.buildControls();
        this.buildVariantSelector();
        this._relabelAtcButton();  // our change event may have reset the theme label
        this.render();
        this._generateAllStitches();
        this.updateLineItemProperties();
      } catch (_) {}
    }

    _applyCanvasScale() {
      // Preserve the canvas's intrinsic (buffer) aspect ratio in BOTH modes: clear
      // any explicit px sizing and let CSS scale it to fit the preview box WITHOUT
      // distortion (the canvas' inline style carries width/height:auto +
      // max-width/max-height:100%, so the browser fits it while keeping the ratio,
      // and re-fits automatically when the modal becomes visible or the window
      // resizes — no JS math needed).
      //
      // The OLD desktop branch set an explicit width AND height in px; whenever the
      // CSS max-width/max-height then clamped ONE axis (e.g. a tall image against a
      // limited preview column), the other px value stayed put → the squished
      // desktop preview the customer reported. Mobile always cleared both and was
      // never distorted. (The active modal is .test-modal-dialog, so the
      // .customizer-modal-dialog{object-fit:contain} safety net never applied here.)
      this.canvas.style.width  = '';
      this.canvas.style.height = '';
      if (this._mobileMode && this._updateMobilePreviewHeight) this._updateMobilePreviewHeight();
    }

    // ── Mobile: collapsing Preview + Pinch-Zoom (statt Lupe) ─────────────────
    // Amazon-Konfigurator-Muster: Die Preview hängt oben im Dialog AUSSERHALB
    // des Scroll-Bereichs. Ganz oben ist sie maximal groß; beim Runterscrollen
    // schrumpft sie px-genau mit bis auf eine Mini-Höhe und bleibt sichtbar.
    _setupMobilePreview() {
      this._mobileMode = window.matchMedia('(max-width: 900px)').matches;
      if (!this._mobileMode || this.displayMode !== 'modal') return;

      const dialog  = document.getElementById('test-modal-dialog');
      const heading = dialog && dialog.querySelector('.test-modal-heading');
      const body    = dialog && dialog.querySelector('.test-modal-body');
      const preview = document.querySelector('.test-preview');
      if (!dialog || !heading || !body || !preview || !this.canvas) return;

      heading.insertAdjacentElement('afterend', preview);
      preview.classList.add('customizer-mobile-preview');
      this.canvas.style.transform = 'none';   // Desktop-Zoom (scale 1.3) aus
      this._applyCanvasScale();               // px-Maße entfernen

      const MIN_H = 110;
      const updateHeight = () => {
        const aspect = this.canvas.height / (this.canvas.width || 1);
        const idealH = (dialog.clientWidth - 24) * aspect + 16;
        const maxH   = Math.min(idealH, Math.round(window.innerHeight * 0.5));
        preview.style.height = Math.max(MIN_H, maxH - body.scrollTop) + 'px';
      };
      this._updateMobilePreviewHeight = updateHeight;
      body.addEventListener('scroll', updateHeight, { passive: true });
      window.addEventListener('resize', updateHeight);
      // Beim Init ist der Dialog noch display:none (clientWidth 0) und das
      // Öffnen feuert kein Scroll-Event — daher auf Größenwechsel reagieren.
      if (window.ResizeObserver) new ResizeObserver(updateHeight).observe(dialog);
      ['test-modal-btn', 'customizer-modal-btn-top'].forEach((id) => {
        const b = document.getElementById(id);
        if (b) b.addEventListener('click', () => requestAnimationFrame(updateHeight));
      });
      updateHeight();

      this._setupPinchZoom(preview);
    }

    // 2-Finger-Pinch + 1-Finger-Pan (wenn gezoomt) + Doppeltipp (rein/raus).
    // Zum Desktop-Testen zusätzlich Trackpad-Pinch bzw. Ctrl+Mausrad (beide
    // kommen als wheel-Event mit ctrlKey an). Der Zoom ist ein CSS-transform
    // aufs Canvas — schrumpft die Preview beim Scrollen, schrumpft die
    // gezoomte Ansicht proportional mit.
    _setupPinchZoom(preview) {
      const canvas = this.canvas;
      const st = { s: 1, tx: 0, ty: 0 };
      const MAX_S = 4;
      canvas.style.transformOrigin = 'center center';
      preview.style.touchAction = 'pan-y';

      const apply = () => {
        if (st.s <= 1.001) { st.s = 1; st.tx = 0; st.ty = 0; }
        const maxTx = (st.s - 1) * canvas.offsetWidth  / 2;
        const maxTy = (st.s - 1) * canvas.offsetHeight / 2;
        st.tx = Math.max(-maxTx, Math.min(maxTx, st.tx));
        st.ty = Math.max(-maxTy, Math.min(maxTy, st.ty));
        canvas.style.transform = st.s === 1
          ? 'none'
          : 'translate(' + st.tx + 'px,' + st.ty + 'px) scale(' + st.s + ')';
        // Gezoomt: 1 Finger pannt das Bild statt die Seite zu scrollen
        preview.style.touchAction = st.s > 1 ? 'none' : 'pan-y';
      };

      // Mittelpunkt des UNtransformierten Canvas (Layout-Mitte): die sichtbare
      // Rect-Mitte ist um die aktuelle Translation verschoben.
      const layoutCenter = () => {
        const r = canvas.getBoundingClientRect();
        return { x: r.left + r.width / 2 - st.tx, y: r.top + r.height / 2 - st.ty };
      };
      const zoomAround = (px, py, newS) => {
        newS = Math.max(1, Math.min(MAX_S, newS));
        const C = layoutCenter();
        const f = newS / st.s;
        st.tx = (px - C.x) - f * (px - C.x - st.tx);
        st.ty = (py - C.y) - f * (py - C.y - st.ty);
        st.s  = newS;
        apply();
      };

      const pointers = new Map();
      let pinch = null;        // {dist, s, tx, ty, mid, C}
      let pan = null;          // {x, y}
      let lastTap = { t: 0, x: 0, y: 0 };

      preview.addEventListener('pointerdown', (e) => {
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        preview.setPointerCapture && preview.setPointerCapture(e.pointerId);
        const pts = [...pointers.values()];
        if (pts.length === 2) {
          pinch = {
            dist: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y),
            s: st.s, tx: st.tx, ty: st.ty,
            mid: { x: (pts[0].x + pts[1].x) / 2, y: (pts[0].y + pts[1].y) / 2 },
            C: layoutCenter(),
          };
          pan = null;
        } else if (pts.length === 1 && st.s > 1) {
          pan = { x: e.clientX, y: e.clientY };
        }
      });

      preview.addEventListener('pointermove', (e) => {
        if (!pointers.has(e.pointerId)) return;
        pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        const pts = [...pointers.values()];
        if (pinch && pts.length === 2) {
          const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
          const mid  = { x: (pts[0].x + pts[1].x) / 2, y: (pts[0].y + pts[1].y) / 2 };
          const newS = Math.max(1, Math.min(MAX_S, pinch.s * (dist / (pinch.dist || 1))));
          const f    = newS / pinch.s;
          st.tx = (mid.x - pinch.C.x) - f * (pinch.mid.x - pinch.C.x - pinch.tx);
          st.ty = (mid.y - pinch.C.y) - f * (pinch.mid.y - pinch.C.y - pinch.ty);
          st.s  = newS;
          apply();
        } else if (pan && pts.length === 1 && st.s > 1) {
          st.tx += e.clientX - pan.x;
          st.ty += e.clientY - pan.y;
          pan = { x: e.clientX, y: e.clientY };
          apply();
        }
      });

      const release = (e) => {
        // Doppeltipp: rein (2.5x um den Tipp-Punkt) bzw. raus
        if (pointers.size === 1 && !pan && e.type === 'pointerup') {
          const now = Date.now();
          if (now - lastTap.t < 300 && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 30) {
            if (st.s > 1) { st.s = 1; apply(); }
            else zoomAround(e.clientX, e.clientY, 2.5);
            lastTap.t = 0;
          } else {
            lastTap = { t: now, x: e.clientX, y: e.clientY };
          }
        }
        pointers.delete(e.pointerId);
        if (pointers.size < 2) pinch = null;
        if (pointers.size !== 1) pan = null;
        else { const p = [...pointers.values()][0]; pan = st.s > 1 ? { x: p.x, y: p.y } : null; }
      };
      preview.addEventListener('pointerup', release);
      preview.addEventListener('pointercancel', release);

      // iOS-Safari: Browser-Page-Zoom/Scroll nicht dazwischenfunken lassen
      preview.addEventListener('touchmove', (e) => {
        if (e.touches.length >= 2 || st.s > 1) e.preventDefault();
      }, { passive: false });

      // Desktop-Test: Trackpad-Pinch/Ctrl+Mausrad → zoomen um den Cursor
      preview.addEventListener('wheel', (e) => {
        if (!e.ctrlKey) return;
        e.preventDefault();
        zoomAround(e.clientX, e.clientY, st.s * Math.exp(-e.deltaY * 0.01));
      }, { passive: false });
    }

    // ── Active rects (variant override aware + option visibility) ─────────────

    activeRects() {
      // Filter out rects controlled by an option whose choice is 'no'
      const hidden = this._hiddenRectIds();
      return this._allRects().filter(r => !hidden.has(r.id));
    }

    // Alle Rects der aktuellen Variante — OHNE den Sichtbarkeits-Filter.
    // Gebraucht, um Eingaben zu finden, deren Option inzwischen auf „Nein"
    // steht: solche Rects fallen aus `activeRects()` heraus, ihr Wert bleibt
    // aber in `this.values` stehen (`update('no')` loescht ihn nicht).
    _allRects() {
      const overrides = this.config.variantOverrides || {};
      const vt        = this.variantTitle;
      return (vt && overrides[vt] && overrides[vt].length)
        ? overrides[vt]
        : (this.config.rectangles || []);
    }

    _hiddenRectIds() {
      const hidden = new Set();
      this.options.forEach(opt => {
        const isNo = this.optionChoices[opt.id] === 'no';
        if (isNo && opt.rectIds) {
          opt.rectIds.forEach(id => hidden.add(id));
        }
      });
      return hidden;
    }

    // ── Default values ────────────────────────────────────────────────────────

    initDefaultValues() {
      const fonts  = this.global.fonts  || [];
      const colors = this.global.colors || ['#000000'];
      const yarnColors = this.global.yarnColors || [];
      const technique = this.global.technique || '';

      // Defaults are PER-PRODUCT first (config), then the global fallback.
      const cfgColor     = this.config.defaultColor     || this.global.defaultColor;
      const cfgColorName  = this.config.defaultColorName || this.global.defaultColorName;

      // Prefer the product default font; then global; then the first font.
      const defaultFont = this.config.defaultFont || this.global.defaultFont
        || (fonts[0] ? fonts[0].name : 'Arial');

      // Prefer the configured default colour (by name). For embroidery, fall back
      // to the first yarn colour; otherwise first colour or white.
      let defaultColor = '#ffffff';
      let defaultColorName = '';
      // Prefer defaultColorName; fall back to a name held in defaultColor (legacy).
      const legacyDefault = (cfgColor && !String(cfgColor).startsWith('#'))
        ? cfgColor : '';
      let adminColorName = cfgColorName || legacyDefault;
      let adminYarn = adminColorName
        ? yarnColors.find(y => y.name === adminColorName)
        : null;
      // The admin often stores the default as a HEX (e.g. "#d9a44a") with no name.
      // Resolve it to a yarn by matching the hex, otherwise it falls back to the
      // first yarn (was showing braun instead of the configured gold).
      if (!adminYarn && cfgColor && String(cfgColor).startsWith('#')) {
        const hx = String(cfgColor).replace('#', '').toLowerCase();
        adminYarn = yarnColors.find(y =>
          String(y.displayHex || ('#' + y.hex)).replace('#', '').toLowerCase() === hx ||
          String(y.hex || '').toLowerCase() === hx);
        if (adminYarn) adminColorName = adminYarn.name;
      }
      if (adminYarn) {
        defaultColor = adminYarn.displayHex || `#${adminYarn.hex}`;
        defaultColorName = adminYarn.name;
      } else if (technique === 'embroidery' && yarnColors.length > 0) {
        defaultColor = yarnColors[0].displayHex || `#${yarnColors[0].hex}`;
        defaultColorName = yarnColors[0].name;
      } else if (adminColorName) {
        // No yarn match (non-embroidery) but a name/hex is set
        defaultColor = cfgColor || adminColorName;
        defaultColorName = adminColorName;
      } else if (colors.length > 0) {
        defaultColor = (typeof colors[0] === 'string') ? colors[0] : (colors[0].hex || '#ffffff');
      }

      // Init values for all rects (visible and hidden) so they're ready when shown
      const allRects = [
        ...(this.config.rectangles || []),
        ...Object.values(this.config.variantOverrides || {}).flat(),
      ];
      allRects.forEach(rect => {
        if (this.values[rect.id]) return; // keep existing user input
        if (rect.type === 'text') {
          const value = { type: 'text', text: '', font: defaultFont, color: defaultColor };
          if (defaultColorName) value.colorName = defaultColorName;  // Store yarn name if applicable
          this.values[rect.id] = value;
        } else if (rect.type === 'image') {
          this.values[rect.id] = { type: 'image', imageUrl: null, imageName: null };
        }
      });
    }

    // ── Controls: options with inline rect controls, then unlinked rects ─────────

    buildOptionPrompts() {} // no-op — handled in buildControls

    // ── Sich gegenseitig ausschließende Optionen ──────────────────────────────
    // Zwei Wege, beide symmetrisch — es reicht, den Ausschluss auf EINER Seite zu
    // pflegen:
    //   • excludes: [optionId, …]  — im Admin angeklickt (der normale Weg)
    //   • exclusiveGroup: 'name'   — Altbestand: gleicher Gruppenname auf BEIDEN
    //     Optionen. Ein Gruppenname, den nur eine Option trägt, schließt nichts
    //     aus — das war die Falle, die den Ausschluss „nicht funktionieren" ließ.
    _excludedOptions(opt) {
      const norm  = s => String(s || '').trim().toLowerCase();
      const mine  = (Array.isArray(opt.excludes) ? opt.excludes : []).map(String);
      // Gruppenname zeigt auf die andere Option (Name oder ID) statt auf eine
      // gemeinsame Gruppe. So ist es auf bestehenden Artikeln gepflegt
      // („einzeilig" trägt die Gruppe „zweizeilig" und umgekehrt) — früher fiel
      // genau diese Schreibweise still durch und schloss gar nichts aus.
      const pointsAt = (from, to) => {
        const g = norm(from.exclusiveGroup);
        return !!g && (g === norm(to.label) || g === norm(to.id));
      };
      return this.options.filter(other => {
        if (other.id === opt.id) return false;
        if (mine.indexOf(String(other.id)) !== -1) return true;
        const theirs = (Array.isArray(other.excludes) ? other.excludes : []).map(String);
        if (theirs.indexOf(String(opt.id)) !== -1) return true;
        if (pointsAt(opt, other) || pointsAt(other, opt)) return true;
        return !!opt.exclusiveGroup && other.exclusiveGroup === opt.exclusiveGroup;
      });
    }

    // Name der ERSTEN Geschenk-Auswahl. Die ist der neutrale Zustand: sie steht
    // per Default an ("Nein") und wird ohne Zutun des Kunden vorausgewählt.
    _giftboxNeutral(opt) {
      const first = (opt.choices || [])[0];
      if (first === undefined) return null;
      return typeof first === 'object' ? first.name : first;
    }

    _isOptionActive(opt) {
      const c = this.optionChoices[opt.id];
      if (opt.type !== 'giftbox') return c === 'yes';
      // „Nein" ist ein gültiger Wert, aber keine Entscheidung FÜR etwas — sonst
      // bliebe der Kasten hervorgehoben, obwohl der Kunde abgelehnt hat.
      return !!c && c !== this._giftboxNeutral(opt);
    }

    // „Aus" heißt je nach Typ etwas anderes: eine Geschenkbox hat keinen
    // Ja/Nein-Zustand, sondern eine Auswahl — die wird geleert.
    _deactivateOption(opt) {
      this.optionChoices[opt.id] = opt.type === 'giftbox' ? '' : 'no';
    }

    // Gibt true zurück, wenn tatsächlich etwas abgeschaltet wurde (→ neu aufbauen).
    _applyExclusions(opt) {
      let changed = false;
      this._excludedOptions(opt).forEach(other => {
        if (!this._isOptionActive(other)) return;
        this._deactivateOption(other);
        changed = true;
      });
      return changed;
    }

    buildControls() {
      this.controlsEl.innerHTML = '';
      const giftboxContainer = document.getElementById('customizer-giftbox-container');
      if (giftboxContainer) giftboxContainer.innerHTML = '';
      this._inlineRenderedRects.clear();
      // Rebuilt fresh below by _buildTextControl (only for sameContent options),
      // so a turned-off sameContent or a variant change can't leave stale links.
      this._mirrorGroups = {};
      this._mirrorCross  = {};
      this._hints = {};          // gemeinsame Erklärtexte je Option, s. _sharedHint

      // 0. Price summary. In modal mode it lives in the footer (next to the
      // buttons, added in _setupModalIfNeeded); inline mode keeps it at the top.
      if (this.displayMode !== 'modal') {
        let summary = document.getElementById('customizer-price-summary');
        if (!summary) {
          summary = document.createElement('div');
          summary.id = 'customizer-price-summary';
          summary.className = 'customizer-price-summary';
          this.controlsEl.appendChild(summary);
        }
      }
      this._updatePriceDisplay();

      // Collect which rect IDs are managed by an option
      const managedRectIds = new Set(
        this.options.flatMap(opt => opt.rectIds || [])
      );

      // 1. Render each option prompt, and if activated, inline controls for its rects
      this.options.forEach(opt => {
        console.log('[Customizer] Rendering option', opt.id, 'current choice:', this.optionChoices[opt.id], 'exclusiveGroup:', opt.exclusiveGroup);

        // Check if prerequisites are met
        if (opt.prerequisites && opt.prerequisites.length > 0) {
          const allPrereqsMet = opt.prerequisites.every(prereqId =>
            this.optionChoices[prereqId] === 'yes'
          );
          if (!allPrereqsMet) return; // Skip this option if prerequisites not met
        }

        const prompt = document.createElement('div');
        prompt.className = 'customizer-option-prompt';

        // Question — with the price appended in parentheses (space-saving: no
        // separate price line). Giftbox prices live on the individual choices.
        const question = document.createElement('div');
        question.className = 'customizer-option-question';
        let qtext = opt.question || opt.label || '';
        if (opt.type !== 'giftbox' && opt.price > 0) {
          qtext += ' (+' + this._formatPrice(opt.price, opt.currency) + ')';
        }
        question.textContent = qtext;
        prompt.appendChild(question);

        // Controls placeholder (filled when yes is chosen)
        const inlineControls = document.createElement('div');
        inlineControls.className = 'customizer-option-inline-controls';

        if (opt.type === 'giftbox') {
          this._buildGiftboxControl(prompt, opt, inlineControls);
        } else {
          this._buildYesNoControl(prompt, opt, inlineControls);
        }

        prompt.appendChild(inlineControls);

        // If currently "yes", fill in the rect controls
        if (this.optionChoices[opt.id] === 'yes') {
          this._fillInlineControls(inlineControls, opt);
        }

        // Mark as selected if active
        if (this._isOptionActive(opt)) {
          prompt.classList.add('is-selected');
        }

        // Render giftbox options to separate container, others to main controls
        if (opt.type === 'giftbox') {
          const giftboxContainer = document.getElementById('customizer-giftbox-container');
          if (giftboxContainer) giftboxContainer.appendChild(prompt);
        } else {
          this.controlsEl.appendChild(prompt);
        }
      });

      // 2. Render controls for rects not linked to any option
      // Skip text rects entirely — they're always managed by embroidery/laser inline controls
      const allVisible = this.activeRects();
      const unlinked   = allVisible.filter(r => !managedRectIds.has(r.id) && r.type !== 'text');

      unlinked.forEach((rect, index) => {
          const group = document.createElement('div');
          group.className      = 'customizer-control-group';
          group.dataset.rectId = rect.id;

          const label = document.createElement('div');
          label.className   = 'customizer-control-label';
          label.textContent = rect.label ||
            (rect.type === 'text' ? `Text ${index + 1}` : `Bild ${index + 1}`);
          group.appendChild(label);

          if (rect.type === 'text') {
            group.appendChild(this._buildTextControl(rect));
          } else if (rect.type === 'image') {
            group.appendChild(this._buildImageControl(rect));
          }

          this.controlsEl.appendChild(group);
        });

    }

    _fillInlineControls(container, opt) {
      container.innerHTML = '';
      // Die gemeinsamen Erklärtexte dieser Option hingen im gerade geleerten
      // Container — Merker weg, sonst zeigen sie ins Nichts.
      if (this._hints) {
        Object.keys(this._hints).forEach(k => {
          if (k.indexOf(opt.id + ':') === 0) delete this._hints[k];
        });
      }

      // Motif options get a thumbnail picker instead of text controls.
      if (opt.type === 'Motiv') { this._buildMotifPicker(container, opt); return; }

      const allRects = this.activeRects();

      // Get text rectangles that are linked to THIS option
      const textRects = (opt.rectIds || [])
        .map(rid => allRects.find(r => r.id === rid))
        .filter(r => r && r.type === 'text');

      // Track that these text rects are being rendered in inline controls
      textRects.forEach(rect => this._inlineRenderedRects.add(rect.id));

      // Initialize state for "use same settings" checkbox (default: true)
      const stateKey = opt.id + '_useSameFont';
      if (!(stateKey in this.optionChoices)) {
        this.optionChoices[stateKey] = true;
      }
      const useSameFont = this.optionChoices[stateKey];

      // If this option has text rectangles, show embroidery controls
      if (textRects.length > 0) {
        const embroiderySection = document.createElement('div');
        embroiderySection.className = 'customizer-embroidery-section';

        // Kein „Alle Texte verwenden die gleiche Schrift und Farbe"-Kästchen mehr:
        // Schrift und Farbe gelten immer für alle Textfelder einer Option. Der
        // Schalter stand nur im Weg — der Zustand (stateKey) bleibt auf true und
        // steuert weiterhin, dass eine Schrift-/Farbwahl auf alle Felder wirkt.

        // Add text input controls. With sameContent, show ONE input that mirrors
        // its text to every linked rectangle (e.g. one name on backpack + gym bag).
        const inputRects = opt.sameContent ? textRects.slice(0, 1) : textRects;
        const mirrorRects = opt.sameContent ? textRects : null;
        inputRects.forEach((rect, idx) => {
          const group = document.createElement('div');
          group.className = 'customizer-control-group';
          // No redundant "Name" heading for the single sameContent input — the
          // option question already provides context. Keep distinguishing labels
          // only when there are multiple, separately-editable text fields.
          if (!opt.sameContent) {
            const label = document.createElement('div');
            label.className = 'customizer-control-label';
            label.textContent = rect.label || `Text ${idx + 1}`;
            group.appendChild(label);
          }
          // Erklärtexte (S3-Herz-Hinweis, „keine Großbuchstaben") gehören zur
          // OPTION, nicht zum einzelnen Textfeld — sonst stünden sie bei drei
          // Rechtecken dreimal untereinander.
          group.appendChild(this._buildTextControl(rect, mirrorRects, opt.id, embroiderySection));
          embroiderySection.appendChild(group);
        });

        // Font selector — custom dropdown showing each font rendered as a
        // stitched preview image (pre-deployed "Wunschtext" per font). Falls back
        // to a native <select> when no previews are available.
        // Schriftart + Farbe teilen sich EINE Zeile (platzsparend).
        const styleRow = document.createElement('div');
        styleRow.className = 'customizer-style-row';
        const fonts = this.global.fonts || [];
        // Assigned inside the font-dropdown block; called from the yarn-colour
        // handler so the font previews recolour to the chosen yarn colour.
        let refreshFontPreviewsColor = null;
        if (fonts.length > 0) {
          const fontRow = document.createElement('div');
          fontRow.className = 'customizer-option-row';
          const fontLbl = document.createElement('span');
          fontLbl.className = 'customizer-option-label';
          fontLbl.textContent = this._t('fontLabel');
          fontRow.appendChild(fontLbl);

          // Stick: gestickte Vorschau je Garnfarbe; „nur Laser": Gravur auf Lack.
          const fpSource = this._fontPreviewSource(textRects);
          const fpDefaultColor = fpSource.defaultColor;
          const previewUrl = fpSource.url;
          const currentColorName = () => this.values[textRects[0].id].colorName || fpDefaultColor;
          const havePreviews = fonts.some(f => previewUrl(f.name, fpDefaultColor));

          // Very light thread colours (weiß, gelb, hellblau, hellgrau, rosa, mint …)
          // are near-invisible on the default white preview background — darken the
          // container for those so the stitched sample stays readable.
          const _isLightColor = (colorName) => this._isLightColor(colorName);
          // Hintergrund der Vorschau-Flächen: bevorzugt die Artikel-Farbe (Ring
          // um den Textbereich im Produktbild) – die Schriftprobe wirkt dann wie
          // auf dem Artikel. Fehlt die Artikel-Farbe (kein Bild/kein Zugriff auf
          // die Pixel), gilt das bisherige Verhalten (#454545 bei hellem Garn,
          // sonst weiß).
          const _artikelBg = (colorName) => {
            // Im Set (mehrere Namensfelder) bekommen alle Listen dieselbe Grundfarbe:
            // gemessen am ersten Textfeld der Variante (Hauptartikel).
            const base = this._artikelFarbe(this._hauptTextRects() || textRects);
            if (!base) return '';
            // Die Artikel-Farbe wird gegen die Schriftfarbe (Garn bzw. Gravur)
            // verschoben, damit die Vorschau sichtbar bleibt.
            return this._mitKontrast(
              base,
              this._schriftFarbe(textRects, colorName),
              this._schriftIstHell(textRects, colorName)
            );
          };
          // Das geschlossene Auswahlfeld trägt denselben Hintergrund wie die
          // Liste (Artikel-Farbe); ohne Artikel-Farbe wie bisher nur bei hellem
          // Garn abgedunkelt.
          const _applyPreviewBg = (el, colorName) => {
            if (!el) return;
            const bg = _artikelBg(colorName);
            if (bg) { el.style.backgroundColor = bg; return; }
            el.style.backgroundColor = (fpSource.laser || !_isLightColor(colorName)) ? '' : '#454545';
          };
          // Das Dropdown (Liste inkl. Innenabstand) bekommt EINE gemeinsame
          // Hintergrundfarbe: die Artikel-Farbe, sonst bei hellen Garnfarben
          // dunkel, sonst weiß. Die Einträge selbst bleiben transparent – so
          // wirkt die Liste als ein Block statt als Sammlung einzelner Kacheln.
          const _applyDropdownBg = (el, colorName) => {
            if (!el) return;
            const bg = _artikelBg(colorName);
            const hex = bg || (fpSource.laser ? '#fff' : (_isLightColor(colorName) ? '#454545' : '#fff'));
            el.style.backgroundColor = hex;
            const lum = this._relativeLuminance(hex);
            el.classList.toggle('is-dark', lum !== null && lum < 0.35);
          };

          const applyFont = (fontName) => {
            const rects = (useSameFont || opt.sameContent) ? textRects : [textRects[0]];
            rects.forEach(rect => { this.values[rect.id].font = fontName; });
            // Regenerate ONCE per distinct content: sameContent → primary only
            // (shared to mirrors); otherwise each rect (they hold different text).
            const toGen = opt.sameContent ? [textRects[0]] : rects;
            toGen.forEach(rect => { if (this._usesBackendRender(rect)) this._scheduleStitch(rect); });
            // Re-run each affected input's char-support check + font hint for the NEW
            // font. The text input's own onChange does NOT fire on a font switch, so
            // without this the "unsupported char" warning and the S3-only heart hint
            // stay frozen on the PREVIOUS font's state (e.g. S3 hint lingering on S2,
            // or a "M not available" warning surviving a switch away from S3).
            rects.forEach(rect => this._textUIRefreshers?.[rect.id]?.());
            this.render();
            this.updateLineItemProperties();
          };

          if (havePreviews) {
            const currentFont = this.values[textRects[0].id].font;
            const control  = document.createElement('div');
            control.className = 'customizer-font-control';

            const selected = document.createElement('div');
            selected.className = 'customizer-font-selected';
            const selImg = document.createElement('img');
            selImg.alt = currentFont;
            { const u = previewUrl(currentFont, currentColorName()); if (u) selImg.src = u; }
            _applyPreviewBg(selected, currentColorName());
            selected.appendChild(selImg);

            const toggleBtn = document.createElement('button');
            toggleBtn.type = 'button';
            toggleBtn.className = 'customizer-font-dropdown-toggle';
            toggleBtn.textContent = '▼';
            toggleBtn.setAttribute('aria-label', this._t('fontLabel'));

            const dropdown = document.createElement('div');
            dropdown.className = 'customizer-font-dropdown';
            // Stick: alle Schriftproben auf gleiche sichtbare Groesse bringen, sobald
            // die Bilder geladen sind und die Liste sichtbar ist (Breite bekannt).
            const _angleichen = () => {
              if (fpSource.laser) return;
              const imgs = [...dropdown.querySelectorAll('img')];
              const w = dropdown.clientWidth - 40;
              if (w > 0) this._gleicheSchriftgroesse(imgs, w, 24);
            };
            _applyDropdownBg(dropdown, currentColorName());

            fonts.forEach(f => {
              const item = document.createElement('button');
              item.type = 'button';
              item.className = 'customizer-font-dropdown-item';
              item.setAttribute('data-font', f.name);
              item.setAttribute('title', f.name);
              if (f.name === currentFont) item.classList.add('is-selected');
              const img = document.createElement('img');
              img.alt = f.name;
              img.dataset.font = f.name;
              const itemUrl = previewUrl(f.name, currentColorName());
              if (itemUrl) { img.src = itemUrl; item.appendChild(img); }
              else { item.textContent = f.name; }  // no preview yet (font not preprocessed)
              item.addEventListener('click', () => {
                dropdown.querySelectorAll('.customizer-font-dropdown-item').forEach(s => s.classList.remove('is-selected'));
                item.classList.add('is-selected');
                { const u = previewUrl(f.name, currentColorName()); if (u) selImg.src = u; }
                selImg.alt = f.name;
                dropdown.classList.remove('is-open');
                applyFont(f.name);
              });
              dropdown.appendChild(item);
            });

            // Recolour selected + all dropdown previews to a yarn colour. Called
            // by the yarn-colour handler so the samples match the chosen colour.
            refreshFontPreviewsColor = (colorName) => {
              const fnNow = this.values[textRects[0].id].font;
              const su = previewUrl(fnNow, colorName);
              if (su) selImg.src = su;
              _applyPreviewBg(selected, colorName);
              // Die Liste wechselt die Hintergrundfarbe mit (hell → weiß,
              // hellfarbig → dunkel); die Einträge selbst bleiben transparent.
              _applyDropdownBg(dropdown, colorName);
              dropdown.querySelectorAll('.customizer-font-dropdown-item').forEach(el => {
                const im = el.querySelector('img');
                const u = previewUrl(el.getAttribute('data-font'), colorName);
                if (im && u) im.src = u;
              });
            };

            toggleBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              const open = dropdown.classList.toggle('is-open');
              if (open) {
                this._floatPanel(control, dropdown);
                // erst jetzt ist die Breite bekannt; noch ladende Bilder gleichen beim onload an
                _angleichen();
                dropdown.querySelectorAll('img').forEach(i => { if (!i.complete) i.onload = _angleichen; });
              }
            });
            document.addEventListener('click', () => dropdown.classList.remove('is-open'));

            control.appendChild(selected);
            control.appendChild(toggleBtn);
            control.appendChild(dropdown);
            fontRow.appendChild(control);
          } else {
            // Fallback: native select (previews not deployed yet)
            const fontSel = document.createElement('select');
            fontSel.className = 'customizer-font-select';
            fonts.forEach(f => {
              const o = document.createElement('option');
              o.value = f.name;
              o.textContent = f.name;
              fontSel.appendChild(o);
            });
            fontSel.value = this.values[textRects[0].id].font;
            fontSel.addEventListener('change', () => applyFont(fontSel.value));
            fontRow.appendChild(fontSel);
          }

          styleRow.appendChild(fontRow);
        }

        // Yarn colors (only for embroidery, not laser). Sind ALLE Textfelder der
        // Option Laser-Rechtecke, entfällt die Garnfarbe ganz (Gravur hat keine).
        const technique = opt.technique || 'embroidery';
        const allLaser = textRects.every(r => this._isLaserRect(r));
        const yarnColors = (technique !== 'laser' && !allLaser) ? (this.global.yarnColors || []) : [];
        if (yarnColors.length > 0) {
          const yarnRow = document.createElement('div');
          yarnRow.className = 'customizer-option-row';
          const yarnLbl = document.createElement('span');
          yarnLbl.className = 'customizer-option-label';
          yarnLbl.textContent = this._t('colorLabel');

          // Container for selected color + dropdown toggle
          const yarnControl = document.createElement('div');
          yarnControl.className = 'customizer-yarn-control';

          // Get current selected color
          const currentColor = this.values[textRects[0].id].color;
          const selectedYarn = yarnColors.find(y =>
            y.displayHex === currentColor || `#${y.hex}` === currentColor
          ) || yarnColors[0];

          // Selected color display
          const yarnSelected = document.createElement('div');
          yarnSelected.className = 'customizer-yarn-selected';
          if (selectedYarn.imageUrl) {
            yarnSelected.style.backgroundImage = `url('${selectedYarn.imageUrl}')`;
          } else {
            yarnSelected.style.backgroundColor = selectedYarn.displayHex || `#${selectedYarn.hex}`;
          }

          // Dropdown toggle button (down arrow)
          const toggleBtn = document.createElement('button');
          toggleBtn.type = 'button';
          toggleBtn.className = 'customizer-yarn-dropdown-toggle';
          toggleBtn.textContent = '▼';
          toggleBtn.setAttribute('aria-label', 'Farbe wählen');
          toggleBtn.setAttribute('title', 'Farbe wählen');

          // Dropdown menu
          const dropdown = document.createElement('div');
          dropdown.className = 'customizer-yarn-dropdown';

          yarnColors.forEach(yarn => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'customizer-yarn-dropdown-item';
            btn.setAttribute('data-color-name', yarn.name);
            btn.setAttribute('title', yarn.name);

            if (yarn.imageUrl) {
              btn.style.backgroundImage = `url('${yarn.imageUrl}')`;
              btn.style.backgroundSize = 'cover';
              btn.style.backgroundPosition = 'center';
            } else {
              btn.style.backgroundColor = yarn.displayHex || `#${yarn.hex}`;
            }

            if (yarn.displayHex === currentColor || `#${yarn.hex}` === currentColor) {
              btn.classList.add('is-selected');
            }

            btn.addEventListener('click', () => {
              // Update selected display
              yarnSelected.style.backgroundImage = yarn.imageUrl ? `url('${yarn.imageUrl}')` : '';
              yarnSelected.style.backgroundColor = yarn.imageUrl ? '' : (yarn.displayHex || `#${yarn.hex}`);

              // Update selected state in dropdown
              dropdown.querySelectorAll('.customizer-yarn-dropdown-item').forEach(s => s.classList.remove('is-selected'));
              btn.classList.add('is-selected');

              // Update values
              const rects = (useSameFont || opt.sameContent) ? textRects : [textRects[0]];
              rects.forEach(rect => {
                this.values[rect.id].color = yarn.displayHex || `#${yarn.hex}`;
                this.values[rect.id].colorName = yarn.name;
              });
              // Recolour the font-dropdown previews to match the chosen yarn.
              if (refreshFontPreviewsColor) refreshFontPreviewsColor(yarn.name);
              // A colour change re-generates the stitched image (colour is baked
              // into the PNG). sameContent → one generation shared to mirrors;
              // otherwise one per (independent) rect. Avoids duplicate backend calls.
              const toGen = opt.sameContent ? [textRects[0]] : rects;
              toGen.forEach(rect => {
                if (this._getRenderMode(rect) === 'stitched') this._scheduleStitch(rect);
                // Laser-Primär (Gravur hat keine Garnfarbe): nur seine Stick-Spiegel neu.
                else (this._mirrorCross[rect.id] || []).forEach(r => {
                  if (this._getRenderMode(r) === 'stitched') this._scheduleStitch(r);
                });
              });

              // Close dropdown
              dropdown.classList.remove('is-open');

              this.render(); // Render preview but DON'T update price (color doesn't affect cost)
            });

            dropdown.appendChild(btn);
          });

          // Toggle dropdown
          toggleBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            const open = dropdown.classList.toggle('is-open');
            if (open) this._floatPanel(yarnControl, dropdown);
          });

          // Close dropdown when clicking outside (with proper target checks)
          document.addEventListener('click', (e) => {
            if (!dropdown.classList.contains('is-open')) return;
            // Don't close if click was on toggle button or inside dropdown
            if (e.target === toggleBtn || toggleBtn.contains(e.target) || dropdown.contains(e.target)) return;
            dropdown.classList.remove('is-open');
          });

          yarnControl.appendChild(yarnSelected);
          yarnControl.appendChild(toggleBtn);
          yarnControl.appendChild(dropdown);

          yarnRow.appendChild(yarnLbl);
          yarnRow.appendChild(yarnControl);
          styleRow.appendChild(yarnRow);
        }

        if (styleRow.children.length) embroiderySection.appendChild(styleRow);
        container.appendChild(embroiderySection);
      }

      // Add non-text controls (images, etc) linked to this option
      (opt.rectIds || []).forEach((rid, index) => {
        const rect = allRects.find(r => r.id === rid);
        if (!rect || rect.type === 'text') return;
        const group = document.createElement('div');
        group.className      = 'customizer-control-group';
        group.dataset.rectId = rect.id;

        const label = document.createElement('div');
        label.className   = 'customizer-control-label';
        label.textContent = rect.label || `Bild ${index + 1}`;
        group.appendChild(label);

        if (rect.type === 'image') {
          group.appendChild(this._buildImageControl(rect));
        }

        container.appendChild(group);
      });
    }

    _buildYesNoControl(prompt, opt, inlineControls) {
      const choices = document.createElement('div');
      choices.className = 'customizer-option-choices';

      const noBtn  = document.createElement('button');
      const yesBtn = document.createElement('button');
      noBtn.type  = 'button';
      yesBtn.type = 'button';
      noBtn.className  = 'customizer-choice-btn is-no';
      yesBtn.className = 'customizer-choice-btn is-yes';
      noBtn.textContent = opt.noLabel || this._t('noThanks');
      yesBtn.textContent = opt.price > 0
        ? (opt.yesLabel || 'Ja, bitte!') + ' (+' + this._formatPrice(opt.price, opt.currency) + ')'
        : (opt.yesLabel || 'Ja, bitte!');

      const current = this.optionChoices[opt.id];
      if (current === 'no')  noBtn.classList.add('is-active');
      if (current === 'yes') yesBtn.classList.add('is-active');

      const update = (choice) => {
        this.optionChoices[opt.id] = choice;

        // Wird diese Option eingeschaltet, gehen die von ihr ausgeschlossenen aus.
        if (choice === 'yes') this._applyExclusions(opt);

        noBtn.classList.toggle('is-active',  choice === 'no');
        yesBtn.classList.toggle('is-active', choice === 'yes');
        if (choice === 'yes') {
          this._fillInlineControls(inlineControls, opt);
        } else {
          inlineControls.innerHTML = '';
        }
        // Surcharge fee lines are added at "In den Warenkorb" time (not on toggle),
        // so cancelling personalization never leaves orphaned fees in the cart.
        this._updatePriceDisplay();
        console.log('[Customizer] Calling buildControls() and render() now');
        this.buildControls();  // Rebuild controls to reflect exclusive group changes
        this.render();
        // Generate stitched previews ONLY when the toggled option actually owns a
        // text rectangle (a 2nd embroidery option becoming visible). A Motiv /
        // giftbox toggle owns no text, so it must never touch the text stitches.
        const ownsTextRect = (opt.rectIds || []).some(rid => {
          const r = this.activeRects().find(x => x.id === rid);
          return r && r.type === 'text';
        });
        if (ownsTextRect) this._generateAllStitches(opt);
        this.updateLineItemProperties();
      };

      noBtn.addEventListener('click',  () => update('no'));
      yesBtn.addEventListener('click', () => update('yes'));

      choices.appendChild(noBtn);
      choices.appendChild(yesBtn);
      prompt.appendChild(choices);
    }

    _buildGiftboxControl(prompt, opt, _inlineControls) {
      const container = document.createElement('div');
      container.className = 'customizer-giftbox-radios';

      const current = this.optionChoices[opt.id];
      const choices = opt.choices || [];

      choices.forEach((choice, idx) => {
        // Support both string and object (with price) formats
        const choiceName = typeof choice === 'object' ? choice.name : choice;
        const choicePrice = typeof choice === 'object' ? choice.price : 0;

        const label = document.createElement('label');
        label.className = 'customizer-giftbox-radio';

        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'giftbox-' + opt.id;
        radio.value = choiceName;
        radio.checked = (current === choiceName) || (idx === 0 && !current);

        const labelText = document.createElement('span');
        const priceText = choicePrice > 0
          ? ' (+' + this._formatPrice(choicePrice, opt.currency || 'EUR') + ')'
          : '';
        labelText.textContent = choiceName + priceText;

        label.appendChild(radio);
        label.appendChild(labelText);

        radio.addEventListener('change', () => {
          this.optionChoices[opt.id] = choiceName;

          // Auch eine Geschenkbox kann andere Optionen ausschließen. Vorher lief
          // der Ausschluss NUR über den Ja/Nein-Pfad — eine Geschenk-Auswahl hat
          // ihre Gegenoption also nie abgeschaltet.
          if (this._applyExclusions(opt)) {
            this.buildControls();
            this.render();
            this._updatePriceDisplay();
            this.updateLineItemProperties();
            return;
          }

          // Hervorhebung nachziehen — auch nach UNTEN: zurück auf „Nein" muss den
          // Kasten wieder entdunkeln, vorher wurde die Klasse nur je gesetzt.
          const optPrompt = radio.closest('.customizer-option-prompt');
          if (optPrompt) {
            optPrompt.classList.toggle('is-selected', this._isOptionActive(opt));
          }

          this._updatePriceDisplay();
          this.updateLineItemProperties();
        });

        container.appendChild(label);
      });

      prompt.appendChild(container);
    }

    // ── Cart add-on sync ──────────────────────────────────────────────────────
    // Entfernt: _syncCartAddon + opt.variantId. Aufpreise laufen seit dem
    // Verbund-Key-Modell über __customizerFeeVariants (typ|label|preis), die der
    // Push selbst anlegt — je bepreiste Option von Hand eine Variant-ID zu
    // pflegen war nur noch eine Fehlerquelle. Die Funktion hatte ohnehin keinen
    // Aufrufer mehr.

    _notifyCartChange() {
      // Fire common theme cart-refresh events
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:update', { bubbles: true }));
      // Fetch updated cart and fire a detail event (many themes listen for this)
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart }, bubbles: true }));
          // Update cart count badges used by most themes
          document.querySelectorAll('[data-cart-count],[data-cart-item-count]').forEach(el => {
            el.textContent = cart.item_count;
          });
        })
        .catch(() => {});
    }

    _formatPrice(price, currency) {
      const c = currency || 'EUR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency', currency: c
        }).format(price);
      } catch (_) {
        return price.toFixed(2) + ' ' + c;
      }
    }

    // ── Text control ──────────────────────────────────────────────────────────

    // Motif picker: a grid of the motifs enabled for this product's motif option.
    // Choosing one sets the option's rectangle(s) to that motif image, which the
    // canvas then renders (positioned/rotated by the rect) via _renderImage.
    _buildMotifPicker(container, opt) {
      const library = window.__customizerMotifs || {};
      const enabled = (opt.enabledMotifs || []).filter(n => library[n]);
      // Anzeige-Name = Motivname ohne den internen "M<Nr>-"-Präfix. Sortierung und
      // Label laufen über den sprechenden Namen, damit gleichartige Motive zusammen
      // stehen (alle "Babyfeet", alle "Regenbogen" …) statt nach Motivnummer. Der
      // interne Identifier `name` (z.B. "M200-Babyfeet-Hellblau") bleibt für Auswahl
      // und Line-Item-Property unverändert.
      const motifLabel = (n) => n.replace(/^M\d+[-_ ]*/i, '').replace(/[-_]+/g, ' ').trim() || n;
      const enabledSorted = enabled.slice().sort(
        (a, b) => motifLabel(a).localeCompare(motifLabel(b), 'de', { numeric: true }));
      const rects = (opt.rectIds || [])
        .map(rid => this.activeRects().find(r => r.id === rid))
        .filter(Boolean);

      if (!enabled.length || !rects.length) {
        const hint = document.createElement('p');
        hint.className = 'customizer-motif-hint';
        hint.textContent = !rects.length
          ? 'Kein Motiv-Platzhalter (Rechteck) für diese Option konfiguriert.'
          : 'Für dieses Produkt sind noch keine Motive freigeschaltet.';
        container.appendChild(hint);
        return;
      }

      const section = document.createElement('div');
      section.className = 'customizer-motif-section';

      // Searchable dropdown (hundreds of motifs): a trigger showing the selected
      // motif (image + name) and a panel with a search box + scrollable list.
      const dd = document.createElement('div');
      dd.className = 'customizer-motif-dropdown';

      const trigger  = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'customizer-motif-trigger';
      const trigImg   = document.createElement('img');
      trigImg.className = 'customizer-motif-trigger-img';
      trigImg.alt = '';
      const trigLabel = document.createElement('span');
      trigLabel.className = 'customizer-motif-trigger-label';
      const caret = document.createElement('span');
      caret.className = 'customizer-motif-caret';
      caret.textContent = '▼';
      trigger.append(trigImg, trigLabel, caret);

      const panel  = document.createElement('div');
      panel.className = 'customizer-motif-panel';
      const search = document.createElement('input');
      search.type = 'text';
      search.className = 'customizer-motif-search';
      search.placeholder = this._t('motifSearchPlaceholder');
      const list = document.createElement('div');
      list.className = 'customizer-motif-list';
      panel.append(search, list);

      dd.append(trigger, panel);
      section.appendChild(dd);
      container.appendChild(section);

      let currentName = (this.values[rects[0].id] && this.values[rects[0].id].imageName) || '';

      const setTrigger = (name) => {
        if (name) {
          trigImg.src = library[name]; trigImg.style.display = '';
          trigLabel.textContent = motifLabel(name);
          trigLabel.classList.remove('is-placeholder');
        } else {
          trigImg.removeAttribute('src'); trigImg.style.display = 'none';
          trigLabel.textContent = this._t('motifChoose');
          trigLabel.classList.add('is-placeholder');
        }
      };
      const closePanel = () => dd.classList.remove('is-open');

      const selectMotif = (name) => {
        currentName = name;
        rects.forEach(rect => { this.values[rect.id] = { type: 'image', imageUrl: library[name], imageName: name }; });
        setTrigger(name);
        list.querySelectorAll('.customizer-motif-option').forEach(x =>
          x.classList.toggle('is-selected', x.getAttribute('data-motif') === name));
        closePanel();
        this.render();
        this.updateLineItemProperties();
      };

      const optionEls = [];
      enabledSorted.forEach(name => {
        const row = document.createElement('button');
        row.type = 'button';
        row.className = 'customizer-motif-option' + (name === currentName ? ' is-selected' : '');
        row.setAttribute('data-motif', name);
        const img = document.createElement('img');
        img.src = library[name]; img.alt = name; img.loading = 'lazy';
        const span = document.createElement('span');
        span.textContent = motifLabel(name);
        row.append(img, span);
        row.addEventListener('click', () => selectMotif(name));
        list.appendChild(row);
        // Suchtext = Anzeige-Name + interner Name OHNE "M<Nr>-"-Präfix (sonst
        // beginnt JEDER Name mit "m" → Suche nach "m" filtert nichts).
        optionEls.push({ q: (motifLabel(name) + ' ' + name.replace(/^M\d+[-_ ]*/i, '')).toLowerCase(), el: row });
      });

      const filter = (q) => {
        q = (q || '').trim().toLowerCase();
        optionEls.forEach(o => { o.el.style.display = (!q || o.q.indexOf(q) !== -1) ? '' : 'none'; });
      };
      search.addEventListener('input', () => filter(search.value));

      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const open = dd.classList.toggle('is-open');
        if (open) {
          search.value = ''; filter('');
          this._floatPanel(trigger, panel, dd);
          const selEl = list.querySelector('.is-selected');
          if (selEl) selEl.scrollIntoView({ block: 'nearest' });
          search.focus();
        }
      });
      document.addEventListener('click', (e) => { if (!dd.contains(e.target)) closePanel(); });

      setTrigger(currentName);

      // Nothing chosen yet → preselect: the admin-configured default motif (if set
      // and enabled for this product), else the first when the option is mandatory.
      // Stays until the customer picks another.
      if (!currentName) {
        const def = (opt.defaultMotif && enabled.indexOf(opt.defaultMotif) !== -1)
          ? opt.defaultMotif
          : (opt.mandatory ? enabledSorted[0] : null);
        if (def) selectMotif(def);
      }
    }

    // Ein gemeinsamer Erklärtext je Option (Schlüssel: optionId + Art). Ohne
    // hintHost fällt es auf einen eigenen Kasten je Textfeld zurück — den Fall
    // gibt es noch für Rechtecke, die zu keiner Option gehören.
    _sharedHint(key, cls, host) {
      if (!this._hints) this._hints = {};
      let h = this._hints[key];
      // Bewusst KEIN isConnected-Test: der Abschnitt, in den der Hinweis gehängt
      // wird, hängt beim ersten Textfeld selbst noch nicht im Dokument — der Test
      // hätte für jedes weitere Feld einen zweiten Kasten erzeugt. Aufgeräumt wird
      // stattdessen am Anfang von _fillInlineControls bzw. buildControls.
      if (!h) {
        const el = document.createElement('div');
        el.className = cls;
        el.style.display = 'none';
        host.appendChild(el);
        h = this._hints[key] = { el, flags: {} };
      }
      return h;
    }

    // Zeigt den Text, sobald IRGENDEIN Textfeld der Option ihn braucht.
    _setSharedHint(h, rectId, on, text) {
      if (!h) return;
      h.flags[rectId] = !!on;
      const any = Object.keys(h.flags).some(k => h.flags[k]);
      if (any) h.el.textContent = text;
      h.el.style.display = any ? 'block' : 'none';
    }

    _buildTextControl(rect, mirrorRects, optId, hintHost) {
      const wrap = document.createElement('div');
      wrap.className = 'customizer-text-control';

      // Font-specific hint (above input) — pro Option, nicht pro Rechteck.
      const hint = this._sharedHint(
        (optId || rect.id) + ':s3', 'customizer-font-hint', hintHost || wrap);
      const info = this._sharedHint(
        (optId || rect.id) + ':case', 'customizer-font-warning', hintHost || wrap);
      info.el.style.color = '#00695c';

      const inputRow = document.createElement('div');
      inputRow.className = 'customizer-input-row';

      const input = document.createElement('input');
      input.type        = 'text';
      input.className   = 'customizer-text-input';
      // Rect-Id am Feld, damit die ATC-Pruefung ein leer gelassenes Pflichtfeld
      // anspringen und markieren kann (siehe _missingPersonalizationFields).
      input.dataset.rectId = rect.id;
      input.placeholder = rect.defaultText || this._t('textPlaceholder');
      input.value       = this.values[rect.id].text || '';
      if (rect.maxChars) input.maxLength = rect.maxChars;

      const counter = document.createElement('span');
      counter.className = 'customizer-char-counter';
      if (rect.maxChars) counter.textContent = `0 / ${rect.maxChars} ${this._t('charLimit')}`;

      // Unsupported character warning (below input)
      const warningEl = document.createElement('div');
      warningEl.className = 'customizer-font-warning';
      warningEl.style.display = 'none';

      const isStitch = this._usesBackendRender(rect);

      // Same-content: register the mirror group so ONE generated stitch image is
      // shared across all linked rects (no duplicate backend calls). Nur Rechtecke
      // GLEICHER Technik teilen ein PNG — ein Laser-Rechteck neben einem Stick-
      // Rechteck braucht sein eigenes (_mirrorCross, in _scheduleStitch).
      if (mirrorRects && mirrorRects.length > 1) {
        const laser = this._isLaserRect(rect);
        this._mirrorGroups[rect.id] = mirrorRects
          .filter(r => this._isLaserRect(r) === laser).map(r => r.id);
        const cross = mirrorRects.filter(r => this._isLaserRect(r) !== laser);
        if (cross.length) this._mirrorCross[rect.id] = cross;
      }

      const onChange = (initial) => {
        this.values[rect.id].text = input.value;

        // Same-content: copy text/font/colour into the mirror rects' values (so
        // they're saved). The stitch image itself is generated ONCE for this rect
        // and shared to the mirrors in _generateStitch — no extra backend calls.
        if (mirrorRects && mirrorRects.length > 1) {
          mirrorRects.forEach(mr => {
            if (mr.id === rect.id) return;
            const v = this.values[mr.id] || (this.values[mr.id] = { type: 'text', text: '' });
            v.text      = input.value;
            v.font      = this.values[rect.id].font;
            v.color     = this.values[rect.id].color;
            v.colorName = this.values[rect.id].colorName;
          });
        }

        const currentFont = this.values[rect.id].font || 'S9';

        // Nicht darstellbare Zeichen bleiben AM Feld — die Meldung nennt das
        // konkrete Zeichen, sie gehört neben die Eingabe, die es enthält.
        const fontCheck = this._checkFontSupport(currentFont, input.value, [rect]);
        if (!fontCheck.supported && input.value.length > 0) {
          const msg = this._t(fontCheck.laser ? 'unsupportedCharLaser' : 'unsupportedChar')
            .replace('{char}', fontCheck.firstChar)
            .replace('{fallback}', fontCheck.fallback);
          warningEl.textContent = msg;
          warningEl.style.color = '';                 // red (CSS default) = real error
          warningEl.style.display = 'block';
        } else {
          warningEl.style.display = 'none';
          warningEl.style.color = '';
        }

        // Schriftbezogene Erklärtexte: einmal je Option, egal wie viele Felder.
        this._setSharedHint(info, rect.id,
          fontCheck.supported && fontCheck.lowercased && input.value.length > 0,
          this._t('uppercaseLowercased'));
        this._setSharedHint(hint, rect.id,
          currentFont === 'S3' && this._fontSupportFor('S3', [rect])?.hint,
          this._t('s3Hint'));

        if (rect.maxChars) {
          const count = input.value.length;
          counter.textContent = `${count} / ${rect.maxChars} ${this._t('charLimit')}`;
          if (count > rect.maxChars) {
            counter.classList.add('customizer-char-warning');
            counter.setAttribute('title', this._t('charWarning'));
          } else {
            counter.classList.remove('customizer-char-warning');
            counter.removeAttribute('title');
          }
        }
        // Only a REAL change regenerates the stitch. The one-off initial call
        // (below, on every buildControls → every option toggle) must NOT, or
        // toggling any option re-renders the text. Real generation on activation
        // is done once by _generateAllStitches in the option's toggle handler.
        if (isStitch && !initial) this._scheduleStitch(rect);
        this.render();
        this.updateLineItemProperties();
      };

      // Wrap so the Event arg never leaks into onChange's `initial` param.
      input.addEventListener('input',  () => onChange());
      input.addEventListener('change', () => onChange());
      inputRow.appendChild(input);
      if (rect.maxChars) inputRow.appendChild(counter);
      wrap.appendChild(inputRow);
      wrap.appendChild(warningEl);

      // Status indicator for AI stitch generation
      if (isStitch) {
        const statusEl = document.createElement('span');
        statusEl.className = 'customizer-stitch-status';
        this._stitchStatusEls[rect.id] = statusEl;
        wrap.appendChild(statusEl);
      }

      // Expose a refresher so an external font change (the font dropdown's
      // applyFont) can re-run this input's char-support warning + S3 hint for the
      // new font. initial=true → no stitch reschedule (applyFont handles that).
      (this._textUIRefreshers || (this._textUIRefreshers = {}))[rect.id] = () => onChange(true);

      // Show the initial hint/counter, but pass initial=true so this does NOT
      // schedule a stitch regeneration (it runs on every rebuild / option toggle).
      onChange(true);

      return wrap;
    }

    // ── Image picker control ──────────────────────────────────────────────────

    _buildImageControl(rect) {
      const wrap   = document.createElement('div');
      wrap.className = 'customizer-image-control';
      const images = this.global.images || [];

      if (images.length === 0) {
        const msg = document.createElement('p');
        msg.className   = 'customizer-no-images';
        msg.textContent = this._t('noImages');
        wrap.appendChild(msg);
        return wrap;
      }

      const grid = document.createElement('div');
      grid.className = 'customizer-image-grid';

      const noneBtn = document.createElement('button');
      noneBtn.type      = 'button';
      noneBtn.className = 'customizer-image-option customizer-image-none is-active';
      noneBtn.textContent = '✕';
      noneBtn.title     = this._t('noImage');
      noneBtn.addEventListener('click', () => {
        grid.querySelectorAll('.customizer-image-option').forEach(b => b.classList.remove('is-active'));
        noneBtn.classList.add('is-active');
        this.values[rect.id].imageUrl  = null;
        this.values[rect.id].imageName = null;
        this.render();
        this.updateLineItemProperties();
      });
      grid.appendChild(noneBtn);

      images.forEach(imgDef => {
        const btn   = document.createElement('button');
        btn.type    = 'button';
        btn.className = 'customizer-image-option';
        btn.title   = imgDef.name || '';

        const imgEl   = document.createElement('img');
        imgEl.src     = imgDef.url;
        imgEl.alt     = imgDef.name || '';
        imgEl.loading = 'lazy';
        btn.appendChild(imgEl);

        if (imgDef.name) {
          const cap = document.createElement('span');
          cap.className   = 'customizer-image-caption';
          cap.textContent = imgDef.name;
          btn.appendChild(cap);
        }

        btn.addEventListener('click', () => {
          grid.querySelectorAll('.customizer-image-option').forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          this.values[rect.id].imageUrl  = imgDef.url;
          this.values[rect.id].imageName = imgDef.name || imgDef.url;
          this.render();
          this.updateLineItemProperties();
        });

        grid.appendChild(btn);
      });

      wrap.appendChild(grid);
      return wrap;
    }

    // ── Canvas rendering ──────────────────────────────────────────────────────

    render() {
      if (!this.image) return;
      const ctx = this.ctx;
      // Draw in LOGICAL (natural) coordinates, scaled up to the supersampled
      // backing store via a single transform. All rect coords below stay natural;
      // the higher backing resolution is what keeps the loupe crisp.
      const RES = this._res || 1;
      const W   = this._imgNaturalW || this.canvas.width;
      const H   = this._imgNaturalH || this.canvas.height;
      ctx.setTransform(RES, 0, 0, RES, 0, 0);
      ctx.clearRect(0, 0, W, H);
      ctx.drawImage(this.image, 0, 0, W, H);

      // Get rectangles that belong to ANY selected embroidery/laser option.
      // Use filter (not find) so a 2nd (or 3rd) embroidery option also renders —
      // find() only returned the first option's rects, hiding the rest.
      const visibleRectIds = new Set();
      this.options
        .filter(opt =>
          (opt.type === 'embroidery' || opt.type === 'laser' || opt.type === 'Motiv') &&
          this.optionChoices[opt.id] === 'yes'
        )
        .forEach(opt => (opt.rectIds || []).forEach(id => visibleRectIds.add(id)));

      this.activeRects().forEach(rect => {
        // Only render if no embroidery option is selected, or if this rect belongs to the selected option
        const shouldRender = visibleRectIds.size === 0 || visibleRectIds.has(rect.id);
        if (!shouldRender) return;

        const val = this.values[rect.id];
        if (!val) return;
        // A selected motif/image wins regardless of the rect's configured type,
        // so a motif option can be linked to any rectangle for positioning.
        if (val.imageUrl) {
          this._renderImage(rect, val);
        } else if (rect.type === 'text') {
          // Use customer text, this rect's default text, or (mirror secondary) the
          // primary's effective text — so a shared stitch renders before typing.
          const textToRender = this._effectiveText(rect);
          if (textToRender) {
            this._renderText(rect, { ...val, text: textToRender });
          }
        }
      });

      // Reset so anything reading/drawing this.ctx later isn't left scaled.
      ctx.setTransform(1, 0, 0, 1, 0, 0);
    }

    _renderText(rect, val) {
      const ctx      = this.ctx;
      const fontSize = this._fitFontSize(val.text, val.font, rect.width, rect.height);
      const cx       = rect.x + rect.width  / 2;
      const cy       = rect.y + rect.height / 2;
      const rot      = ((rect.rotation || 0) * Math.PI) / 180;

      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(rot);
      ctx.beginPath();
      ctx.rect(-rect.width / 2, -rect.height / 2, rect.width, rect.height);
      ctx.clip();

      ctx.font         = `bold ${fontSize}px "${val.font}"`;
      ctx.textAlign    = 'center';
      ctx.textBaseline = 'middle';
      ctx.globalAlpha  = 1;

      const mode = this._getRenderMode(rect);
      const realStitch = this._stitchImages[this._stitchCacheKey(rect)];

      if ((mode === 'stitched' || mode === 'engraved') && realStitch) {
        // Real embroidery / laser preview from the backend (transparent PNG).
        // ctx is already translated to rect centre + rotated + clipped to rect,
        // so draw the image centred and contain-fit within the rect.
        const sScale = Math.min(rect.width / realStitch.width, rect.height / realStitch.height);
        const dw = realStitch.width  * sScale;
        const dh = realStitch.height * sScale;
        // Gravur auf einer Trinkflasche: gewickelt auf den Zylinder zeichnen.
        // Nur Laser-Rechtecke mit Flaschenradius (cylinderRadius) machen das;
        // alles andere bleibt beim flachen contain-Fit.
        const R = Number(rect.cylinderRadius) || 0;
        if (mode === 'engraved' && R > 0) {
          this._drawCylinderWrapped(ctx, realStitch, dw, dh, R);
        } else {
          ctx.drawImage(realStitch, -dw / 2, -dh / 2, dw, dh);
        }
      } else if (mode === 'stitched') {
        // No real image yet (still generating) — synthetic satin placeholder.
        this._renderTextStitched(ctx, val.text, val.color || '#000000', fontSize, rect.width, rect.height);
      } else if (mode === 'engraved') {
        // Gravur-PNG lädt noch oder ist fehlgeschlagen — schlichter Stahlgrau-
        // Platzhalter (keine Garnfarbe), analog zum Satin-Platzhalter bei Stick.
        ctx.fillStyle = '#8a9099';
        ctx.fillText(val.text, 0, 0);
      } else if (mode === 'lasered') {
        this._renderTextLaser(ctx, val.text, fontSize);
      } else {
        // printed — clean solid fill
        ctx.fillStyle = val.color || '#000000';
        ctx.fillText(val.text, 0, 0);
      }

      ctx.restore();
    }

    // Gravur wie auf einen senkrechten Zylinder gewickelt zeichnen (Blick
    // frontal, Achse senkrecht). Das PNG wird in BOGENLÄNGE gefittet
    // (s ∈ [-dw/2, +dw/2] um die Flaschenachse = Rechteckmitte) und mit
    // x = R · sin(s / R) auf die x-Achse projiziert: die Ränder werden
    // gestaucht (Foreshortening), wie auf der echten Flasche.
    //
    // Canvas kann keine Zylinderprojektion in einem drawImage-Aufruf — das
    // Bild wird deshalb in schmale senkrechte Streifen zerlegt, deren Kanten
    // einzeln projiziert werden. ctx ist bereits auf die Rechteckmitte
    // verschoben, rotiert und auf das Rechteck geclippt.
    //
    // R = Radius der Flasche in Bildpixeln (gleiches Koordinatensystem wie
    // rect.x / rect.width).
    _drawCylinderWrapped(ctx, img, dw, dh, R) {
      const W = img.naturalWidth  || img.width;
      const H = img.naturalHeight || img.height;
      if (!W || !H || !(R > 0)) {
        ctx.drawImage(img, -dw / 2, -dh / 2, dw, dh);
        return;
      }

      // Nur der sichtbare Halbkreis (Blick frontal): Bogenlängen jenseits von
      // ±(π/2)·R liegen auf der Rückseite der Flasche und entfallen.
      const sLimit = Math.min(dw / 2, (Math.PI / 2) * R);
      const proj   = s => R * Math.sin(s / R);          // Bogenlänge → x
      // 1 Streifen je ~2 Ziel-Pixel, mindestens 60 — sonst bleiben an den
      // stark gestauchten Rändern sichtbare Treppen stehen.
      const n    = Math.max(60, Math.ceil((2 * proj(sLimit)) / 2));
      const step = (2 * sLimit) / n;                    // Bogenlänge je Streifen

      ctx.save();
      for (let i = 0; i < n; i++) {
        const s1 = -sLimit + i * step;
        const s2 = s1 + step;
        // Bogenlänge → Quellpixel: s = 0 liegt in der Bildmitte.
        const sx = ((s1 + dw / 2) / dw) * W;
        const sw = ((s2 - s1) / dw) * W;
        const x1 = proj(s1);
        const x2 = proj(s2) + 0.5;   // +0.5px Überlappung gegen Haarlinien
        // Zum Rand hin flacher sichtbar (Gravur schmiegt sich an die Wölbung).
        ctx.globalAlpha = 0.55 + 0.45 * Math.cos(((s1 + s2) / 2) / R);
        ctx.drawImage(img, sx, 0, sw, H, x1, -dh / 2, x2 - x1, dh);
      }
      ctx.globalAlpha = 1;
      ctx.restore();
    }

    // ── Render mode inference ─────────────────────────────────────────────────

    _getColorTranslations(colorName) {
      // Translations of yarn colors with country flags
      const translations = {
        braun:      { de: 'Braun', en: 'Brown', fr: 'Marron', it: 'Marrone', es: 'Marrón', nl: 'Bruin' },
        flieder:    { de: 'Flieder', en: 'Lilac', fr: 'Lilas', it: 'Lilla', es: 'Lila', nl: 'Lila' },
        gelb:       { de: 'Gelb', en: 'Yellow', fr: 'Jaune', it: 'Giallo', es: 'Amarillo', nl: 'Geel' },
        gold:       { de: 'Gold', en: 'Gold', fr: 'Or', it: 'Oro', es: 'Oro', nl: 'Goud' },
        grau:       { de: 'Grau', en: 'Gray', fr: 'Gris', it: 'Grigio', es: 'Gris', nl: 'Grijs' },
        gruen:      { de: 'Grün', en: 'Green', fr: 'Vert', it: 'Verde', es: 'Verde', nl: 'Groen' },
        hellblau:   { de: 'Hellblau', en: 'Light Blue', fr: 'Bleu Clair', it: 'Blu Chiaro', es: 'Azul Claro', nl: 'Lichtblauw' },
        lila:       { de: 'Lila', en: 'Purple', fr: 'Violet', it: 'Viola', es: 'Púrpura', nl: 'Paars' },
        mint:       { de: 'Mint', en: 'Mint', fr: 'Menthe', it: 'Menta', es: 'Menta', nl: 'Munt' },
        navy:       { de: 'Navy', en: 'Navy', fr: 'Marine', it: 'Marina', es: 'Azul Marino', nl: 'Marineblauw' },
        pink:       { de: 'Pink', en: 'Pink', fr: 'Rose', it: 'Rosa', es: 'Rosa', nl: 'Roze' },
        rosa:       { de: 'Rosa', en: 'Rose', fr: 'Rose', it: 'Rosa', es: 'Rosa', nl: 'Roos' },
        rot:        { de: 'Rot', en: 'Red', fr: 'Rouge', it: 'Rosso', es: 'Rojo', nl: 'Rood' },
        schwarz:    { de: 'Schwarz', en: 'Black', fr: 'Noir', it: 'Nero', es: 'Negro', nl: 'Zwart' },
        stone:      { de: 'Stone', en: 'Stone', fr: 'Pierre', it: 'Pietra', es: 'Piedra', nl: 'Steen' },
        weiss:      { de: 'Weiß', en: 'White', fr: 'Blanc', it: 'Bianco', es: 'Blanco', nl: 'Wit' }
      };

      const flags = {
        de: '🇩🇪',
        en: '🇬🇧',
        fr: '🇫🇷',
        it: '🇮🇹',
        es: '🇪🇸',
        nl: '🇳🇱'
      };

      const colorTrans = translations[colorName] || { de: colorName, en: colorName, fr: colorName, it: colorName, es: colorName, nl: colorName };
      const lines = Object.entries(colorTrans).map(([lang, text]) => `${flags[lang]} ${text}`);
      return lines.join('\n');
    }

    _getContrastColor(hexColor) {
      // Return black or white text based on background brightness
      const hex = hexColor.replace('#', '');
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 128 ? '#000000' : '#ffffff';
    }

    // Technik je Text-Rechteck (Admin „Technik: Stick / Laser"). Fehlt das
    // Feld, gilt Stick — so bleiben alle Bestands-Configs unverändert.
    _isLaserRect(rect) {
      return !!rect && rect.type === 'text' && rect.technique === 'laser';
    }

    // Material der Gravur: 'holz' = Laser in Holz, sonst polierter Edelstahl.
    _laserMaterial(rect) {
      const m = String((rect && rect.material) || '').trim().toLowerCase();
      return m === 'holz' ? 'holz' : 'stahl';
    }

    // Rect über die ID finden (Cache-Schlüssel brauchen das Material des Rects).
    _rectById(id) {
      return (this._allRects() || []).find(r => r.id === id) || null;
    }

    // Zwei Rechtecke teilen ein gerendertes Bild nur, wenn sie dasselbe
    // Material haben – ein Stahl-Bild auf einem Holz-Rechteck wäre falsch.
    _sameMaterial(idA, idB) {
      return this._laserMaterial(this._rectById(idA))
          === this._laserMaterial(this._rectById(idB));
    }

    // Cache-Schlüssel des gerenderten Bildes: je Material ein eigener Schlüssel,
    // damit Stahl und Holz sich nie teilen (auch nicht über Varianten hinweg –
    // dieselbe Rechteck-ID kann je Variante ein anderes Material haben).
    // 'stahl' ist die Vorgabe und behält den reinen Rechteck-ID.
    _stitchCacheKey(rect) {
      if (!this._isLaserRect(rect)) return rect.id;
      const mat = this._laserMaterial(rect);
      return mat === 'stahl' ? rect.id : rect.id + '@' + mat;
    }

    _stitchCacheKeyById(id) {
      const rect = this._rectById(id);
      return rect ? this._stitchCacheKey(rect) : id;
    }

    // „Nur Laser"-Produkt: ALLE Text-Rechtecke der Konfiguration – auch die
    // jeder Variante (variantOverrides) – sind Laser. Gemischt oder reiner
    // Stick → false, dann bleibt alles beim Stick (Vorschau, Zeichenprüfung).
    _isLaserOnlyProduct() {
      const textRects = [
        ...(this.config.rectangles || []),
        ...Object.values(this.config.variantOverrides || {}).flat(),
      ].filter(r => r && r.type === 'text');
      return textRects.length > 0 && textRects.every(r => this._isLaserRect(r));
    }

    // Bildquelle des Schrift-Dropdowns. Stick: vorab deployte gestickte
    // „Wunschtext"-Bilder je Garnfarbe (/deploy-font-previews). „Nur Laser":
    // ein Bild je Schrift, Gravur auf Lack (/push-assets), ohne Umfärbung.
    // Alle Text-Rechtecke des Produkts (Basis + jede Variante), die Laser sind.
    _allLaserRects() {
      return [...(this.config.rectangles || []),
              ...Object.values(this.config.variantOverrides || {}).flat()]
        .filter(r => this._isLaserRect(r));
    }

    // Laser-Kontext: für ein konkretes Namensfeld (rects) zählt nur dessen Technik –
    // im Set Rucksack + Flasche zeigt das Flaschenfeld Laser-, das Rucksackfeld
    // Stick-Schriften. Ohne rects: ganzes Produkt (wie bisher).
    _laserKontext(rects) {
      return (rects && rects.length) ? rects.every(r => this._isLaserRect(r)) : this._isLaserOnlyProduct();
    }

    _fontPreviewSource(rects) {
      if (this._laserKontext(rects)) {
        const fonts = (window.__customizerLaserFontPreviews || {}).fonts || {};
        // Gravur in Holz (Holzspielzeug): eigene Vorschauen „laser-font-preview-holz-S*.png"
        // (eingebrannt, transparent) statt Edelstahl auf Flaschenlack.
        const lr = (rects && rects.length) ? rects : this._allLaserRects();
        const holz = lr.length > 0 && lr.every(r => r.material === 'holz');
        const pick = (fontName) => {
          const u = fonts[fontName] || null;
          if (!u) return null;
          if (u.indexOf('laser-font-preview-tr-') !== -1) return u;
          // Gravur in Holz: eigene, eingebrannte Vorschauen. Stahl: die
          // transparente Variante („…-tr-…"), damit die Artikel-Farbe als
          // Hintergrund durchscheint.
          return (holz)
            ? u.replace('laser-font-preview-', 'laser-font-preview-holz-')
            : u.replace('laser-font-preview-', 'laser-font-preview-tr-');
        };
        return { laser: true, defaultColor: '', url: pick };
      }
      const fpMeta = window.__customizerFontPreviews || {};
      const previews = fpMeta.fonts || {};
      const defaultColor = fpMeta.defaultColor || 'rot';
      // Resolve a font's preview image for a yarn colour, with fallbacks:
      // chosen colour → default colour → any available. Tolerates the legacy
      // flat manifest (font -> url string) too.
      const url = (fontName, colorName) => {
        const byColor = previews[fontName];
        if (!byColor) return null;
        if (typeof byColor === 'string') return byColor;
        return byColor[colorName] || byColor[defaultColor]
               || byColor[Object.keys(byColor)[0]] || null;
      };
      return { laser: false, defaultColor, url };
    }

    // ── Farben: Garn, Artikel-Farbe, Kontrast ───────────────────────────────

    // Hex-Wert einer Garnfarbe (leer, wenn die Farbe unbekannt ist).
    _yarnHexFor(colorName) {
      const yarnColors = (this.global && this.global.yarnColors) || [];
      const y = yarnColors.find(v => v && v.name === colorName);
      if (!y) return '';
      return y.displayHex || (y.hex ? '#' + y.hex : '');
    }

    // Helle Garnfarbe? (Wahrnehmungsleuchtdichte > 155) – helle Garne sind auf
    // hellem Grund kaum sichtbar.
    _isLightColor(colorName) {
      const hex = this._yarnHexFor(colorName).replace('#', '');
      if (!/^[0-9a-f]{6}$/i.test(hex)) return false;
      const r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b = parseInt(hex.slice(4, 6), 16);
      return (0.299 * r + 0.587 * g + 0.114 * b) > 155;   // perceived luminance
    }

    // Relative Luminanz (WCAG) einer Hex-Farbe: 0 = schwarz, 1 = weiß.
    _relativeLuminance(hex) {
      const h = String(hex || '').replace('#', '').trim();
      if (!/^[0-9a-f]{6}$/i.test(h)) return null;
      const ch = (v) => {
        const s = v / 255;
        return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
      };
      return 0.2126 * ch(parseInt(h.slice(0, 2), 16))
           + 0.7152 * ch(parseInt(h.slice(2, 4), 16))
           + 0.0722 * ch(parseInt(h.slice(4, 6), 16));
    }

    // Geschätzte Schriftfarbe (Kontrastpartner) zum Hintergrund: Stick → die
    // gewählte Garnfarbe; Laser auf Stahl → hell; Laser in Holz → dunkel.
    _schriftFarbe(rects, colorName) {
      if (this._laserKontext(rects)) {
        const lr = (rects && rects.length) ? rects : this._allLaserRects();
        const holz = lr.length > 0 && lr.every(r => this._laserMaterial(r) === 'holz');
        return holz ? '#000000' : '#ffffff';
      }
      return this._yarnHexFor(colorName) || '#000000';
    }

    // Ist die Schrift hell? (Stick: die Garnfarbe; Laser Stahl: hell;
    // Laser Holz: dunkel) – davon hängt ab, in welche Richtung der Hintergrund
    // verschoben wird.
    _schriftIstHell(rects, colorName) {
      if (this._laserKontext(rects)) {
        const lr = (rects && rects.length) ? rects : this._allLaserRects();
        const holz = lr.length > 0 && lr.every(r => this._laserMaterial(r) === 'holz');
        return !holz;
      }
      return this._isLightColor(colorName);
    }

    // Hintergrund gegen die Schriftfarbe verschieben, bis beide sich deutlich
    // unterscheiden: helle Schrift → Hintergrund abdunkeln (höchstens 45 %),
    // dunkle Schrift → Hintergrund aufhellen (in kleinen Schritten Richtung
    // Weiß). Ziel ist eine Luminanzdifferenz von mindestens 0.35.
    _mitKontrast(bgHex, fontHex, fontHell = null) {
      const bg = this._relativeLuminance(bgHex);
      const fg = this._relativeLuminance(fontHex);
      if (bg === null || fg === null) return bgHex;
      if (Math.abs(bg - fg) >= 0.35) return bgHex;
      // Richtung: in die Gegenrichtung der Schrift. Ohne Angabe entscheidet die
      // Helligkeit der Schrift selbst (ab Luminanz 0.5 = hell).
      const hell = (fontHell === null || fontHell === undefined) ? fg >= 0.5 : !!fontHell;
      const abdunkeln = hell;
      const h = String(bgHex).replace('#', '');
      const rgb = [0, 2, 4].map(i => parseInt(h.slice(i, i + 2), 16));
      const toHex = (c) => '#' + c.map(v => Math.max(0, Math.min(255, v)).toString(16).padStart(2, '0')).join('');
      const schritte = abdunkeln ? 9 : 20;
      let last = bgHex;
      for (let step = 1; step <= schritte; step++) {
        const f = step / schritte;
        const neu = abdunkeln
          ? rgb.map(c => Math.round(c * (1 - 0.45 * f)))    // abdunkeln (max. 45 %)
          : rgb.map(c => Math.round(c + (255 - c) * f));     // aufhellen
        const hex = toHex(neu);
        last = hex;
        if (Math.abs(this._relativeLuminance(hex) - fg) >= 0.35) return hex;
      }
      return last;
    }

    // ── Artikel-Farbe: die Farbe des Produkts rund um den Textbereich ───────
    // Mittlere Farbe im Ring UM das erste Rechteck der Liste (Streifen von 15 %
    // der Rechteckhöhe ober- und unterhalb, ganze Rechteckbreite). Dient als
    // Hintergrund der Schrift-Vorschauen (Liste + geschlossenes Feld), damit
    // die Probe auf der Farbe des Artikels liegt.
    // Erstes Text-Rechteck der aktuellen Variante (Hauptartikel eines Sets).
    _hauptTextRects() {
      const r = (this._allRects() || []).find(x => x.type === 'text');
      return r ? [r] : null;
    }

    // Stick-Vorschauen: Anteil der Kleinbuchstaben-Hoehe an der Bildhoehe je Schrift
    // (gemessen im Vorschaubild selbst: dichtestes Tintenband im Wortteil „…text“). Damit wirken alle Schriften gleich gross –
    // S3 & Co. erschienen sonst deutlich kleiner.
    static get STICK_XHOEHE() { return {"S1": 0.43, "S2": 0.554, "S3": 0.425, "S4": 0.485, "S5": 0.329, "S6": 0.377, "S7": 0.437, "S8": 0.403, "S9": 0.687, "S10": 0.488}; }

    // Bilder einer Schriftliste auf gleiche Kleinbuchstaben-Hoehe bringen: Ziel-Hoehe X
    // so waehlen, dass das breiteste Bild noch in die Liste passt (hoechstens maxX px).
    _gleicheSchriftgroesse(imgs, breite, maxX) {
      const Q = Customizer.STICK_XHOEHE;
      const ok = imgs.filter(i => i.naturalWidth && i.naturalHeight);
      if (!ok.length || !breite) return;
      let X = maxX;
      ok.forEach(i => {
        const q = Q[i.dataset.font] || 0.65;
        X = Math.min(X, breite * q * i.naturalHeight / i.naturalWidth);
      });
      ok.forEach(i => {
        const q = Q[i.dataset.font] || 0.65;
        i.style.maxHeight = 'none';
        i.style.maxWidth = 'none';
        i.style.width = 'auto';
        i.style.height = (X / q).toFixed(1) + 'px';
      });
    }

    _artikelFarbe(rects) {
      const rect = Array.isArray(rects) ? rects[0] : rects;
      if (!rect || !this.image) return null;
      const img = this.image;
      const key = [
        this.previewUrl || img.src || '',
        rect.id || '',
        Math.round(rect.x || 0), Math.round(rect.y || 0),
        Math.round(rect.width || 0), Math.round(rect.height || 0),
      ].join('|');
      if (!this._artikelFarbeCache) this._artikelFarbeCache = new Map();
      if (this._artikelFarbeCache.has(key)) return this._artikelFarbeCache.get(key);
      let farbe = null;
      try {
        farbe = this._artikelFarbeBerechnen(img, rect);
      } catch (e) {
        farbe = null;          // z. B. kein Zugriff auf die Bild-Pixel
      }
      this._artikelFarbeCache.set(key, farbe);
      return farbe;
    }

    // Pixel aus dem Produktbild lesen und den Median je Kanal bilden.
    _artikelFarbeBerechnen(img, rect) {
      const W = img.naturalWidth || img.width || 0;
      const H = img.naturalHeight || img.height || 0;
      if (!W || !H) return null;
      const x0 = Math.round(rect.x || 0);
      const y0 = Math.round(rect.y || 0);
      const w  = Math.round(rect.width || 0);
      const h  = Math.round(rect.height || 0);
      if (w <= 0 || h <= 0) return null;
      const band = Math.max(1, Math.round(h * 0.15));   // Ringbreite
      const rx = Math.max(0, x0);
      const rw = Math.min(W, x0 + w) - rx;
      if (rw <= 0) return null;
      // Ring: Streifen ober- und unterhalb des Rechtecks (ganze Breite)
      const streifen = [];
      const obenH = Math.min(y0, band);
      if (obenH > 0) streifen.push({ y: Math.max(0, y0 - band), h: obenH });
      const untenH = Math.min(H, y0 + h + band) - (y0 + h);
      if (untenH > 0) streifen.push({ y: y0 + h, h: untenH });
      if (!streifen.length) return null;

      const canvas = document.createElement('canvas');
      canvas.width  = W;
      canvas.height = H;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      if (!ctx) return null;
      ctx.drawImage(img, 0, 0);

      const rs = [], gs = [], bs = [];
      for (const s of streifen) {
        let data;
        try {
          data = ctx.getImageData(rx, s.y, rw, s.h).data;
        } catch (e) {
          return null;         // Bild nicht CORS-frei → keine Artikel-Farbe
        }
        for (let i = 0; i + 3 < data.length; i += 4) {
          const r = data[i], g = data[i + 1], b = data[i + 2];
          if (r > 245 && g > 245 && b > 245) continue;   // sehr helles Reinweiß
          if (r < 10 && g < 10 && b < 10) continue;      // sehr dunkel (Schatten)
          rs.push(r); gs.push(g); bs.push(b);
        }
      }
      if (!rs.length) return null;
      const median = (arr) => {
        const a = arr.slice().sort((x, y) => x - y);
        const m = a.length >> 1;
        return a.length % 2 ? a[m] : Math.round((a[m - 1] + a[m]) / 2);
      };
      const rgb = [median(rs), median(gs), median(bs)];
      return '#' + rgb.map(v => Math.max(0, Math.min(255, v)).toString(16).padStart(2, '0')).join('');
    }

    // Modi, deren Vorschau als echtes PNG vom Backend kommt (Stick:
    // render-stitch-text, Laser-Rechteck: render-laser-text).
    _usesBackendRender(rect) {
      const mode = this._getRenderMode(rect);
      return mode === 'stitched' || mode === 'engraved';
    }

    _getRenderMode(rect) {
      // Laser-Rechteck: echte Gravur-Vorschau vom Backend ('engraved'). Gilt
      // vor der Options-Technik, weil sie am Rechteck ausdrücklich gesetzt ist.
      if (this._isLaserRect(rect)) return 'engraved';
      // The owning option's technique WINS over the rect's stored renderMode:
      // a rect assigned to an embroidery/laser option must render stitched/
      // lasered even if it kept a stale renderMode ("printed") from before it
      // was linked to that option. (This is why a 2nd embroidery option whose
      // rects were "printed" showed flat text / nothing instead of stitching.)
      for (const opt of this.options) {
        if ((opt.rectIds || []).includes(rect.id)) {
          if (opt.type === 'embroidery') return 'stitched';
          if (opt.type === 'laser')      return 'lasered';
        }
      }
      if (rect.renderMode) return rect.renderMode;
      return 'printed';
    }

    // ── Embroidery/stitched text — clean live preview ─────────────────────────

    _renderTextStitched(ctx, text, color, fontSize, rectWidth, rectHeight) {
      // Offscreen canvas sized to the rect — avoids needing getTransform().
      // ctx is already translated to rect centre and rotated, so we draw the
      // finished stitch image at (-rw/2, -rh/2) to position it correctly.
      const rw = Math.ceil(rectWidth), rh = Math.ceil(rectHeight);
      const oc = document.createElement('canvas');
      oc.width = rw; oc.height = rh;
      const ox = oc.getContext('2d');

      // 1. Text silhouette as alpha mask, centred in the offscreen rect
      ox.font         = ctx.font;
      ox.textAlign    = 'center';
      ox.textBaseline = 'middle';
      ox.fillStyle    = '#000';
      ox.fillText(text, rw / 2, rh / 2);

      // 2. Satin-stitch fill lines clipped to the silhouette
      ox.globalCompositeOperation = 'source-in';
      const lh   = Math.max(1, rh / 30);
      const dark = this._shadeColor(color, -40);
      for (let y = lh / 2; y < rh; y += lh) {
        ox.strokeStyle = (Math.round(y / lh) % 4 === 0) ? dark : color;
        ox.lineWidth   = lh;
        ox.beginPath(); ox.moveTo(0, y); ox.lineTo(rw, y); ox.stroke();
      }

      // 3. Dark outline for thread-edge definition
      ox.globalCompositeOperation = 'source-over';
      ox.font         = ctx.font;
      ox.textAlign    = 'center';
      ox.textBaseline = 'middle';
      ox.strokeStyle  = this._shadeColor(color, -60);
      ox.lineWidth    = Math.max(0.5, fontSize * 0.025);
      ox.lineJoin     = 'round';
      ox.strokeText(text, rw / 2, rh / 2);

      // 4. Draw onto main canvas — ctx origin is already at rect centre
      ctx.drawImage(oc, -rw / 2, -rh / 2);
    }

    // ── Auto stitch generation (debounced) ───────────────────────────────────

    // The text to actually render for a rect: the customer's input, or the
    // rect's default text when they haven't typed anything yet. This lets the
    // preview show the default embroidery on load, before any input.
    // The mirror-group PRIMARY (key) for a rect id, or the id itself if it isn't
    // a secondary. Secondaries share the primary's stitch image AND its text.
    _mirrorPrimaryId(rectId) {
      const groups = this._mirrorGroups || {};
      for (const primary in groups) {
        if (primary !== rectId && (groups[primary] || []).indexOf(rectId) !== -1) return primary;
      }
      // Andere Technik, gleicher Text: erbt nur den TEXT (eigenes PNG).
      const cross = this._mirrorCross || {};
      for (const primary in cross) {
        if ((cross[primary] || []).some(r => r.id === rectId)) return primary;
      }
      return rectId;
    }

    _effectiveText(rect) {
      const typed = (this.values[rect.id] && this.values[rect.id].text || '').trim();
      if (typed) return typed;
      // Mirror secondary with no own text: inherit the primary's text (typed or
      // its defaultText), so the shared stitch renders on activation / colour /
      // font change — before the customer has typed anything.
      const primaryId = this._mirrorPrimaryId(rect.id);
      if (primaryId !== rect.id) {
        const pTyped = (this.values[primaryId] && this.values[primaryId].text || '').trim();
        if (pTyped) return pTyped;
        const primaryRect = this.activeRects().find(r => r.id === primaryId);
        if (primaryRect && (primaryRect.defaultText || '').trim()) return primaryRect.defaultText.trim();
      }
      return (rect.defaultText || '').trim();
    }

    _scheduleStitch(rect) {
      // Invalidate cached image so canvas falls back to plain text immediately
      delete this._stitchImages[this._stitchCacheKey(rect)];
      (this._mirrorGroups[rect.id] || []).forEach(id =>
        delete this._stitchImages[this._stitchCacheKeyById(id)]);
      this.render();

      // Cancel any pending timer and abort an in-flight request
      clearTimeout(this._stitchTimers[rect.id]);
      if (this._stitchAborts[rect.id]) {
        this._stitchAborts[rect.id].abort();
        delete this._stitchAborts[rect.id];
      }

      const statusEl = this._stitchStatusEls[rect.id];
      if (statusEl) { statusEl.textContent = ''; statusEl.className = 'customizer-stitch-status'; }

      // Gleicher Text, andere Technik: eigenes PNG, gleich mit anstoßen. Die
      // Cross-Rechtecke sind nie selbst Schlüssel in _mirrorCross → keine Schleife.
      (this._mirrorCross[rect.id] || [])
        .filter(r => this._usesBackendRender(r))
        .forEach(r => this._scheduleStitch(r));

      if (!this._effectiveText(rect)) return;

      // Start the debounce (kept short so the preview updates responsively)
      this._stitchTimers[rect.id] = setTimeout(() => this._generateStitch(rect), 900);
    }

    // Generate stitched previews for every visible stitch rect right away, using
    // each rect's effective text (default text on load). No debounce — this runs
    // on start and when defaults change, not on every keystroke.
    // Generate missing stitch images. Pass an option to scope to that option's
    // rects only — toggling a Motiv/giftbox option must NOT touch text stitches.
    _generateAllStitches(opt) {
      // When called from a specific option's toggle, scope strictly to THAT
      // option's rects — even if it has none (e.g. a Motiv option), so toggling
      // it never regenerates unrelated text stitches. Only the no-arg call
      // (initial load / variant change) generates across all rects.
      const scope = opt ? new Set(opt.rectIds || []) : null;
      // Secondary mirror rects are filled by their primary's shared image — never
      // generate them independently (that caused a duplicate render and a race
      // where each rect used its own default text). Ausnahme: ein Spiegel mit
      // anderem Material (Stahl/Metall) braucht sein eigenes Bild.
      const secondaries = new Set();
      Object.entries(this._mirrorGroups).forEach(([primary, ids]) =>
        ids.forEach(id => {
          if (id !== primary && this._sameMaterial(primary, id)) secondaries.add(id);
        }));
      this.activeRects().forEach(rect => {
        if (scope && !scope.has(rect.id)) return;
        if (secondaries.has(rect.id)) return;
        if (rect.type !== 'text') return;
        if (!this._usesBackendRender(rect)) return;
        if (!this._effectiveText(rect)) return;
        // Skip rects that already have a current cached image (the cache is
        // invalidated on text/colour/font change, so a present image is fresh).
        if (this._stitchImages[this._stitchCacheKey(rect)]) return;
        this._generateStitch(rect);
      });
    }

    async _generateStitch(rect) {
      const val = this.values[rect.id];
      const text = this._effectiveText(rect);
      if (!text) return;

      const isLaser  = this._isLaserRect(rect);
      const statusEl = this._stitchStatusEls[rect.id];
      if (statusEl) {
        statusEl.textContent = this._t(isLaser ? 'laserGenerating' : 'stitchGenerating');
        statusEl.className   = 'customizer-stitch-status is-loading';
      }

      const controller = new AbortController();
      this._stitchAborts[rect.id] = controller;

      // Laser: transparente, eng beschnittene Gravur (polierter Edelstahl oder –
      // bei material 'holz' – eingebrannt in Holz). Keine Garnfarbe — die
      // Gravur hat keine.
      const laserBody = {
        text:       text,
        font:       (val && val.font) || 'S1',
        height:     this._laserRenderHeight(rect),
        background: 'none',
      };
      // Nur bei Holz das Material mitschicken; sonst bleibt es beim Default
      // des Backends (Stahl).
      if (isLaser && this._laserMaterial(rect) === 'holz') laserBody.material = 'holz';

      try {
        if (!this.apiUrl) throw new Error('Backend-URL nicht konfiguriert (Global-Tab im Admin)');

        const res = isLaser
          ? await fetch(this.apiUrl + '/api/customizer/render-laser-text', {
              method:  'POST',
              headers: { 'Content-Type': 'application/json' },
              body:    JSON.stringify(laserBody),
              signal: controller.signal,
            })
          // Try new stitched text library first (from fontConverter)
          : await fetch(this.apiUrl + '/api/customizer/render-stitch-text', {
              method:  'POST',
              headers: { 'Content-Type': 'application/json' },
              body:    JSON.stringify({
                text:         text,
                font:         (val && val.font) || 'S1',
                // Backend needs the yarn NAME (e.g. "gold") to find glyph PNGs —
                // val.color is a hex and yields a blank image. Fall back to gold.
                color:        (val && val.colorName) || 'gold',
                spacing:      undefined,  // use default from spacing_config.json
                space_spacing: undefined,
              }),
              signal: controller.signal,
            });
        if (!res.ok) throw new Error(`API ${res.status}: ` + await res.text().catch(() => ''));

        // New endpoint returns PNG blob, not JSON
        const pngBlob = await res.blob();
        const blobUrl = URL.createObjectURL(pngBlob);
        const img = await this._loadImage(blobUrl);

        this._stitchImages[this._stitchCacheKey(rect)] = img;
        // Same-content: share this one image with all mirror rects (identical
        // text/font/colour) instead of generating it again for each – aber nur
        // mit gleichem Material (Stahl-Bild ≠ Holz-Bild).
        (this._mirrorGroups[rect.id] || []).forEach(id => {
          if (this._sameMaterial(rect.id, id)) {
            this._stitchImages[this._stitchCacheKeyById(id)] = img;
          }
        });
        delete this._stitchAborts[rect.id];

        if (statusEl) {
          statusEl.textContent = this._t('stitchReady');
          statusEl.className   = 'customizer-stitch-status is-done';
        }
        this.render();

      } catch (err) {
        if (err.name === 'AbortError') return; // user typed again — silently discard
        console.error('[Customizer] stitch generation failed:', err);
        if (statusEl) {
          statusEl.textContent = this._t('stitchError') + ' (' + err.message + ')';
          statusEl.className   = 'customizer-stitch-status is-error';
        }
      }
    }

    // Pixelhöhe des Gravur-PNGs: Rechteckhöhe × devicePixelRatio, begrenzt auf
    // den Bereich, den render-laser-text annimmt (24–1200, sonst HTTP 400).
    _laserRenderHeight(rect) {
      const dpr = window.devicePixelRatio || 1;
      const h   = Math.round((Number(rect.height) || 0) * dpr);
      return Math.max(24, Math.min(1200, h || 300));
    }

    _renderStitchImage(rect, img) {
      const cx  = rect.x + rect.width  / 2;
      const cy  = rect.y + rect.height / 2;
      const rot = ((rect.rotation || 0) * Math.PI) / 180;
      const rw  = rect.width;
      const rh  = rect.height;
      const s   = Math.min(rw / img.width, rh / img.height);
      const dw  = img.width  * s;
      const dh  = img.height * s;

      const ctx = this.ctx;
      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(rot);
      ctx.beginPath();
      ctx.rect(-rw / 2, -rh / 2, rw, rh);
      ctx.clip();
      const R = Number(rect.cylinderRadius) || 0;
      if (this._getRenderMode(rect) === 'engraved' && R > 0) {
        this._drawCylinderWrapped(ctx, img, dw, dh, R);
      } else {
        ctx.drawImage(img, -dw / 2, -dh / 2, dw, dh);
      }
      ctx.restore();
    }

    // ── Embroidery preview popup (AI-powered) ────────────────────────────────

    async _showEmbroideryPreview(rect, val) {
      if (!val || !val.text || !this.image) return;

      // Build and show modal immediately with spinner
      const overlay = document.createElement('div');
      overlay.className = 'cust-pv-overlay';
      overlay.innerHTML =
        '<div class="cust-pv-modal">' +
          '<div class="cust-pv-header">' +
            '<span>Stickerei-Vorschau</span>' +
            '<button class="cust-pv-close" type="button">&times;</button>' +
          '</div>' +
          '<div class="cust-pv-body">' +
            '<canvas class="cust-pv-canvas" style="display:none"></canvas>' +
            '<div class="cust-pv-loading">' +
              '<div class="cust-pv-spinner"></div>' +
              '<p>KI generiert Stickerei-Vorschau…<br><small>Das dauert ca. 10–15 Sekunden.</small></p>' +
            '</div>' +
            '<div class="cust-pv-error" style="display:none"></div>' +
          '</div>' +
          '<p class="cust-pv-hint">KI-generierte Näherungsdarstellung – tatsächliche Stickerei kann abweichen.</p>' +
        '</div>';

      document.body.appendChild(overlay);

      const close = () => overlay.remove();
      overlay.querySelector('.cust-pv-close').addEventListener('click', close);
      overlay.addEventListener('click', e => { if (e.target === overlay) close(); });

      const loadingEl = overlay.querySelector('.cust-pv-loading');
      const errorEl   = overlay.querySelector('.cust-pv-error');
      const canvas    = overlay.querySelector('.cust-pv-canvas');

      try {
        // Call backend to render stitched text image (from fontConverter library)
        const res = await fetch(this.apiUrl + '/api/customizer/render-stitch-text', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({
            text:         val.text,
            font:         val.font || 'S1',
            // Backend needs the yarn NAME (e.g. "gold"), not the hex.
            color:        val.colorName || 'gold',
            spacing:      undefined,  // use default from spacing_config.json
            space_spacing: undefined,
          }),
        });
        if (!res.ok) {
          const msg = await res.text();
          throw new Error(`API-Fehler ${res.status}: ` + msg);
        }

        // New endpoint returns PNG blob directly, not JSON
        const pngBlob = await res.blob();
        const blobUrl = URL.createObjectURL(pngBlob);
        const stitchImg = await this._loadImage(blobUrl);
        loadingEl.style.display = 'none';
        canvas.style.display    = 'block';
        this._renderPreviewCanvas(canvas, rect, val, stitchImg);

      } catch (err) {
        loadingEl.style.display = 'none';
        errorEl.style.display   = 'block';
        errorEl.textContent     = this._t('error') + ' ' + err.message;
      }
    }

    // White-background removal — uses max channel deviation from white (255,255,255)
    // Remove background color from an AI-generated image, then tight-crop to content.
    // bgColor: '#ffffff' (white bg) or '#000000' (dark bg for light-colored text).
    _removeBg(url, bgColor) {
      const br = parseInt(bgColor.slice(1, 3), 16);
      const bg = parseInt(bgColor.slice(3, 5), 16);
      const bb = parseInt(bgColor.slice(5, 7), 16);
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          const mc  = document.createElement('canvas');
          mc.width  = img.width;
          mc.height = img.height;
          const ctx = mc.getContext('2d');
          ctx.drawImage(img, 0, 0);

          const id = ctx.getImageData(0, 0, mc.width, mc.height);
          const d  = id.data;
          // deviation from the background color — hard cut < 25, feather 25–60
          for (let i = 0; i < d.length; i += 4) {
            const dev = Math.max(Math.abs(d[i]-br), Math.abs(d[i+1]-bg), Math.abs(d[i+2]-bb));
            if (dev < 25) {
              d[i + 3] = 0;
            } else if (dev < 60) {
              d[i + 3] = Math.round((dev - 25) / 35 * 255);
            }
          }
          ctx.putImageData(id, 0, 0);

          // Tight-crop to non-transparent pixels so the text fills the rect
          // the same way the plain-text canvas placeholder does.
          let minX = mc.width, maxX = 0, minY = mc.height, maxY = 0;
          for (let i = 0; i < d.length; i += 4) {
            if (d[i + 3] > 10) {
              const px = (i / 4) % mc.width;
              const py = Math.floor((i / 4) / mc.width);
              if (px < minX) minX = px;
              if (px > maxX) maxX = px;
              if (py < minY) minY = py;
              if (py > maxY) maxY = py;
            }
          }
          if (maxX > minX && maxY > minY) {
            const pad = Math.round((maxX - minX) * 0.05);
            minX = Math.max(0, minX - pad);
            minY = Math.max(0, minY - pad);
            maxX = Math.min(mc.width  - 1, maxX + pad);
            maxY = Math.min(mc.height - 1, maxY + pad);
            const cw = maxX - minX + 1;
            const ch = maxY - minY + 1;
            const cropped = document.createElement('canvas');
            cropped.width  = cw;
            cropped.height = ch;
            cropped.getContext('2d').drawImage(mc, minX, minY, cw, ch, 0, 0, cw, ch);
            resolve(cropped.toDataURL('image/png'));
          } else {
            resolve(mc.toDataURL('image/png'));
          }
        };
        img.onerror = reject;
        img.src     = url;
      });
    }

    _loadImage(src) {
      return new Promise((resolve, reject) => {
        const img    = new Image();
        img.onload   = () => resolve(img);
        img.onerror  = reject;
        img.src      = src;
      });
    }

    _renderPreviewCanvas(canvas, rect, val, stitchImg) {
      const imgW  = this.image.naturalWidth;
      const imgH  = this.image.naturalHeight;
      const maxW  = Math.min(640, window.innerWidth - 48);
      const scale = maxW / imgW;
      const W = Math.round(imgW * scale);
      const H = Math.round(imgH * scale);
      canvas.width  = W;
      canvas.height = H;
      canvas.style.width  = W + 'px';
      canvas.style.height = H + 'px';

      const ctx = canvas.getContext('2d');
      ctx.drawImage(this.image, 0, 0, W, H);

      const rx  = rect.x      * scale;
      const ry  = rect.y      * scale;
      const rw  = rect.width  * scale;
      const rh  = rect.height * scale;
      const cx  = rx + rw / 2;
      const cy  = ry + rh / 2;
      const rot = ((rect.rotation || 0) * Math.PI) / 180;

      if (stitchImg) {
        // Scale the AI stitch image (1024×1024) to fill the rect, contain-fit.
        // Transparent BG means only the thread pixels are visible.
        const sScale = Math.min(rw / stitchImg.width, rh / stitchImg.height);
        const dw = stitchImg.width  * sScale;
        const dh = stitchImg.height * sScale;

        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(rot);
        ctx.beginPath();
        ctx.rect(-rw / 2, -rh / 2, rw, rh);
        ctx.clip();
        // Gleiche Zylinder-Projektion wie in _renderText — Radius skaliert mit
        // dem Vorschau-Faktor (scale), damit Vorschau und Kundenbild gleich
        // aussehen.
        const R = (Number(rect.cylinderRadius) || 0) * scale;
        if (R > 0) {
          this._drawCylinderWrapped(ctx, stitchImg, dw, dh, R);
        } else {
          ctx.drawImage(stitchImg, -dw / 2, -dh / 2, dw, dh);
        }
        ctx.restore();
      }

      // Stitch-border decoration
      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(rot);
      this._drawStitchBorder(ctx, -rw / 2, -rh / 2, rw, rh, val.color || '#ffffff');
      ctx.restore();
    }

    _drawStitchBorder(ctx, bx, by, bw, bh, color) {
      // Draw small × cross-stitch marks along the rectangle border
      const spacing = Math.max(9, Math.min(18, bw / 7));
      const sz      = Math.max(2, spacing * 0.28);
      const dark    = this._shadeColor(color, -45);

      ctx.save();
      ctx.globalAlpha = 0.48;
      ctx.strokeStyle = dark;
      ctx.lineWidth   = 1;
      ctx.lineCap     = 'round';

      const cross = (px, py) => {
        ctx.beginPath();
        ctx.moveTo(px - sz, py - sz); ctx.lineTo(px + sz, py + sz);
        ctx.moveTo(px + sz, py - sz); ctx.lineTo(px - sz, py + sz);
        ctx.stroke();
      };

      for (let x = bx + spacing; x < bx + bw - spacing / 2; x += spacing) {
        cross(x, by);
        cross(x, by + bh);
      }
      for (let y = by + spacing; y < by + bh - spacing / 2; y += spacing) {
        cross(bx, y);
        cross(bx + bw, y);
      }

      ctx.restore();
    }

    // ── Laser engraving text effect ───────────────────────────────────────────

    _renderTextLaser(ctx, text, fontSize) {
      const burnDark  = '#2a1200';
      const burnWarm  = '#7a3500';

      // 1. Heat glow
      ctx.save();
      ctx.shadowColor  = burnWarm;
      ctx.shadowBlur   = Math.max(3, fontSize * 0.10);
      ctx.globalAlpha  = 0.22;
      ctx.fillStyle    = burnWarm;
      ctx.fillText(text, 0, 0);
      ctx.restore();

      // 2. Engraved fill
      ctx.globalAlpha = 0.88;
      ctx.fillStyle   = burnDark;
      ctx.fillText(text, 0, 0);

      // 3. Precision edge
      ctx.save();
      ctx.globalAlpha  = 0.40;
      ctx.strokeStyle  = '#100800';
      ctx.lineWidth    = 0.4;
      ctx.strokeText(text, 0, 0);
      ctx.restore();

      ctx.globalAlpha = 1;
    }

    // ── Color hex → English name for Replicate prompt ────────────────────────

    _colorName(hex) {
      const map = {
        '#ffffff':'white','#f5f5f5':'off-white','#000000':'black',
        '#ff0000':'red','#cc0000':'dark red','#8b0000':'deep red',
        '#00cc00':'green','#006400':'dark green','#008000':'forest green',
        '#0000ff':'blue','#00008b':'dark blue','#000080':'navy blue',
        '#ffff00':'yellow','#ffd700':'gold','#ffa500':'orange',
        '#ff8c00':'dark orange','#ff69b4':'hot pink','#ffc0cb':'pink',
        '#800080':'purple','#40e0d0':'turquoise','#808080':'gray',
        '#c0c0c0':'silver','#d2691e':'chocolate brown','#8b4513':'saddle brown',
      };
      return map[(hex || '#ffffff').toLowerCase()] || ('color ' + hex);
    }

    // ── i18n helper ──────────────────────────────────────────────────────────

    _t(key) {
      const lang = (document.documentElement.lang || 'de').split('-')[0];
      const map = {
        de: {
          noExtraCharge: '(kein Aufpreis)',
          noThanks: 'Nein, danke',
          missingFields: 'Du hast eine Option aktiviert, dass wir den Artikel mit einem Wunschnamen oder Wunschtext personalisieren sollen, hast aber keinen Text eingegeben. Bitte gib einen Text ein oder klicke bei der entsprechenden Option auf „Nein, danke".',
          confirmNoPerso: 'Du hast keine Personalisierungsoption ausgewählt. Bist du sicher, dass du das Produkt ohne Personalisierung bestellen möchtest?',
          confirmNoPersoGo: 'Ja, ohne Personalisierung bestellen',
          confirmNoPersoBack: 'Nein, zurück',
          confirmTextGone: 'Du hast keine Personalisierungsoption für den Text ausgewählt, aber bereits einen Wunschtext eingegeben: „{text}". Bist du sicher, dass du das Produkt trotzdem OHNE WUNSCHTEXT bestellen möchtest?',
          confirmTextGoneGo: 'Ja, ohne Wunschtext bestellen',
          confirmTextGoneBack: 'Nein, zurück',
          textPlaceholder: 'Ihren Text eingeben…',
          fontLabel: 'Schriftart:',
          colorLabel: 'Farbe:',
          allSameStyle: 'Alle Texte verwenden die gleiche Schrift und Farbe',
          noImages: 'Keine Bilder verfügbar.',
          noImage: 'Kein Bild',
          priceTotal: 'Aufpreis gesamt:',
          priceTotalAmount: 'Aufpreis gesamt: +',
          charLimit: '/ Zeichen',
          charWarning: 'Zu viele Zeichen',
          embroideryPreview: 'Stickerei-Vorschau',
          stitchGenerating: '⏳ Stickerei wird generiert…',
          laserGenerating: '⏳ Gravur wird erstellt…',
          stitchReady: '✓ Vorschau bereit',
          stitchError: '⚠ Vorschau fehlgeschlagen',
          error: 'Fehler:',
          unsupportedChar: 'Leider kann diese Schriftart der Stickmaschine das Zeichen "{char}" nicht darstellen. Bitte versuche es mit einer anderen Schriftart oder verwende dieses Zeichen nicht.',
          unsupportedCharLaser: 'Diese Gravur-Schrift kann das Zeichen "{char}" leider nicht darstellen. Bitte versuche es mit einer anderen Schriftart oder verwende dieses Zeichen nicht.',
          uppercaseLowercased: 'Diese Schriftart hat keine Großbuchstaben – sie werden als Kleinbuchstaben gestickt.',
          s3Hint: 'Nur Schriftart S3: gib einen Unterstrich "_" ein um ein Herz in deinen Wunschtext einzufügen!',
          soldOut: 'Ausverkauft',
          personalizeBtn: 'Personalisieren',
          atcWithoutPerso: 'Ohne Personalisierung in den Warenkorb',
          addToCartBtn: 'In den Warenkorb',
          addToCartBusy: 'Wird hinzugefügt…',
          cancelBtn: 'Abbrechen',
          zoomHint: 'Fahre mit der Maus über das Bild zum Vergrößern!',
          variantHeading: 'Wähle deine Lieblingsfarbe:',
          motifSearchPlaceholder: 'Motiv suchen…',
          motifChoose: 'Motiv wählen…',
          continueShopping: 'Weiter Shoppen',
          toCart: 'Zum Warenkorb',
          atcLoading: 'Toll gemacht! Dein Produkt wird jetzt in den Warenkorb gelegt. Das dauert einen kleinen Moment. Bitte etwas Geduld ...',
          atcDone: 'Fertig! Dein Produkt liegt im Warenkorb. 🎉',
          atcError: 'Da ist leider etwas schiefgelaufen. Bitte versuche es noch einmal.',
        },
        en: {
          personalizeBtn: 'Personalize',
          atcWithoutPerso: 'Add to cart without personalization',
          addToCartBtn: 'Add to cart',
          addToCartBusy: 'Adding…',
          cancelBtn: 'Cancel',
          zoomHint: 'Hover over the image to zoom in!',
          variantHeading: 'Choose your favourite colour:',
          motifSearchPlaceholder: 'Search motif…',
          motifChoose: 'Choose a motif…',
          continueShopping: 'Continue shopping',
          toCart: 'To cart',
          atcLoading: 'Nicely done! Your product is being added to the cart. This takes a brief moment. Please be patient ...',
          atcDone: 'Done! Your product is in the cart. 🎉',
          atcError: 'Something went wrong. Please try again.',
          noExtraCharge: '(no extra charge)',
          noThanks: 'No, thanks',
          missingFields: 'You have selected an option for us to personalise this item with a name or text of your choice, but you have not entered any text. Please enter a text, or click "No, thanks" on that option.',
          confirmNoPerso: 'You have not selected any personalisation option. Are you sure you want to order this product without personalisation?',
          confirmNoPersoGo: 'Yes, order without personalisation',
          confirmNoPersoBack: 'No, go back',
          confirmTextGone: 'You have not selected a text personalisation option, but you have already entered a text: "{text}". Are you sure you want to order this product WITHOUT YOUR TEXT?',
          confirmTextGoneGo: 'Yes, order without my text',
          confirmTextGoneBack: 'No, go back',
          textPlaceholder: 'Enter your text…',
          fontLabel: 'Font:',
          colorLabel: 'Colour:',
          allSameStyle: 'All texts use the same font and color',
          noImages: 'No images available.',
          noImage: 'No image',
          priceTotal: 'Total extra charge:',
          priceTotalAmount: 'Total extra charge: +',
          charLimit: '/ characters',
          charWarning: 'Too many characters',
          embroideryPreview: 'Embroidery preview',
          stitchGenerating: '⏳ Generating embroidery…',
          laserGenerating: '⏳ Generating engraving…',
          stitchReady: '✓ Preview ready',
          stitchError: '⚠ Preview failed',
          error: 'Error:',
          unsupportedChar: 'Unfortunately, this embroidery machine\'s font cannot display the character "{char}". Please try a different font or leave this character out.',
          unsupportedCharLaser: 'Unfortunately, this engraving font cannot display the character "{char}". Please try a different font or leave this character out.',
          uppercaseLowercased: 'This font has no capital letters – they are stitched as lowercase.',
          s3Hint: 'Font S3 only: Enter an underscore "_" to add a heart to your custom text!',
          soldOut: 'Sold out',
        },
        fr: {
          noExtraCharge: '(sans supplément)',
          noThanks: 'Non, merci',
          missingFields: 'Vous avez activé une option pour que nous personnalisions l\'article avec un prénom ou un texte de votre choix, mais vous n\'avez saisi aucun texte. Veuillez saisir un texte ou cliquer sur « Non, merci » pour cette option.',
          confirmNoPerso: 'Vous n\'avez sélectionné aucune option de personnalisation. Êtes-vous sûr de vouloir commander ce produit sans personnalisation ?',
          confirmNoPersoGo: 'Oui, commander sans personnalisation',
          confirmNoPersoBack: 'Non, retour',
          confirmTextGone: 'Vous n\'avez sélectionné aucune option de personnalisation du texte, mais vous avez déjà saisi un texte : « {text} ». Êtes-vous sûr de vouloir commander ce produit SANS VOTRE TEXTE ?',
          confirmTextGoneGo: 'Oui, commander sans mon texte',
          confirmTextGoneBack: 'Non, retour',
          textPlaceholder: 'Entrez votre texte…',
          fontLabel: 'Police :',
          colorLabel: 'Couleur :',
          allSameStyle: 'Tous les textes utilisent la même police et couleur',
          noImages: 'Aucune image disponible.',
          noImage: 'Pas d\'image',
          priceTotal: 'Supplément total:',
          priceTotalAmount: 'Supplément total: +',
          charLimit: '/ caractères',
          charWarning: 'Trop de caractères',
          embroideryPreview: 'Aperçu broderie',
          stitchGenerating: '⏳ Génération en cours…',
          laserGenerating: '⏳ Génération de la gravure…',
          stitchReady: '✓ Aperçu prêt',
          stitchError: '⚠ Échec aperçu',
          error: 'Erreur:',
          unsupportedChar: 'Malheureusement, cette police de machine à broder ne peut pas afficher le caractère « {char} ». Veuillez essayer une autre police ou ne pas utiliser ce caractère.',
          unsupportedCharLaser: 'Malheureusement, cette police de gravure ne peut pas afficher le caractère « {char} ». Veuillez essayer une autre police ou ne pas utiliser ce caractère.',
          uppercaseLowercased: 'Cette police n\'a pas de majuscules – elles sont brodées en minuscules.',
          s3Hint: 'Police S3 uniquement : entrez un tiret bas « _ » pour ajouter un cœur à votre texte personnalisé !',
          soldOut: 'Épuisé',
        },
        it: {
          noExtraCharge: '(nessun supplemento)',
          noThanks: 'No, grazie',
          missingFields: 'Hai attivato un\'opzione per personalizzare l\'articolo con un nome o un testo a tua scelta, ma non hai inserito alcun testo. Inserisci un testo oppure clicca su «No, grazie» in quell\'opzione.',
          confirmNoPerso: 'Non hai selezionato alcuna opzione di personalizzazione. Sei sicuro di voler ordinare il prodotto senza personalizzazione?',
          confirmNoPersoGo: 'Sì, ordina senza personalizzazione',
          confirmNoPersoBack: 'No, indietro',
          confirmTextGone: 'Non hai selezionato alcuna opzione di personalizzazione del testo, ma hai già inserito un testo: «{text}». Sei sicuro di voler ordinare il prodotto SENZA IL TUO TESTO?',
          confirmTextGoneGo: 'Sì, ordina senza il mio testo',
          confirmTextGoneBack: 'No, indietro',
          textPlaceholder: 'Inserisci il tuo testo…',
          fontLabel: 'Carattere:',
          colorLabel: 'Colore:',
          allSameStyle: 'Tutti i testi utilizzano lo stesso carattere e colore',
          noImages: 'Nessuna immagine disponibile.',
          noImage: 'Nessuna immagine',
          priceTotal: 'Supplemento totale:',
          priceTotalAmount: 'Supplemento totale: +',
          charLimit: '/ caratteri',
          charWarning: 'Troppi caratteri',
          embroideryPreview: 'Anteprima ricamo',
          stitchGenerating: '⏳ Generazione ricamo…',
          laserGenerating: '⏳ Generazione incisione…',
          stitchReady: '✓ Anteprima pronta',
          stitchError: '⚠ Anteprima non riuscita',
          error: 'Errore:',
          unsupportedChar: 'Purtroppo, il carattere di questa macchina per ricamo non può visualizzare il carattere "{char}". Prova un altro carattere o non utilizzare questo carattere.',
          unsupportedCharLaser: 'Purtroppo questo carattere per incisione non può visualizzare il carattere "{char}". Prova un altro carattere o non utilizzare questo carattere.',
          uppercaseLowercased: 'Questo carattere non ha lettere maiuscole – vengono ricamate in minuscolo.',
          s3Hint: 'Solo carattere S3: inserisci un trattino basso "_" per aggiungere un cuore al tuo testo personalizzato!',
          soldOut: 'Esaurito',
        },
        es: {
          noExtraCharge: '(sin cargo adicional)',
          noThanks: 'No, gracias',
          missingFields: 'Has activado una opción para que personalicemos el artículo con un nombre o un texto a tu elección, pero no has introducido ningún texto. Introduce un texto o haz clic en «No, gracias» en esa opción.',
          confirmNoPerso: 'No has seleccionado ninguna opción de personalización. ¿Seguro que quieres pedir el producto sin personalización?',
          confirmNoPersoGo: 'Sí, pedir sin personalización',
          confirmNoPersoBack: 'No, volver',
          confirmTextGone: 'No has seleccionado ninguna opción de personalización de texto, pero ya has introducido un texto: «{text}». ¿Seguro que quieres pedir el producto SIN TU TEXTO?',
          confirmTextGoneGo: 'Sí, pedir sin mi texto',
          confirmTextGoneBack: 'No, volver',
          textPlaceholder: 'Ingresa tu texto…',
          fontLabel: 'Fuente:',
          colorLabel: 'Color:',
          allSameStyle: 'Todos los textos utilizan la misma fuente y color',
          noImages: 'No hay imágenes disponibles.',
          noImage: 'Sin imagen',
          priceTotal: 'Cargo adicional total:',
          priceTotalAmount: 'Cargo adicional total: +',
          charLimit: '/ caracteres',
          charWarning: 'Demasiados caracteres',
          embroideryPreview: 'Vista previa de bordado',
          stitchGenerating: '⏳ Generando bordado…',
          laserGenerating: '⏳ Generando grabado…',
          stitchReady: '✓ Vista previa lista',
          stitchError: '⚠ Vista previa fallida',
          error: 'Error:',
          unsupportedChar: 'Desafortunadamente, la fuente de esta máquina de bordar no puede mostrar el carácter "{char}". Intenta con otra fuente o no uses este carácter.',
          unsupportedCharLaser: 'Desafortunadamente, esta fuente de grabado no puede mostrar el carácter "{char}". Intenta con otra fuente o no uses este carácter.',
          uppercaseLowercased: 'Esta fuente no tiene mayúsculas – se bordan en minúsculas.',
          s3Hint: '¡Solo fuente S3: ingresa un guion bajo "_" para agregar un corazón a tu texto personalizado!',
          soldOut: 'Agotado',
        },
        nl: {
          noExtraCharge: '(geen meerprijs)',
          noThanks: 'Nee, dank u wel',
          missingFields: 'Je hebt een optie aangezet om het artikel te personaliseren met een naam of tekst naar keuze, maar je hebt geen tekst ingevuld. Vul een tekst in of klik bij die optie op \'Nee, dank u wel\'.',
          confirmNoPerso: 'Je hebt geen personalisatie-optie gekozen. Weet je zeker dat je het product zonder personalisatie wilt bestellen?',
          confirmNoPersoGo: 'Ja, zonder personalisatie bestellen',
          confirmNoPersoBack: 'Nee, terug',
          confirmTextGone: 'Je hebt geen tekstpersonalisatie gekozen, maar wel al een tekst ingevuld: \'{text}\'. Weet je zeker dat je het product ZONDER JOUW TEKST wilt bestellen?',
          confirmTextGoneGo: 'Ja, zonder mijn tekst bestellen',
          confirmTextGoneBack: 'Nee, terug',
          textPlaceholder: 'Voer uw tekst in…',
          fontLabel: 'Lettertype:',
          colorLabel: 'Kleur:',
          allSameStyle: 'Alle teksten gebruiken hetzelfde lettertype en dezelfde kleur',
          noImages: 'Geen afbeeldingen beschikbaar.',
          noImage: 'Geen afbeelding',
          priceTotal: 'Totale bijzondere kosten:',
          priceTotalAmount: 'Totale bijzondere kosten: +',
          charLimit: '/ tekens',
          charWarning: 'Te veel tekens',
          embroideryPreview: 'Borduurwerk voorbeeld',
          stitchGenerating: '⏳ Borduurwerk genereren…',
          laserGenerating: '⏳ Gravure genereren…',
          stitchReady: '✓ Voorbeeld klaar',
          stitchError: '⚠ Voorbeeld mislukt',
          error: 'Fout:',
          unsupportedChar: 'Helaas kan dit borduurlettertype het teken "{char}" niet weergeven. Probeer een ander lettertype of gebruik dit teken niet.',
          unsupportedCharLaser: 'Helaas kan dit graveerlettertype het teken "{char}" niet weergeven. Probeer een ander lettertype of gebruik dit teken niet.',
          uppercaseLowercased: 'Dit lettertype heeft geen hoofdletters – ze worden als kleine letters geborduurd.',
          s3Hint: 'Alleen lettertype S3: voer een onderstrepingsteken "_" in om een hartje aan uw aangepaste tekst toe te voegen!',
          soldOut: 'Uitverkocht',
        },
        pl: {
          noExtraCharge: '(bez opłaty dodatkowej)',
          noThanks: 'Nie, dziękuję',
          missingFields: 'Włączono opcję personalizacji artykułu wybranym imieniem lub tekstem, ale nie wpisano żadnego tekstu. Wpisz tekst lub kliknij „Nie, dziękuję" przy tej opcji.',
          confirmNoPerso: 'Nie wybrano żadnej opcji personalizacji. Czy na pewno chcesz zamówić produkt bez personalizacji?',
          confirmNoPersoGo: 'Tak, zamów bez personalizacji',
          confirmNoPersoBack: 'Nie, wróć',
          confirmTextGone: 'Nie wybrano opcji personalizacji tekstu, ale wpisano już tekst: „{text}". Czy na pewno chcesz zamówić produkt BEZ SWOJEGO TEKSTU?',
          confirmTextGoneGo: 'Tak, zamów bez mojego tekstu',
          confirmTextGoneBack: 'Nie, wróć',
          textPlaceholder: 'Wpisz swój tekst…',
          fontLabel: 'Czcionka:',
          colorLabel: 'Kolor:',
          allSameStyle: 'Wszystkie teksty używają tej samej czcionki i koloru',
          noImages: 'Brak dostępnych obrazów.',
          noImage: 'Brak obrazu',
          priceTotal: 'Całkowita opłata dodatkowa:',
          priceTotalAmount: 'Całkowita opłata dodatkowa: +',
          charLimit: '/ znaków',
          charWarning: 'Za dużo znaków',
          embroideryPreview: 'Podgląd haftowania',
          stitchGenerating: '⏳ Generowanie haftowania…',
          laserGenerating: '⏳ Generowanie grawerunku…',
          stitchReady: '✓ Podgląd gotowy',
          stitchError: '⚠ Podgląd nie powiódł się',
          error: 'Błąd:',
          unsupportedChar: 'Niestety, czcionka tej maszyny do haftu nie może wyświetlić znaku "{char}". Spróbuj innej czcionki lub nie używaj tego znaku.',
          unsupportedCharLaser: 'Niestety, ta czcionka do grawerowania nie może wyświetlić znaku "{char}". Spróbuj innej czcionki lub nie używaj tego znaku.',
          uppercaseLowercased: 'Ta czcionka nie ma wielkich liter – są haftowane jako małe litery.',
          s3Hint: 'Tylko czcionka S3: wpisz znak podkreślenia "_", aby dodać serce do niestandardowego tekstu!',
          soldOut: 'Wyprzedane',
        },
        sv: {
          noExtraCharge: '(ingen extra avgift)',
          noThanks: 'Nej, tack',
          missingFields: 'Du har valt ett alternativ där vi personaliserar artikeln med ett namn eller en text, men du har inte angett någon text. Ange en text eller klicka på ”Nej, tack” vid det alternativet.',
          confirmNoPerso: 'Du har inte valt något personaliseringsalternativ. Är du säker på att du vill beställa produkten utan personalisering?',
          confirmNoPersoGo: 'Ja, beställ utan personalisering',
          confirmNoPersoBack: 'Nej, tillbaka',
          confirmTextGone: 'Du har inte valt något alternativ för textpersonalisering, men har redan angett en text: ”{text}”. Är du säker på att du vill beställa produkten UTAN DIN TEXT?',
          confirmTextGoneGo: 'Ja, beställ utan min text',
          confirmTextGoneBack: 'Nej, tillbaka',
          textPlaceholder: 'Ange din text…',
          fontLabel: 'Teckensnitt:',
          colorLabel: 'Färg:',
          allSameStyle: 'All text använder samma teckensnitt och färg',
          noImages: 'Inga bilder tillgängliga.',
          noImage: 'Ingen bild',
          priceTotal: 'Total extrakostnad:',
          priceTotalAmount: 'Total extrakostnad: +',
          charLimit: '/ tecken',
          charWarning: 'För många tecken',
          embroideryPreview: 'Förhandsgranskning av broderi',
          stitchGenerating: '⏳ Genererar broderi…',
          laserGenerating: '⏳ Genererar gravyr…',
          stitchReady: '✓ Förhandsgranskning klar',
          stitchError: '⚠ Förhandsgranskning misslyckades',
          error: 'Fel:',
          unsupportedChar: 'Tyvärr kan detta broderisteckensnitt inte visa tecknet "{char}". Prova ett annat teckensnitt eller använd inte detta tecken.',
          unsupportedCharLaser: 'Tyvärr kan detta graveringsteckensnitt inte visa tecknet "{char}". Prova ett annat teckensnitt eller använd inte detta tecken.',
          uppercaseLowercased: 'Det här teckensnittet saknar versaler – de broderas som gemener.',
          s3Hint: 'Endast teckensnitt S3: ange ett understreck "_" för att lägga till ett hjärta i din anpassade text!',
          soldOut: 'Slutsåld',
        },
        da: {
          noExtraCharge: '(ingen ekstra omkostninger)',
          noThanks: 'Nej tak',
          missingFields: 'Du har valgt en mulighed, hvor vi personaliserer varen med et navn eller en tekst, men du har ikke indtastet nogen tekst. Indtast en tekst, eller klik på „Nej tak" ved den pågældende mulighed.',
          confirmNoPerso: 'Du har ikke valgt nogen personaliseringsmulighed. Er du sikker på, at du vil bestille produktet uden personalisering?',
          confirmNoPersoGo: 'Ja, bestil uden personalisering',
          confirmNoPersoBack: 'Nej, tilbage',
          confirmTextGone: 'Du har ikke valgt en mulighed for tekstpersonalisering, men har allerede indtastet en tekst: „{text}". Er du sikker på, at du vil bestille produktet UDEN DIN TEKST?',
          confirmTextGoneGo: 'Ja, bestil uden min tekst',
          confirmTextGoneBack: 'Nej, tilbage',
          textPlaceholder: 'Indtast din tekst…',
          fontLabel: 'Skrifttype:',
          colorLabel: 'Farve:',
          allSameStyle: 'Al tekst bruger samme skrifttype og farve',
          noImages: 'Ingen billeder tilgængelige.',
          noImage: 'Intet billede',
          priceTotal: 'Samlet ekstra gebyr:',
          priceTotalAmount: 'Samlet ekstra gebyr: +',
          charLimit: '/ tegn',
          charWarning: 'For mange tegn',
          embroideryPreview: 'Broderiforhåndsvisning',
          stitchGenerating: '⏳ Genererer broderi…',
          laserGenerating: '⏳ Genererer gravering…',
          stitchReady: '✓ Forhåndsvisning klar',
          stitchError: '⚠ Forhåndsvisning mislykkedes',
          error: 'Fejl:',
          unsupportedChar: 'Desværre kan denne broderskriftstype ikke vise tegnet "{char}". Prøv en anden skrifttype eller undlad at bruge dette tegn.',
          unsupportedCharLaser: 'Desværre kan denne graveringsskrifttype ikke vise tegnet "{char}". Prøv en anden skrifttype eller undlad at bruge dette tegn.',
          uppercaseLowercased: 'Denne skrifttype har ikke store bogstaver – de broderes som små bogstaver.',
          s3Hint: 'Kun skrifttype S3: indtast en understregning "_" for at tilføje et hjerte til din tilpassede tekst!',
          soldOut: 'Udsolgt',
        },
        pt: {
          noExtraCharge: '(sem custo adicional)',
          noThanks: 'Não, obrigado',
          missingFields: 'Ativou uma opção para personalizarmos o artigo com um nome ou texto à sua escolha, mas não introduziu qualquer texto. Introduza um texto ou clique em «Não, obrigado» nessa opção.',
          confirmNoPerso: 'Não selecionou nenhuma opção de personalização. Tem a certeza de que quer encomendar o produto sem personalização?',
          confirmNoPersoGo: 'Sim, encomendar sem personalização',
          confirmNoPersoBack: 'Não, voltar',
          confirmTextGone: 'Não selecionou nenhuma opção de personalização de texto, mas já introduziu um texto: «{text}». Tem a certeza de que quer encomendar o produto SEM O SEU TEXTO?',
          confirmTextGoneGo: 'Sim, encomendar sem o meu texto',
          confirmTextGoneBack: 'Não, voltar',
          textPlaceholder: 'Digite seu texto…',
          fontLabel: 'Fonte:',
          colorLabel: 'Cor:',
          allSameStyle: 'Todo o texto usa a mesma fonte e cor',
          noImages: 'Nenhuma imagem disponível.',
          noImage: 'Nenhuma imagem',
          priceTotal: 'Custo adicional total:',
          priceTotalAmount: 'Custo adicional total: +',
          charLimit: '/ caracteres',
          charWarning: 'Muitos caracteres',
          embroideryPreview: 'Visualização de bordado',
          stitchGenerating: '⏳ Gerando bordado…',
          laserGenerating: '⏳ Gerando gravação…',
          stitchReady: '✓ Visualização pronta',
          stitchError: '⚠ Visualização falhou',
          error: 'Erro:',
          unsupportedChar: 'Infelizmente, esta fonte de bordado não pode exibir o caractere "{char}". Tente outra fonte ou não use este caractere.',
          unsupportedCharLaser: 'Infelizmente, esta fonte de gravação não pode exibir o caractere "{char}". Tente outra fonte ou não use este caractere.',
          uppercaseLowercased: 'Esta fonte não tem letras maiúsculas – são bordadas em minúsculas.',
          s3Hint: 'Apenas fonte S3: digite um sublinhado "_" para adicionar um coração ao seu texto personalizado!',
          soldOut: 'Esgotado',
        },
      };
      return (map[lang] || map.de)[key] || map.de[key] || key;
    }

    // ── Font character mapping ────────────────────────────────────────────────

    _loadFontCharacterMap() {
      // Load font_character_map.json from assets
      const mapUrl = document.currentScript?.src.replace('customizer.js', 'font_character_map.json') ||
                     (typeof Shopify !== 'undefined' && Shopify.cdnHost
                       ? Shopify.cdnHost + '/font_character_map.json'
                       : '/cdn/shop/t/customizer/font_character_map.json');

      fetch(mapUrl)
        .then(r => r.json())
        .then(data => {
          // Convert font_character_map format to fontSupport format
          if (data.fonts) {
            Object.keys(data.fonts).forEach(fontName => {
              const fontData = data.fonts[fontName];
              const chars = fontData.characters || [];
              // Special hints for specific fonts
              const hints = {
                'S3': this._t('s3Hint')
              };

              this.fontSupport[fontName] = {
                supported: chars.join(''),
                characters: chars,
                fallbacks: this._getFallbackFonts(fontName),
                hint: hints[fontName]
              };
            });
          }
        })
        .catch(err => {
          console.warn('[Customizer] Could not load font character map:', err);
          // Fallback to S1-S3, S9 only
          this._setDefaultFontSupport();
        });
    }

    // Laser-Gegenstück: Zeichen der Laser-TTFs (laser_font_character_map.json,
    // gleiches Format, aus tools/gen_laser_font_character_map.py). Kein S3-Herz-
    // Hinweis – das "_"-Herz gibt es nur bei den Stick-Glyphen.
    _loadLaserFontCharacterMap() {
      const mapUrl = (window.__customizerLaserFontPreviews || {}).charMapUrl
        || document.currentScript?.src.replace('customizer.js', 'laser_font_character_map.json')
        || '/cdn/shop/t/customizer/laser_font_character_map.json';
      return fetch(mapUrl)
        .then(r => r.json())
        .then(data => {
          Object.keys(data.fonts || {}).forEach(fontName => {
            const chars = data.fonts[fontName].characters || [];
            this.laserFontSupport[fontName] = {
              supported: chars.join(''),
              characters: chars,
              fallbacks: this._getFallbackFonts(fontName),
            };
          });
        })
        .catch(err => console.warn('[Customizer] Could not load laser font character map:', err));
    }

    // Zeichendaten der Schrift für dieses Produkt: „nur Laser" → Laser-TTFs,
    // sonst (Stick oder gemischt) die Stickschriften.
    _fontSupportFor(fontName, rects) {
      return this._laserKontext(rects)
        ? (this.laserFontSupport || {})[fontName]
        : this.fontSupport[fontName];
    }

    _setDefaultFontSupport() {
      // Fallback when font_character_map.json is not available
      // This is a safe default until the file is deployed
      const defaults = {
        S1: {
          supported: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789.,!?;:\'"()- ',
          characters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ',', '!', '?', ';', ':', '\'', '"', '(', ')', '-', ' '],
          fallbacks: ['S2', 'S3', 'S9']
        },
        S2: {
          supported: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789.,!?;:\'"()- ',
          characters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ',', '!', '?', ';', ':', '\'', '"', '(', ')', '-', ' '],
          fallbacks: ['S1', 'S3', 'S9']
        },
        S3: {
          supported: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789.,!?;:\'"()- _',
          characters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ',', '!', '?', ';', ':', '\'', '"', '(', ')', '-', '_', ' '],
          fallbacks: ['S1', 'S2', 'S9'],
          hint: this._t('s3Hint')
        },
        S9: {
          supported: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789.,!?;:\'"()- ',
          characters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ',', '!', '?', ';', ':', '\'', '"', '(', ')', '-', ' '],
          fallbacks: ['S3', 'S1', 'S2']
        }
      };

      Object.keys(defaults).forEach(fontName => {
        this.fontSupport[fontName] = defaults[fontName];
      });
    }

    _getFallbackFonts(fontName) {
      // Suggest fallback fonts if current font lacks a character
      const fallbacks = {
        'S1': ['S2', 'S3', 'S9'],
        'S2': ['S1', 'S3', 'S9'],
        'S3': ['S9', 'S1', 'S2'],
        'S4': ['S9', 'S3'],
        'S5': ['S9', 'S3'],
        'S6': ['S9', 'S3'],
        'S7': ['S9', 'S3'],
        'S8': ['S9', 'S3'],
        'S9': ['S3', 'S1', 'S2'],
        'S10': ['S9', 'S3']
      };
      return fallbacks[fontName] || ['S9'];
    }

    // ── Font character validation ──────────────────────────────────────────────

    _checkFontSupport(fontName, text, rects) {
      const laser = this._laserKontext(rects);
      const fontData = this._fontSupportFor(fontName, rects);
      if (!fontData) return { supported: true, laser }; // Unknown font: assume all chars OK

      const unsupported = [];
      let lowercased = false;
      for (let char of text) {
        // Whitespace is always renderable (just a gap) — never flag spaces,
        // and pass the text through to the renderer with the space intact.
        if (char === ' ' || char.trim() === '') continue;
        if (fontData.supported.includes(char)) continue;
        // Exact glyph missing: if it's an uppercase letter whose lowercase form IS
        // available (e.g. S3 is lowercase-only), the renderer stitches the
        // lowercase glyph — that is a graceful substitution, not a failure.
        // Nicht beim Laser: die TTF zeichnet den Text, wie er ist.
        const lower = char.toLowerCase();
        if (!laser && lower !== char && fontData.supported.includes(lower)) {
          lowercased = true;
          continue;
        }
        unsupported.push(char);
      }

      if (unsupported.length === 0) {
        return { supported: true, lowercased: lowercased, laser };
      }

      return {
        supported: false,
        firstChar: unsupported[0],
        fallback: fontData.fallbacks && fontData.fallbacks[0] ? fontData.fallbacks[0] : 'S9',
        hint: fontData.hint,
        lowercased: lowercased,
        laser
      };
    }

    // ── Price summary ─────────────────────────────────────────────────────────

    _updatePriceDisplay() {
      // The summary lives in the modal FOOTER now (not inside controlsEl), so look
      // it up by id wherever it is.
      const el = document.getElementById('customizer-price-summary');
      if (!el) return;
      const total = this.options.reduce((sum, opt) => {
        const choice = this.optionChoices[opt.id];

        if (opt.type === 'giftbox' && choice) {
          // Giftbox: find the choice and get its price (supports per-choice pricing)
          const choiceObj = opt.choices?.find(c =>
            (typeof c === 'object' ? c.name : c) === choice
          );
          const price = typeof choiceObj === 'object' ? choiceObj.price : 0;
          return sum + price;
        } else if (choice === 'yes' && opt.price > 0) {
          // Yes/no option: add price if 'yes' is selected
          return sum + opt.price;
        }

        return sum;
      }, 0);
      const currency = (this.options.find(o => o.price > 0) || {}).currency || 'EUR';
      // setProperty('important') beats the CSS `display: block !important`.
      if (total > 0) {
        el.textContent = this._t('priceTotalAmount') + this._formatPrice(total, currency);
        el.style.setProperty('display', 'block', 'important');
      } else {
        el.textContent = '';
        el.style.setProperty('display', 'none', 'important');  // no empty box in footer
      }
    }

    // ── Preview modal styles (injected once) ──────────────────────────────────

    _injectPreviewStyles() {
      if (document.getElementById('cust-pv-styles')) return;
      const s = document.createElement('style');
      s.id = 'cust-pv-styles';
      s.textContent = `
        .cust-pv-overlay {
          position:fixed;inset:0;background:rgba(0,0,0,.72);
          display:flex;align-items:center;justify-content:center;
          z-index:2147483100;padding:24px;box-sizing:border-box;  /* über Dialog + ATC-Overlay */
        }
        .cust-pv-modal {
          background:#fff;border-radius:12px;overflow:hidden;
          max-width:100%;display:flex;flex-direction:column;
          box-shadow:0 8px 40px rgba(0,0,0,.45);
        }
        .cust-pv-header {
          display:flex;align-items:center;justify-content:space-between;
          padding:12px 16px;background:#1a1a1a;color:#fff;
          font-family:sans-serif;font-size:15px;font-weight:600;
        }
        .cust-pv-close {
          background:none;border:none;color:#fff;font-size:20px;
          cursor:pointer;line-height:1;padding:2px 6px;
        }
        .cust-pv-body { position:relative;min-width:320px;min-height:120px; }
        .cust-pv-canvas { display:block;max-width:100%; }
        .cust-pv-loading {
          display:flex;flex-direction:column;align-items:center;
          justify-content:center;padding:32px 24px;gap:16px;
          font-family:sans-serif;font-size:14px;color:#555;text-align:center;
        }
        .cust-pv-error {
          padding:20px 24px;color:#c00;font-family:sans-serif;font-size:14px;
        }
        .cust-pv-spinner {
          width:40px;height:40px;border:4px solid #eee;
          border-top-color:#555;border-radius:50%;
          animation:cust-spin .8s linear infinite;
        }
        @keyframes cust-spin { to { transform:rotate(360deg); } }
        .cust-pv-hint {
          margin:0;padding:8px 16px;
          font-family:sans-serif;font-size:12px;color:#888;
          background:#f8f8f8;border-top:1px solid #eee;
        }
        .customizer-option-free {
          color:#4caf50;font-size:12px;font-weight:500;
        }
        .customizer-price-summary {
          margin-top:12px;padding:10px 14px;
          background:#f0f7ff;border:1px solid #c8dff8;border-radius:6px;
          font-size:14px;font-weight:600;color:#1a4e8a;
        }
        .customizer-stitch-status {
          display:block;font-size:12px;margin-top:4px;min-height:16px;
          transition:color .2s;
        }
        .customizer-stitch-status.is-loading { color:#888; }
        .customizer-stitch-status.is-done    { color:#4caf50; }
        .customizer-stitch-status.is-error   { color:#c00; }
      `;
      document.head.appendChild(s);
    }

    // ── Color helper ──────────────────────────────────────────────────────────

    _shadeColor(hex, amount) {
      const base = (hex || '#000000').replace('#', '');
      const num  = parseInt(base.length === 3
        ? base.split('').map(c => c + c).join('')
        : base, 16);
      const r = Math.min(255, Math.max(0, (num >> 16) + amount));
      const g = Math.min(255, Math.max(0, ((num >> 8) & 0xFF) + amount));
      const b = Math.min(255, Math.max(0, (num & 0xFF) + amount));
      return '#' + [r, g, b].map(v => v.toString(16).padStart(2, '0')).join('');
    }

    _fitFontSize(text, font, maxW, maxH) {
      const ctx = this.ctx;
      let lo = 4, hi = Math.floor(maxH);
      while (lo < hi - 1) {
        const mid = Math.floor((lo + hi) / 2);
        ctx.font = `bold ${mid}px "${font}"`;
        if (ctx.measureText(text).width <= maxW && mid * 1.2 <= maxH) lo = mid;
        else hi = mid;
      }
      return lo;
    }

    // ── Image rendering ───────────────────────────────────────────────────────

    _renderImage(rect, val) {
      const cached = this._imageCache[val.imageUrl];
      if (cached) {
        this._drawContained(cached, rect);
      } else {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          this._imageCache[val.imageUrl] = img;
          this.render();
        };
        img.src = val.imageUrl;
      }
    }

    _drawContained(img, rect) {
      // EINE feste Referenz-Bounding-Box (Bruchteile 0..1), IDENTISCH für ALLE
      // Motive — so bleiben Größen im Preview untereinander vergleichbar und passen
      // zur echten Stickerei. Sie kommt aus dem Motiv-Sync (Union aller Motiv-
      // Alpha-Boxen → entfernt nur den künstlichen Rand, den KEIN Motiv nutzt;
      // einzelne kleinere Motive behalten dadurch bewusst ihren Rand). KEINE
      // Per-Motiv-Berechnung. Ohne Frame (noch nicht gesynct): volles Bild.
      const f = window.__customizerMotifFrame;
      const W = img.naturalWidth, H = img.naturalHeight;
      let sx = 0, sy = 0, sw = W, sh = H;
      if (f && f.w > 0 && f.h > 0) {
        sx = Math.max(0, f.x) * W;
        sy = Math.max(0, f.y) * H;
        sw = Math.min(1 - f.x, f.w) * W;
        sh = Math.min(1 - f.y, f.h) * H;
      }
      const imgAspect  = sw / sh;
      const rectAspect = rect.width / rect.height;
      let drawW, drawH;
      if (imgAspect > rectAspect) { drawW = rect.width;  drawH = rect.width / imgAspect; }
      else                        { drawH = rect.height; drawW = rect.height * imgAspect; }

      const cx  = rect.x + rect.width  / 2;
      const cy  = rect.y + rect.height / 2;
      const rot = ((rect.rotation || 0) * Math.PI) / 180;

      const ctx = this.ctx;
      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(rot);
      ctx.beginPath();
      ctx.rect(-rect.width / 2, -rect.height / 2, rect.width, rect.height);
      ctx.clip();
      ctx.drawImage(img, sx, sy, sw, sh, -drawW / 2, -drawH / 2, drawW, drawH);
      ctx.restore();
    }

    // ── Line-item properties ──────────────────────────────────────────────────

    updateLineItemProperties() {
      this.propertiesEl.innerHTML = '';

      // Regular rect values
      const textKeys = new Set();
      this.activeRects().forEach((rect, i) => {
        const val   = this.values[rect.id];
        if (!val) return;
        const label = rect.label || (rect.type === 'text' ? `Text ${i + 1}` : `Bild ${i + 1}`);

        if (rect.type === 'text' && val.text) {
          this._addHidden(`properties[${label}]`,          val.text);
          this._addHidden(`properties[${label} – Schrift]`, val.font);
          // Save the yarn colour NAME (e.g. "gold"), not the hex, so uos reads it.
          // Laser-Rechteck: keine Garnfarbe (Gravur hat keine).
          if (!this._isLaserRect(rect)) {
            this._addHidden(`properties[${label} – Farbe]`,  val.colorName || val.color);
          }
          textKeys.add(label);
        } else if (rect.type === 'image' && val.imageName) {
          this._addHidden(`properties[${label} – Motiv]`,      val.imageName);
        }
      });

      // Options with cost. Key-Kollision mit einem Textfeld → eigener Key,
      // sonst überschriebe die Antwort den Wunschtext (siehe _optionAnswerKey).
      this.options.forEach(opt => {
        const choice = this.optionChoices[opt.id];
        if (opt.type === 'giftbox') {
          if (choice) this._addHidden(`properties[${this._optionAnswerKey(opt.label, textKeys)}]`, choice);
        } else if (opt.price > 0) {
          const selected = choice === 'yes';
          this._addHidden(`properties[${this._optionAnswerKey(opt.label, textKeys)}]`, selected
            ? (opt.yesLabel || 'Ja')
            : (opt.noLabel  || 'Nein'));
          if (selected && opt.price > 0) {
            this._addHidden(`properties[${opt.label} – Preis]`, this._formatPrice(opt.price, opt.currency));
          }
        }
      });

      // Customer's configured preview image (uploaded to Shopify Files on confirm)
      if (this._previewUrl) {
        this._addHidden('properties[Vorschau]', this._previewUrl);
      }
    }

    _addHidden(name, value) {
      const inp = document.createElement('input');
      inp.type  = 'hidden';
      inp.name  = name;
      inp.value = value || '';
      this.propertiesEl.appendChild(inp);
    }

    // ── ATC form hook ─────────────────────────────────────────────────────────

    hookIntoAddToCart() {
      const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
      if (!forms.length) {
        console.warn('[Customizer] ATC form not found.');
        return;
      }
      this._atcForm = forms[0];
      this._atcButton = this._atcForm.querySelector(this._ATC_BTN_SEL);
      if (this.displayMode === 'modal') this._safe('watchAtcRelabel', () => this._watchAtcRelabel());
    }

    get _ATC_BTN_SEL() {
      // Horizon themes: <button type="submit" is="custom-button"> inside <buy-buttons>.
      return '[type="submit"], button[name="add"], .product-form__submit, .product-form__buttons button, buy-buttons button';
    }

    // Numeric product id of THIS product's form (e.g. "product-form-12345-..."),
    // so we only relabel the current customizer product — never related products.
    _productFormPid() {
      // NB: form.id is SHADOWED by the form's named control <input name="id">
      // (Impact has one), so this._atcForm.id returns that ELEMENT, not the id
      // string → .match crashes. Read the attribute directly.
      const el = this._atcForm;
      const id = (el && el.getAttribute && el.getAttribute('id')) || '';
      const m = String(id).match(/(\d{6,})/);
      return m ? m[1] : '';
    }

    // Relabel THIS product's Add-to-Cart button(s) (main + quick-buy/sticky) to the
    // "without personalization" text. Scoped by product id so other products on the
    // page are untouched. Writes only when different (avoids observer loops).
    // Returns how many ATC buttons were found.
    _relabelAtcButton() {
      if (this.displayMode !== 'modal') return 0;
      const label = this._t('atcWithoutPerso');
      const pid = this._productFormPid();
      // Only forms belonging to THIS product (id contains its product id).
      // NB: use getAttribute('id') — f.id is shadowed by <input name="id"> (Impact).
      const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
        .filter(f => {
          const fid = (f.getAttribute && f.getAttribute('id')) || '';
          return !pid || String(fid).indexOf(pid) !== -1;
        });
      const seen = new Set();
      const buttons = [];
      forms.forEach(f => { const b = f.querySelector(this._ATC_BTN_SEL); if (b && !seen.has(b)) { seen.add(b); buttons.push(b); } });
      buttons.forEach(btn => {
        // Where the VISIBLE label lives, most-specific first:
        //  • Impact/Impulse <button is="custom-button"> hydrates into TWO wrapper
        //    DIVs — contentElement (the visible label = firstElementChild) and an
        //    animationElement (may contain stray spans). So for custom-button we
        //    MUST target firstElementChild (not a querySelector('span') that could
        //    hit the invisible animation span). The theme itself writes
        //    firstElementChild.innerHTML on variant change, so this stays in sync.
        //  • Other themes: a text <span>. • Fallback: firstElementChild / button.
        const isCustom = btn.getAttribute('is') === 'custom-button';
        const target =
          (isCustom && btn.firstElementChild) ||
          btn.querySelector('span:not([class*="icon"]):not([class*="Icon"])') ||
          btn.firstElementChild ||
          btn;
        if ((target.textContent || '').trim() !== label) target.textContent = label;
      });
      return buttons.length;
    }

    // Install ONE throttled document-level observer so the label survives whatever
    // the theme does (late init, variant change, node replacement, sticky bar).
    _watchAtcRelabel() {
      if (this._atcWatchInstalled) return;
      this._atcWatchInstalled = true;
      const n = this._relabelAtcButton();
      console.log('[Customizer] ATC relabel active — %d button(s) found, mode=%s', n, this.displayMode);
      // A few explicit re-applies for very late theme initialization.
      [150, 500, 1200, 2500].forEach(d => setTimeout(() => this._relabelAtcButton(), d));
      try {
        let scheduled = false;
        const obs = new MutationObserver(() => {
          if (scheduled) return;
          scheduled = true;
          setTimeout(() => { scheduled = false; this._relabelAtcButton(); }, 300);
        });
        obs.observe(document.body, { childList: true, subtree: true, characterData: true });
        this._atcRelabelObserver = obs;
      } catch (e) { /* observer unsupported — explicit re-applies above still run */ }
    }
  }

  // ── Boot ───────────────────────────────────────────────────────────────────

  function boot() {
    const wrapper = document.getElementById('customizer-wrapper');
    if (!wrapper) return;

    // Move the konfigurator out of the product-info sidebar (safe-sticky column 2)
    // and place it directly after the .product grid element.
    const productGrid = document.querySelector('.product');
    if (productGrid && productGrid.parentNode) {
      productGrid.parentNode.insertBefore(wrapper, productGrid.nextSibling);

      // Match width to the gallery column and pull up by the height difference
      // so the konfigurator sits flush below the gallery, not below the sidebar.
      const gallery = productGrid.querySelector('.product-gallery, [class*="product-gallery"]');
      if (gallery) {
        const adjust = () => {
          const gRect = gallery.getBoundingClientRect();
          const pRect = productGrid.getBoundingClientRect();
          const w = gRect.width;
          const gap = pRect.bottom - gRect.bottom; // how much taller the right column is
          if (w > 0) wrapper.style.width = w + 'px';
          wrapper.style.marginTop = gap > 0 ? (-gap + 24) + 'px' : '24px';
        };
        // Run after layout is complete
        requestAnimationFrame(() => { adjust(); });
        window.addEventListener('resize', adjust);
      }
    }

    window.customizerInstance = new Customizer(wrapper);
  }

  // ── TEST MODAL (for debugging layout) ──────────────────────────────────────

  // Hängt Backdrop + Dialog EINMALIG direkt unter <body>.
  // Grund: Das Snippet wird MITTEN im Produkt-Markup gerendert (Impact 4.3.3:
  // <safe-sticky class="product-info">), und position:sticky erzeugt einen eigenen
  // Stacking-Context. Darin ist jeder z-index — auch 99999 — auf diese Spalte
  // begrenzt, also malte der Sticky-Header (Seiten-Menü) über den Dialog. Am <body>
  // konkurriert der Dialog im Root-Context und liegt zuverlässig obenauf (gleiches
  // Prinzip wie beim ATC-Overlay, das schon immer an body hängt).
  // appendChild VERSCHIEBT den Knoten (kein Neuaufbau) → Event-Listener und der
  // gezeichnete Canvas-Inhalt bleiben erhalten. Backdrop zuerst, damit der Dialog
  // auch in Dokumentreihenfolge darüber liegt.
  function portalModalToBody() {
    ['test-modal-backdrop', 'test-modal-dialog'].forEach((id) => {
      const el = document.getElementById(id);
      if (el && el.parentElement !== document.body) document.body.appendChild(el);
    });
  }

  function setupTestModal() {
    const testBtn = document.getElementById('test-modal-btn');
    const testBackdrop = document.getElementById('test-modal-backdrop');
    const testDialog = document.getElementById('test-modal-dialog');
    const testCloseBtn = testDialog ? testDialog.querySelector('.test-modal-close') : null;
    const testHeading = testDialog ? testDialog.querySelector('.test-modal-heading') : null;

    if (!testBtn || !testBackdrop || !testDialog) return;

    portalModalToBody();

    function closeModal() {
      testBackdrop.classList.remove('is-open');
      testDialog.classList.remove('is-open');
    }

    // Open test modal
    testBtn.addEventListener('click', (e) => {
      e.preventDefault();
      testBackdrop.classList.add('is-open');
      testDialog.classList.add('is-open');
    });

    // Close test modal — button only
    if (testCloseBtn) {
      testCloseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    }

    // Make modal draggable from heading
    if (testHeading) {
      let isDragging = false;
      let dragStartX = 0;
      let dragStartY = 0;
      let modalStartX = 0;
      let modalStartY = 0;

      testHeading.style.cursor = 'grab';
      testHeading.addEventListener('mousedown', (e) => {
        // Don't drag if clicking the close button
        if (e.target === testCloseBtn || testCloseBtn?.contains(e.target)) return;

        isDragging = true;
        dragStartX = e.clientX;
        dragStartY = e.clientY;
        const rect = testDialog.getBoundingClientRect();
        modalStartX = rect.left;
        modalStartY = rect.top;
        testHeading.style.cursor = 'grabbing';
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const deltaX = e.clientX - dragStartX;
        const deltaY = e.clientY - dragStartY;
        const newX = modalStartX + deltaX;
        const newY = modalStartY + deltaY;
        testDialog.style.left = newX + 'px';
        testDialog.style.top = newY + 'px';
        testDialog.style.transform = 'none';
      });

      document.addEventListener('mouseup', () => {
        isDragging = false;
        testHeading.style.cursor = 'grab';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('DOMContentLoaded', setupTestModal);
  } else {
    boot();
    setupTestModal();
  }

})();
